(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var _memoize = require('../src/memoize');
var wrapper = require('../src/promise-translator');

function memoize(getKey) {
  return _memoize(wrapper, getKey);
}

module.exports = memoize;

},{"../src/memoize":3,"../src/promise-translator":4}],2:[function(require,module,exports){
var _retry = require('../src/retry');
var wrapper = require('../src/promise-translator');

function retry(times, interval, error) {
  return _retry(wrapper, times, interval, error);
}

module.exports = retry;

},{"../src/promise-translator":4,"../src/retry":5}],3:[function(require,module,exports){
var defaultLogger = require('../utils/default-logger');
var keyGetter = require('memoize-cache-utils/key-getter');

function memoizeDecorator(wrapper, getKey) {
  getKey = keyGetter(getKey || function () { return '_default'; });
  return wrapper(function (func) {
    var cache = {};
    return function () {
      var context = this;
      var args = Array.prototype.slice.call(arguments, 0);
      var logger = defaultLogger.apply(context);
      var cb = args[args.length - 1];
      var cacheKey = getKey.apply(context, args);
      args[args.length - 1] = function (err, dep) {
        if (!err && cacheKey !== null) {
          cache[cacheKey] = dep;
        }
        cb(err, dep);
      };
      if (cacheKey !== null && cacheKey in cache) {
        logger('memoize-hit', {key: cacheKey, result: cache[cacheKey]});
        return cb(null, cache[cacheKey]);
      }
      else {
        func.apply(context, args);
      }
    };
  });
}

module.exports = memoizeDecorator;

},{"../utils/default-logger":7,"memoize-cache-utils/key-getter":136}],4:[function(require,module,exports){
var promisify = require('es6-promisify');
var callbackify = require('../utils/callbackify');

// it works for decorator(f) and decorator([f1, f2, f3 ...])

function promiseTranslator(decorator) {
  return function (f) { // f returns a promise
    var cb;
    if (Array.isArray(f)) {
      cb = f.map(callbackify);
    } else {
      cb = callbackify(f);
    }

    return promisify(decorator(cb));
  };
}

module.exports = promiseTranslator;

},{"../utils/callbackify":6,"es6-promisify":133}],5:[function(require,module,exports){
var defaultLogger = require('../utils/default-logger');

function retryDecorator(wrapper, times, interval, error) {
  var condition;
  times = times || Infinity;
  error = error || Error;
  interval = interval || 0;
  var intervalFunc = typeof interval === 'function' ?
    interval :
    function () { return interval; };

  if (error === Error || Error.isPrototypeOf(error)) {
    condition = function (err, dep) { return err instanceof error; };
  }
  else {
    condition = error;
  }

  return wrapper(function (func) {
    return function () {
      var counter = 0;
      var context = this;
      var args = Array.prototype.slice.call(arguments, 0);
      var logger = defaultLogger.apply(context);
      var cb = args[args.length - 1];

      var retry = function () {
        if (counter++ && intervalFunc(counter) > 0) { // do not wait for counter === 0
          setTimeout(function () {
            func.apply(context, args);
          }, interval);
        }
        else {
          func.apply(context, args);
        }
      };

      args[args.length - 1] = function (err, dep) {
        if (condition(err, dep) && counter < times) {
          logger('retry', {
            times: counter,
            actualResult: {err: err, res: dep}
          });
          retry();
        }
        else {
          cb(err, dep);
        }
      };
      retry();
    };
  });
}

module.exports = retryDecorator;

},{"../utils/default-logger":7}],6:[function(require,module,exports){
function isPromise(obj) {
  return typeof obj === 'object' && 'then' in obj;
}

function callbackify(func) {
  return function () {
    // get arguments
    var context = this;
    var args = Array.prototype.slice.call(arguments, 0, -1);
    var cb = arguments[arguments.length - 1];
    try {
      var output = func.apply(context, args);
    }
    catch (e) {
      return cb(e);
    }

    if (isPromise(output)) {
      output.then(function (res) { // onfulfilled
        cb(null, res);
      },
      function (error) { // onrejected
        cb(error);
      });
    }
    else {
      cb(null, output);
    }
  };
}

module.exports = callbackify;

},{}],7:[function(require,module,exports){
module.exports = function () {
  if (typeof this === 'object' && '__log' in this) {
    return this.__log;
  }
  return function () {};
};

},{}],8:[function(require,module,exports){
(function (w, cb){

  var queue = this._async_define_queue = '_async_define_queue' in this ? this._async_define_queue : [];
  var cached_dependencies = this._async_define_cached_dependencies = '_async_define_cached_dependencies' in this ? this._async_define_cached_dependencies : {};

  function getDepsArray(depNames) {
    var i,
      len = depNames.length,
      deps = [];
    for (i = 0; i < len; i++){
      if (depNames[i] in cached_dependencies){
        deps.push(cached_dependencies[depNames[i]]);
      }
      else {
        return;
      }
    }
    return deps;
  }

  function runThroughQueue() {
    while (_runThroughQueue());
  }

  function _runThroughQueue() {
    var i = 0;
    var solvedDependency = false;
    while (i < queue.length){
      if (execute(queue[i])){
        if (queue[i].name){
          solvedDependency = true;
        }
        queue.splice(i, 1);
      }
      else {
        i++;
      }
    }
    return solvedDependency;
  }

  function execute (item){
    if (item.name in cached_dependencies) { // don't execute twice
      return true;
    }
    var deps = getDepsArray(item.depNames);
    var exp;
    if (deps){
      exp = item.func.apply(w, deps);
      if (item.name){
        cached_dependencies[item.name] = exp;
      }
      return true;
    }
    else {
      return;
    }
  }

  function wrapObj (o){
    if (typeof o === 'function'){
      return o;
    }
    else {
      return function (){
        return o;
      };
    }
  }

  function ad() {
    var item = {
        name:  typeof arguments[0] === 'string' ? arguments[0] : undefined,
        depNames: Array.isArray(arguments[0]) ? arguments[0] : Array.isArray(arguments[1]) ? arguments[1] : [],
        func: wrapObj(arguments[arguments.length - 1])
    };
    if (!execute(item)){
      queue.push(item);
    }
    else {
      if (item.name){
        runThroughQueue(); // executed straight away, try to resolve func that depends on this
      }
    }
  }
  cb.call(w, ad);
}(this, function (asyncDefine) {
  if (typeof exports === 'object'){
  module.exports = asyncDefine;
}
else{
  w.asyncDefine = asyncDefine;
}

}));


},{}],9:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };
},{"core-js/library/fn/get-iterator":29}],10:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };
},{"core-js/library/fn/is-iterable":30}],11:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };
},{"core-js/library/fn/json/stringify":31}],12:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };
},{"core-js/library/fn/object/assign":32}],13:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };
},{"core-js/library/fn/object/create":33}],14:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };
},{"core-js/library/fn/object/define-property":34}],15:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };
},{"core-js/library/fn/object/get-prototype-of":35}],16:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/keys"), __esModule: true };
},{"core-js/library/fn/object/keys":36}],17:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };
},{"core-js/library/fn/object/set-prototype-of":37}],18:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };
},{"core-js/library/fn/promise":38}],19:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };
},{"core-js/library/fn/symbol":39}],20:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };
},{"core-js/library/fn/symbol/iterator":40}],21:[function(require,module,exports){
"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
},{}],22:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _defineProperty = require("../core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
},{"../core-js/object/define-property":14}],23:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _setPrototypeOf = require("../core-js/object/set-prototype-of");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = require("../core-js/object/create");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = require("../helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};
},{"../core-js/object/create":13,"../core-js/object/set-prototype-of":17,"../helpers/typeof":26}],24:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _typeof2 = require("../helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};
},{"../helpers/typeof":26}],25:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _isIterable2 = require("../core-js/is-iterable");

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = require("../core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
},{"../core-js/get-iterator":9,"../core-js/is-iterable":10}],26:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _iterator = require("../core-js/symbol/iterator");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require("../core-js/symbol");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
},{"../core-js/symbol":19,"../core-js/symbol/iterator":20}],27:[function(require,module,exports){
module.exports = require("regenerator-runtime");

},{"regenerator-runtime":152}],28:[function(require,module,exports){

},{}],29:[function(require,module,exports){
require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');
},{"../modules/core.get-iterator":113,"../modules/es6.string.iterator":124,"../modules/web.dom.iterable":128}],30:[function(require,module,exports){
require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');
},{"../modules/core.is-iterable":114,"../modules/es6.string.iterator":124,"../modules/web.dom.iterable":128}],31:[function(require,module,exports){
var core  = require('../../modules/_core')
  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};
},{"../../modules/_core":48}],32:[function(require,module,exports){
require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;
},{"../../modules/_core":48,"../../modules/es6.object.assign":116}],33:[function(require,module,exports){
require('../../modules/es6.object.create');
var $Object = require('../../modules/_core').Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};
},{"../../modules/_core":48,"../../modules/es6.object.create":117}],34:[function(require,module,exports){
require('../../modules/es6.object.define-property');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};
},{"../../modules/_core":48,"../../modules/es6.object.define-property":118}],35:[function(require,module,exports){
require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;
},{"../../modules/_core":48,"../../modules/es6.object.get-prototype-of":119}],36:[function(require,module,exports){
require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;
},{"../../modules/_core":48,"../../modules/es6.object.keys":120}],37:[function(require,module,exports){
require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;
},{"../../modules/_core":48,"../../modules/es6.object.set-prototype-of":121}],38:[function(require,module,exports){
require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.promise');
module.exports = require('../modules/_core').Promise;
},{"../modules/_core":48,"../modules/es6.object.to-string":122,"../modules/es6.promise":123,"../modules/es6.string.iterator":124,"../modules/web.dom.iterable":128}],39:[function(require,module,exports){
require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
require('../../modules/es7.symbol.async-iterator');
require('../../modules/es7.symbol.observable');
module.exports = require('../../modules/_core').Symbol;
},{"../../modules/_core":48,"../../modules/es6.object.to-string":122,"../../modules/es6.symbol":125,"../../modules/es7.symbol.async-iterator":126,"../../modules/es7.symbol.observable":127}],40:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');
},{"../../modules/_wks-ext":110,"../../modules/es6.string.iterator":124,"../../modules/web.dom.iterable":128}],41:[function(require,module,exports){
module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};
},{}],42:[function(require,module,exports){
module.exports = function(){ /* empty */ };
},{}],43:[function(require,module,exports){
module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};
},{}],44:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};
},{"./_is-object":67}],45:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject')
  , toLength  = require('./_to-length')
  , toIndex   = require('./_to-index');
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};
},{"./_to-index":102,"./_to-iobject":104,"./_to-length":105}],46:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof')
  , TAG = require('./_wks')('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};
},{"./_cof":47,"./_wks":111}],47:[function(require,module,exports){
var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};
},{}],48:[function(require,module,exports){
var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef
},{}],49:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};
},{"./_a-function":41}],50:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};
},{}],51:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});
},{"./_fails":56}],52:[function(require,module,exports){
var isObject = require('./_is-object')
  , document = require('./_global').document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};
},{"./_global":58,"./_is-object":67}],53:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');
},{}],54:[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys')
  , gOPS    = require('./_object-gops')
  , pIE     = require('./_object-pie');
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};
},{"./_object-gops":85,"./_object-keys":88,"./_object-pie":89}],55:[function(require,module,exports){
var global    = require('./_global')
  , core      = require('./_core')
  , ctx       = require('./_ctx')
  , hide      = require('./_hide')
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;
},{"./_core":48,"./_ctx":49,"./_global":58,"./_hide":60}],56:[function(require,module,exports){
module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};
},{}],57:[function(require,module,exports){
var ctx         = require('./_ctx')
  , call        = require('./_iter-call')
  , isArrayIter = require('./_is-array-iter')
  , anObject    = require('./_an-object')
  , toLength    = require('./_to-length')
  , getIterFn   = require('./core.get-iterator-method')
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;
},{"./_an-object":44,"./_ctx":49,"./_is-array-iter":65,"./_iter-call":68,"./_to-length":105,"./core.get-iterator-method":112}],58:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef
},{}],59:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};
},{}],60:[function(require,module,exports){
var dP         = require('./_object-dp')
  , createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};
},{"./_descriptors":51,"./_object-dp":80,"./_property-desc":91}],61:[function(require,module,exports){
module.exports = require('./_global').document && document.documentElement;
},{"./_global":58}],62:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function(){
  return Object.defineProperty(require('./_dom-create')('div'), 'a', {get: function(){ return 7; }}).a != 7;
});
},{"./_descriptors":51,"./_dom-create":52,"./_fails":56}],63:[function(require,module,exports){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};
},{}],64:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};
},{"./_cof":47}],65:[function(require,module,exports){
// check on default Array iterator
var Iterators  = require('./_iterators')
  , ITERATOR   = require('./_wks')('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};
},{"./_iterators":73,"./_wks":111}],66:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};
},{"./_cof":47}],67:[function(require,module,exports){
module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};
},{}],68:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};
},{"./_an-object":44}],69:[function(require,module,exports){
'use strict';
var create         = require('./_object-create')
  , descriptor     = require('./_property-desc')
  , setToStringTag = require('./_set-to-string-tag')
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};
},{"./_hide":60,"./_object-create":79,"./_property-desc":91,"./_set-to-string-tag":96,"./_wks":111}],70:[function(require,module,exports){
'use strict';
var LIBRARY        = require('./_library')
  , $export        = require('./_export')
  , redefine       = require('./_redefine')
  , hide           = require('./_hide')
  , has            = require('./_has')
  , Iterators      = require('./_iterators')
  , $iterCreate    = require('./_iter-create')
  , setToStringTag = require('./_set-to-string-tag')
  , getPrototypeOf = require('./_object-gpo')
  , ITERATOR       = require('./_wks')('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};
},{"./_export":55,"./_has":59,"./_hide":60,"./_iter-create":69,"./_iterators":73,"./_library":75,"./_object-gpo":86,"./_redefine":93,"./_set-to-string-tag":96,"./_wks":111}],71:[function(require,module,exports){
var ITERATOR     = require('./_wks')('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};
},{"./_wks":111}],72:[function(require,module,exports){
module.exports = function(done, value){
  return {value: value, done: !!done};
};
},{}],73:[function(require,module,exports){
module.exports = {};
},{}],74:[function(require,module,exports){
var getKeys   = require('./_object-keys')
  , toIObject = require('./_to-iobject');
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};
},{"./_object-keys":88,"./_to-iobject":104}],75:[function(require,module,exports){
module.exports = true;
},{}],76:[function(require,module,exports){
var META     = require('./_uid')('meta')
  , isObject = require('./_is-object')
  , has      = require('./_has')
  , setDesc  = require('./_object-dp').f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !require('./_fails')(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};
},{"./_fails":56,"./_has":59,"./_is-object":67,"./_object-dp":80,"./_uid":108}],77:[function(require,module,exports){
var global    = require('./_global')
  , macrotask = require('./_task').set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = require('./_cof')(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};
},{"./_cof":47,"./_global":58,"./_task":101}],78:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = require('./_object-keys')
  , gOPS     = require('./_object-gops')
  , pIE      = require('./_object-pie')
  , toObject = require('./_to-object')
  , IObject  = require('./_iobject')
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;
},{"./_fails":56,"./_iobject":64,"./_object-gops":85,"./_object-keys":88,"./_object-pie":89,"./_to-object":106}],79:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = require('./_an-object')
  , dPs         = require('./_object-dps')
  , enumBugKeys = require('./_enum-bug-keys')
  , IE_PROTO    = require('./_shared-key')('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":44,"./_dom-create":52,"./_enum-bug-keys":53,"./_html":61,"./_object-dps":81,"./_shared-key":97}],80:[function(require,module,exports){
var anObject       = require('./_an-object')
  , IE8_DOM_DEFINE = require('./_ie8-dom-define')
  , toPrimitive    = require('./_to-primitive')
  , dP             = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};
},{"./_an-object":44,"./_descriptors":51,"./_ie8-dom-define":62,"./_to-primitive":107}],81:[function(require,module,exports){
var dP       = require('./_object-dp')
  , anObject = require('./_an-object')
  , getKeys  = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};
},{"./_an-object":44,"./_descriptors":51,"./_object-dp":80,"./_object-keys":88}],82:[function(require,module,exports){
var pIE            = require('./_object-pie')
  , createDesc     = require('./_property-desc')
  , toIObject      = require('./_to-iobject')
  , toPrimitive    = require('./_to-primitive')
  , has            = require('./_has')
  , IE8_DOM_DEFINE = require('./_ie8-dom-define')
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};
},{"./_descriptors":51,"./_has":59,"./_ie8-dom-define":62,"./_object-pie":89,"./_property-desc":91,"./_to-iobject":104,"./_to-primitive":107}],83:[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject')
  , gOPN      = require('./_object-gopn').f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":84,"./_to-iobject":104}],84:[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = require('./_object-keys-internal')
  , hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};
},{"./_enum-bug-keys":53,"./_object-keys-internal":87}],85:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;
},{}],86:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = require('./_has')
  , toObject    = require('./_to-object')
  , IE_PROTO    = require('./_shared-key')('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};
},{"./_has":59,"./_shared-key":97,"./_to-object":106}],87:[function(require,module,exports){
var has          = require('./_has')
  , toIObject    = require('./_to-iobject')
  , arrayIndexOf = require('./_array-includes')(false)
  , IE_PROTO     = require('./_shared-key')('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};
},{"./_array-includes":45,"./_has":59,"./_shared-key":97,"./_to-iobject":104}],88:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = require('./_object-keys-internal')
  , enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};
},{"./_enum-bug-keys":53,"./_object-keys-internal":87}],89:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;
},{}],90:[function(require,module,exports){
// most Object methods by ES6 should accept primitives
var $export = require('./_export')
  , core    = require('./_core')
  , fails   = require('./_fails');
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};
},{"./_core":48,"./_export":55,"./_fails":56}],91:[function(require,module,exports){
module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};
},{}],92:[function(require,module,exports){
var hide = require('./_hide');
module.exports = function(target, src, safe){
  for(var key in src){
    if(safe && target[key])target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};
},{"./_hide":60}],93:[function(require,module,exports){
module.exports = require('./_hide');
},{"./_hide":60}],94:[function(require,module,exports){
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = require('./_is-object')
  , anObject = require('./_an-object');
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = require('./_ctx')(Function.call, require('./_object-gopd').f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};
},{"./_an-object":44,"./_ctx":49,"./_is-object":67,"./_object-gopd":82}],95:[function(require,module,exports){
'use strict';
var global      = require('./_global')
  , core        = require('./_core')
  , dP          = require('./_object-dp')
  , DESCRIPTORS = require('./_descriptors')
  , SPECIES     = require('./_wks')('species');

module.exports = function(KEY){
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};
},{"./_core":48,"./_descriptors":51,"./_global":58,"./_object-dp":80,"./_wks":111}],96:[function(require,module,exports){
var def = require('./_object-dp').f
  , has = require('./_has')
  , TAG = require('./_wks')('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};
},{"./_has":59,"./_object-dp":80,"./_wks":111}],97:[function(require,module,exports){
var shared = require('./_shared')('keys')
  , uid    = require('./_uid');
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};
},{"./_shared":98,"./_uid":108}],98:[function(require,module,exports){
var global = require('./_global')
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};
},{"./_global":58}],99:[function(require,module,exports){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = require('./_an-object')
  , aFunction = require('./_a-function')
  , SPECIES   = require('./_wks')('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};
},{"./_a-function":41,"./_an-object":44,"./_wks":111}],100:[function(require,module,exports){
var toInteger = require('./_to-integer')
  , defined   = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};
},{"./_defined":50,"./_to-integer":103}],101:[function(require,module,exports){
var ctx                = require('./_ctx')
  , invoke             = require('./_invoke')
  , html               = require('./_html')
  , cel                = require('./_dom-create')
  , global             = require('./_global')
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(require('./_cof')(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};
},{"./_cof":47,"./_ctx":49,"./_dom-create":52,"./_global":58,"./_html":61,"./_invoke":63}],102:[function(require,module,exports){
var toInteger = require('./_to-integer')
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};
},{"./_to-integer":103}],103:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};
},{}],104:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject')
  , defined = require('./_defined');
module.exports = function(it){
  return IObject(defined(it));
};
},{"./_defined":50,"./_iobject":64}],105:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer')
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};
},{"./_to-integer":103}],106:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function(it){
  return Object(defined(it));
};
},{"./_defined":50}],107:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};
},{"./_is-object":67}],108:[function(require,module,exports){
var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};
},{}],109:[function(require,module,exports){
var global         = require('./_global')
  , core           = require('./_core')
  , LIBRARY        = require('./_library')
  , wksExt         = require('./_wks-ext')
  , defineProperty = require('./_object-dp').f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};
},{"./_core":48,"./_global":58,"./_library":75,"./_object-dp":80,"./_wks-ext":110}],110:[function(require,module,exports){
exports.f = require('./_wks');
},{"./_wks":111}],111:[function(require,module,exports){
var store      = require('./_shared')('wks')
  , uid        = require('./_uid')
  , Symbol     = require('./_global').Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;
},{"./_global":58,"./_shared":98,"./_uid":108}],112:[function(require,module,exports){
var classof   = require('./_classof')
  , ITERATOR  = require('./_wks')('iterator')
  , Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};
},{"./_classof":46,"./_core":48,"./_iterators":73,"./_wks":111}],113:[function(require,module,exports){
var anObject = require('./_an-object')
  , get      = require('./core.get-iterator-method');
module.exports = require('./_core').getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};
},{"./_an-object":44,"./_core":48,"./core.get-iterator-method":112}],114:[function(require,module,exports){
var classof   = require('./_classof')
  , ITERATOR  = require('./_wks')('iterator')
  , Iterators = require('./_iterators');
module.exports = require('./_core').isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};
},{"./_classof":46,"./_core":48,"./_iterators":73,"./_wks":111}],115:[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables')
  , step             = require('./_iter-step')
  , Iterators        = require('./_iterators')
  , toIObject        = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');
},{"./_add-to-unscopables":42,"./_iter-define":70,"./_iter-step":72,"./_iterators":73,"./_to-iobject":104}],116:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', {assign: require('./_object-assign')});
},{"./_export":55,"./_object-assign":78}],117:[function(require,module,exports){
var $export = require('./_export')
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: require('./_object-create')});
},{"./_export":55,"./_object-create":79}],118:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', {defineProperty: require('./_object-dp').f});
},{"./_descriptors":51,"./_export":55,"./_object-dp":80}],119:[function(require,module,exports){
// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = require('./_to-object')
  , $getPrototypeOf = require('./_object-gpo');

require('./_object-sap')('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});
},{"./_object-gpo":86,"./_object-sap":90,"./_to-object":106}],120:[function(require,module,exports){
// 19.1.2.14 Object.keys(O)
var toObject = require('./_to-object')
  , $keys    = require('./_object-keys');

require('./_object-sap')('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});
},{"./_object-keys":88,"./_object-sap":90,"./_to-object":106}],121:[function(require,module,exports){
// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require('./_export');
$export($export.S, 'Object', {setPrototypeOf: require('./_set-proto').set});
},{"./_export":55,"./_set-proto":94}],122:[function(require,module,exports){
arguments[4][28][0].apply(exports,arguments)
},{"dup":28}],123:[function(require,module,exports){
'use strict';
var LIBRARY            = require('./_library')
  , global             = require('./_global')
  , ctx                = require('./_ctx')
  , classof            = require('./_classof')
  , $export            = require('./_export')
  , isObject           = require('./_is-object')
  , aFunction          = require('./_a-function')
  , anInstance         = require('./_an-instance')
  , forOf              = require('./_for-of')
  , speciesConstructor = require('./_species-constructor')
  , task               = require('./_task').set
  , microtask          = require('./_microtask')()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[require('./_wks')('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = require('./_redefine-all')($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
require('./_set-to-string-tag')($Promise, PROMISE);
require('./_set-species')(PROMISE);
Wrapper = require('./_core')[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && require('./_iter-detect')(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});
},{"./_a-function":41,"./_an-instance":43,"./_classof":46,"./_core":48,"./_ctx":49,"./_export":55,"./_for-of":57,"./_global":58,"./_is-object":67,"./_iter-detect":71,"./_library":75,"./_microtask":77,"./_redefine-all":92,"./_set-species":95,"./_set-to-string-tag":96,"./_species-constructor":99,"./_task":101,"./_wks":111}],124:[function(require,module,exports){
'use strict';
var $at  = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});
},{"./_iter-define":70,"./_string-at":100}],125:[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global         = require('./_global')
  , has            = require('./_has')
  , DESCRIPTORS    = require('./_descriptors')
  , $export        = require('./_export')
  , redefine       = require('./_redefine')
  , META           = require('./_meta').KEY
  , $fails         = require('./_fails')
  , shared         = require('./_shared')
  , setToStringTag = require('./_set-to-string-tag')
  , uid            = require('./_uid')
  , wks            = require('./_wks')
  , wksExt         = require('./_wks-ext')
  , wksDefine      = require('./_wks-define')
  , keyOf          = require('./_keyof')
  , enumKeys       = require('./_enum-keys')
  , isArray        = require('./_is-array')
  , anObject       = require('./_an-object')
  , toIObject      = require('./_to-iobject')
  , toPrimitive    = require('./_to-primitive')
  , createDesc     = require('./_property-desc')
  , _create        = require('./_object-create')
  , gOPNExt        = require('./_object-gopn-ext')
  , $GOPD          = require('./_object-gopd')
  , $DP            = require('./_object-dp')
  , $keys          = require('./_object-keys')
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f  = $propertyIsEnumerable;
  require('./_object-gops').f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !require('./_library')){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);
},{"./_an-object":44,"./_descriptors":51,"./_enum-keys":54,"./_export":55,"./_fails":56,"./_global":58,"./_has":59,"./_hide":60,"./_is-array":66,"./_keyof":74,"./_library":75,"./_meta":76,"./_object-create":79,"./_object-dp":80,"./_object-gopd":82,"./_object-gopn":84,"./_object-gopn-ext":83,"./_object-gops":85,"./_object-keys":88,"./_object-pie":89,"./_property-desc":91,"./_redefine":93,"./_set-to-string-tag":96,"./_shared":98,"./_to-iobject":104,"./_to-primitive":107,"./_uid":108,"./_wks":111,"./_wks-define":109,"./_wks-ext":110}],126:[function(require,module,exports){
require('./_wks-define')('asyncIterator');
},{"./_wks-define":109}],127:[function(require,module,exports){
require('./_wks-define')('observable');
},{"./_wks-define":109}],128:[function(require,module,exports){
require('./es6.array.iterator');
var global        = require('./_global')
  , hide          = require('./_hide')
  , Iterators     = require('./_iterators')
  , TO_STRING_TAG = require('./_wks')('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}
},{"./_global":58,"./_hide":60,"./_iterators":73,"./_wks":111,"./es6.array.iterator":115}],129:[function(require,module,exports){
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */

'use strict';

function assign(target, firstSource) {
  if (target === undefined || target === null) {
    throw new TypeError('Cannot convert first argument to object');
  }

  var to = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var nextSource = arguments[i];
    if (nextSource === undefined || nextSource === null) {
      continue;
    }

    var keysArray = Object.keys(Object(nextSource));
    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
      var nextKey = keysArray[nextIndex];
      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
      if (desc !== undefined && desc.enumerable) {
        to[nextKey] = nextSource[nextKey];
      }
    }
  }
  return to;
}

function polyfill() {
  if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: assign
    });
  }
}

module.exports = {
  assign: assign,
  polyfill: polyfill
};

},{}],130:[function(require,module,exports){
(function (global){
(function(global){

//
// Check for native Promise and it has correct interface
//

var NativePromise = global['Promise'];
var nativePromiseSupported =
  NativePromise &&
  // Some of these methods are missing from
  // Firefox/Chrome experimental implementations
  'resolve' in NativePromise &&
  'reject' in NativePromise &&
  'all' in NativePromise &&
  'race' in NativePromise &&
  // Older version of the spec had a resolver object
  // as the arg rather than a function
  (function(){
    var resolve;
    new NativePromise(function(r){ resolve = r; });
    return typeof resolve === 'function';
  })();


//
// export if necessary
//

if (typeof exports !== 'undefined' && exports)
{
  // node.js
  exports.Promise = nativePromiseSupported ? NativePromise : Promise;
  exports.Polyfill = Promise;
}
else
{
  // AMD
  if (typeof define == 'function' && define.amd)
  {
    define(function(){
      return nativePromiseSupported ? NativePromise : Promise;
    });
  }
  else
  {
    // in browser add to global
    if (!nativePromiseSupported)
      global['Promise'] = Promise;
  }
}


//
// Polyfill
//

var PENDING = 'pending';
var SEALED = 'sealed';
var FULFILLED = 'fulfilled';
var REJECTED = 'rejected';
var NOOP = function(){};

function isArray(value) {
  return Object.prototype.toString.call(value) === '[object Array]';
}

// async calls
var asyncSetTimer = typeof setImmediate !== 'undefined' ? setImmediate : setTimeout;
var asyncQueue = [];
var asyncTimer;

function asyncFlush(){
  // run promise callbacks
  for (var i = 0; i < asyncQueue.length; i++)
    asyncQueue[i][0](asyncQueue[i][1]);

  // reset async asyncQueue
  asyncQueue = [];
  asyncTimer = false;
}

function asyncCall(callback, arg){
  asyncQueue.push([callback, arg]);

  if (!asyncTimer)
  {
    asyncTimer = true;
    asyncSetTimer(asyncFlush, 0);
  }
}


function invokeResolver(resolver, promise) {
  function resolvePromise(value) {
    resolve(promise, value);
  }

  function rejectPromise(reason) {
    reject(promise, reason);
  }

  try {
    resolver(resolvePromise, rejectPromise);
  } catch(e) {
    rejectPromise(e);
  }
}

function invokeCallback(subscriber){
  var owner = subscriber.owner;
  var settled = owner.state_;
  var value = owner.data_;  
  var callback = subscriber[settled];
  var promise = subscriber.then;

  if (typeof callback === 'function')
  {
    settled = FULFILLED;
    try {
      value = callback(value);
    } catch(e) {
      reject(promise, e);
    }
  }

  if (!handleThenable(promise, value))
  {
    if (settled === FULFILLED)
      resolve(promise, value);

    if (settled === REJECTED)
      reject(promise, value);
  }
}

function handleThenable(promise, value) {
  var resolved;

  try {
    if (promise === value)
      throw new TypeError('A promises callback cannot return that same promise.');

    if (value && (typeof value === 'function' || typeof value === 'object'))
    {
      var then = value.then;  // then should be retrived only once

      if (typeof then === 'function')
      {
        then.call(value, function(val){
          if (!resolved)
          {
            resolved = true;

            if (value !== val)
              resolve(promise, val);
            else
              fulfill(promise, val);
          }
        }, function(reason){
          if (!resolved)
          {
            resolved = true;

            reject(promise, reason);
          }
        });

        return true;
      }
    }
  } catch (e) {
    if (!resolved)
      reject(promise, e);

    return true;
  }

  return false;
}

function resolve(promise, value){
  if (promise === value || !handleThenable(promise, value))
    fulfill(promise, value);
}

function fulfill(promise, value){
  if (promise.state_ === PENDING)
  {
    promise.state_ = SEALED;
    promise.data_ = value;

    asyncCall(publishFulfillment, promise);
  }
}

function reject(promise, reason){
  if (promise.state_ === PENDING)
  {
    promise.state_ = SEALED;
    promise.data_ = reason;

    asyncCall(publishRejection, promise);
  }
}

function publish(promise) {
  var callbacks = promise.then_;
  promise.then_ = undefined;

  for (var i = 0; i < callbacks.length; i++) {
    invokeCallback(callbacks[i]);
  }
}

function publishFulfillment(promise){
  promise.state_ = FULFILLED;
  publish(promise);
}

function publishRejection(promise){
  promise.state_ = REJECTED;
  publish(promise);
}

/**
* @class
*/
function Promise(resolver){
  if (typeof resolver !== 'function')
    throw new TypeError('Promise constructor takes a function argument');

  if (this instanceof Promise === false)
    throw new TypeError('Failed to construct \'Promise\': Please use the \'new\' operator, this object constructor cannot be called as a function.');

  this.then_ = [];

  invokeResolver(resolver, this);
}

Promise.prototype = {
  constructor: Promise,

  state_: PENDING,
  then_: null,
  data_: undefined,

  then: function(onFulfillment, onRejection){
    var subscriber = {
      owner: this,
      then: new this.constructor(NOOP),
      fulfilled: onFulfillment,
      rejected: onRejection
    };

    if (this.state_ === FULFILLED || this.state_ === REJECTED)
    {
      // already resolved, call callback async
      asyncCall(invokeCallback, subscriber);
    }
    else
    {
      // subscribe
      this.then_.push(subscriber);
    }

    return subscriber.then;
  },

  'catch': function(onRejection) {
    return this.then(null, onRejection);
  }
};

Promise.all = function(promises){
  var Class = this;

  if (!isArray(promises))
    throw new TypeError('You must pass an array to Promise.all().');

  return new Class(function(resolve, reject){
    var results = [];
    var remaining = 0;

    function resolver(index){
      remaining++;
      return function(value){
        results[index] = value;
        if (!--remaining)
          resolve(results);
      };
    }

    for (var i = 0, promise; i < promises.length; i++)
    {
      promise = promises[i];

      if (promise && typeof promise.then === 'function')
        promise.then(resolver(i), reject);
      else
        results[i] = promise;
    }

    if (!remaining)
      resolve(results);
  });
};

Promise.race = function(promises){
  var Class = this;

  if (!isArray(promises))
    throw new TypeError('You must pass an array to Promise.race().');

  return new Class(function(resolve, reject) {
    for (var i = 0, promise; i < promises.length; i++)
    {
      promise = promises[i];

      if (promise && typeof promise.then === 'function')
        promise.then(resolve, reject);
      else
        resolve(promise);
    }
  });
};

Promise.resolve = function(value){
  var Class = this;

  if (value && typeof value === 'object' && value.constructor === Class)
    return value;

  return new Class(function(resolve){
    resolve(value);
  });
};

Promise.reject = function(reason){
  var Class = this;

  return new Class(function(resolve, reject){
    reject(reason);
  });
};

})(typeof window != 'undefined' ? window : typeof global != 'undefined' ? global : typeof self != 'undefined' ? self : this);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],131:[function(require,module,exports){
(function (process,global){
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   3.3.1
 */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  return typeof x === 'function' || typeof x === 'object' && x !== null;
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (!Array.isArray) {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
} else {
  _isArray = Array.isArray;
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  return function () {
    vertxNext(flush);
  };
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = r('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && typeof require === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  _resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then, value, fulfillmentHandler, rejectionHandler) {
  try {
    then.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        _resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      _reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      _reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    _reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return _resolve(promise, value);
    }, function (reason) {
      return _reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$) {
  if (maybeThenable.constructor === promise.constructor && then$$ === then && maybeThenable.constructor.resolve === resolve) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$ === GET_THEN_ERROR) {
      _reject(promise, GET_THEN_ERROR.error);
    } else if (then$$ === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$)) {
      handleForeignThenable(promise, maybeThenable, then$$);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function _resolve(promise, value) {
  if (promise === value) {
    _reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function _reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      _reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      _resolve(promise, value);
    } else if (failed) {
      _reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      _reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      _resolve(promise, value);
    }, function rejectPromise(reason) {
      _reject(promise, reason);
    });
  } catch (e) {
    _reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this._input = input;
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate();
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    _reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
};

Enumerator.prototype._enumerate = function () {
  var length = this.length;
  var _input = this._input;

  for (var i = 0; this._state === PENDING && i < length; i++) {
    this._eachEntry(_input[i], i);
  }
};

Enumerator.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$ = c.resolve;

  if (resolve$$ === resolve) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$) {
        return resolve$$(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$(entry), i);
  }
};

Enumerator.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      _reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  _reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise ? initializePromise(this, resolver) : needsNew();
  }
}

Promise.all = all;
Promise.race = race;
Promise.resolve = resolve;
Promise.reject = reject;
Promise._setScheduler = setScheduler;
Promise._setAsap = setAsap;
Promise._asap = asap;

Promise.prototype = {
  constructor: Promise,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
  
    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
  
    Chaining
    --------
  
    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
  
    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
  
    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
  
    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
  
    Assimilation
    ------------
  
    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
  
    If the assimliated promise rejects, then the downstream promise will also reject.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
  
    Simple Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let result;
  
    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
  
    Advanced Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let author, books;
  
    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
  
    function foundBooks(books) {
  
    }
  
    function failure(reason) {
  
    }
  
    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
  
    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

function polyfill() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise;
}

polyfill();
// Strange compat..
Promise.polyfill = polyfill;
Promise.Promise = Promise;

return Promise;

})));

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"_process":138}],132:[function(require,module,exports){
(function (global){
/*jslint es6, node, browser, maxlen: 120 */
/*global self, window */

"use strict";

module.exports = (function () {

    "use strict";

    var globalObject = undefined;

    function isFunction(x) {
        return typeof x === "function";
    }

    // Seek the global object
    if (global !== undefined) {
        globalObject = global;
    } else if (window !== undefined && window.document) {
        globalObject = window;
    } else {
        globalObject = self;
    }

    // Test for any native promise implementation, and if that
    // implementation appears to conform to the specificaton.
    // This code mostly nicked from the es6-promise module polyfill
    // and then fooled with.
    var hasPromiseSupport = (function () {

        // No promise object at all, and it's a non-starter
        if (!globalObject.hasOwnProperty("Promise")) {
            return false;
        }

        // There is a Promise object. Does it conform to the spec?
        var P = globalObject.Promise;

        // Some of these methods are missing from
        // Firefox/Chrome experimental implementations
        if (!P.hasOwnProperty("resolve") || !P.hasOwnProperty("reject")) {
            return false;
        }

        if (!P.hasOwnProperty("all") || !P.hasOwnProperty("race")) {
            return false;
        }

        // Older version of the spec had a resolver object
        // as the arg rather than a function
        return (function () {

            var resolve = undefined,
                p = new globalObject.Promise(function (r) {
                resolve = r;
            });

            if (p) {
                return isFunction(resolve);
            }

            return false;
        })();
    })();

    // Export the native Promise implementation if it
    // looks like it matches the spec
    if (hasPromiseSupport) {
        return globalObject.Promise;
    }

    //  Otherwise, return the es6-promise polyfill by @jaffathecake.
    return require("es6-promise").Promise;
})();
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"es6-promise":131}],133:[function(require,module,exports){
/*jslint node, this, es6, maxlen: 120 */
"use strict";

module.exports = (function () {

    "use strict";

    // Get a promise object. This may be native, or it may be polyfilled
    var ES6Promise = require("./promise.js");

    // Promise Context object constructor.
    function Context(resolve, reject, custom) {
        this.resolve = resolve;
        this.reject = reject;
        this.custom = custom;
    }

    // Default callback function - rejects on truthy error, otherwise resolves
    function callback() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var ctx = args.shift(),
            err = args.shift(),
            cust = undefined;

        args = args.length > 1 ? args : args[0];

        if (typeof ctx.custom === 'function') {
            cust = function () {
                for (var _len2 = arguments.length, custArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    custArgs[_key2] = arguments[_key2];
                }

                // Bind the callback to itself, so the resolve and reject
                // properties that we bound are available to the callback.
                // Then we push it onto the end of the arguments array.
                return ctx.custom.apply(cust, custArgs);
            };
            cust.resolve = ctx.resolve;
            cust.reject = ctx.reject;
            cust.call(null, err, args);
        } else {
            if (err) {
                return ctx.reject(err);
            }
            ctx.resolve(args);
        }
    }

    /**
     * promisify
     *
     * Transforms callback-based function -- func(arg1, arg2 .. argN, callback) -- into
     * an ES6-compatible Promise. User can provide their own callback function; otherwise
     * promisify provides a callback of the form (error, result) and rejects on truthy error.
     * If supplying your own callback function, use this.resolve() and this.reject().
     *
     * @param {function} original - The function to promisify
     * @param {function} callback - Optional custom callbac function
     *
     * @return {function} A promisified version of 'original'
     */
    return function (original, custom) {

        return function () {
            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
            }

            // Store original context
            var that = this;

            // Return the promisified function
            return new ES6Promise(function (resolve, reject) {

                // Create a Context object
                var ctx = new Context(resolve, reject, custom);

                // Append the callback bound to the context
                args.push(callback.bind(null, ctx));

                // Call the function
                original.apply(that, args);
            });
        };
    };
})();
},{"./promise.js":132}],134:[function(require,module,exports){
(function() {
	var testObject = {};

	if (!(Object.setPrototypeOf || testObject.__proto__)) {
		var nativeGetPrototypeOf = Object.getPrototypeOf;

		Object.getPrototypeOf = function(object) {
			if (object.__proto__) {
				return object.__proto__;
			} else {
				return nativeGetPrototypeOf.call(Object, object);
			}
		}
	}
})();

},{}],135:[function(require,module,exports){
"use strict";

/**
 * Expose `md5omatic(str)`.
 */
 
module.exports = md5omatic;

/**
 * Hash any string using message digest.
 *
 * @param {String} str
 * @return {String}
 * @api public
 */
 
function md5omatic(str) {
    var x = str2blks_MD5(str);
    var a =  1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d =  271733878;

    for(var i=0; i<x.length; i += 16)
    {
        var olda = a;
        var oldb = b;
        var oldc = c;
        var oldd = d;

        a = ff(a, b, c, d, x[i+ 0], 7 , -680876936);
        d = ff(d, a, b, c, x[i+ 1], 12, -389564586);
        c = ff(c, d, a, b, x[i+ 2], 17,  606105819);
        b = ff(b, c, d, a, x[i+ 3], 22, -1044525330);
        a = ff(a, b, c, d, x[i+ 4], 7 , -176418897);
        d = ff(d, a, b, c, x[i+ 5], 12,  1200080426);
        c = ff(c, d, a, b, x[i+ 6], 17, -1473231341);
        b = ff(b, c, d, a, x[i+ 7], 22, -45705983);
        a = ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
        d = ff(d, a, b, c, x[i+ 9], 12, -1958414417);
        c = ff(c, d, a, b, x[i+10], 17, -42063);
        b = ff(b, c, d, a, x[i+11], 22, -1990404162);
        a = ff(a, b, c, d, x[i+12], 7 ,  1804603682);
        d = ff(d, a, b, c, x[i+13], 12, -40341101);
        c = ff(c, d, a, b, x[i+14], 17, -1502002290);
        b = ff(b, c, d, a, x[i+15], 22,  1236535329);
        a = gg(a, b, c, d, x[i+ 1], 5 , -165796510);
        d = gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
        c = gg(c, d, a, b, x[i+11], 14,  643717713);
        b = gg(b, c, d, a, x[i+ 0], 20, -373897302);
        a = gg(a, b, c, d, x[i+ 5], 5 , -701558691);
        d = gg(d, a, b, c, x[i+10], 9 ,  38016083);
        c = gg(c, d, a, b, x[i+15], 14, -660478335);
        b = gg(b, c, d, a, x[i+ 4], 20, -405537848);
        a = gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
        d = gg(d, a, b, c, x[i+14], 9 , -1019803690);
        c = gg(c, d, a, b, x[i+ 3], 14, -187363961);
        b = gg(b, c, d, a, x[i+ 8], 20,  1163531501);
        a = gg(a, b, c, d, x[i+13], 5 , -1444681467);
        d = gg(d, a, b, c, x[i+ 2], 9 , -51403784);
        c = gg(c, d, a, b, x[i+ 7], 14,  1735328473);
        b = gg(b, c, d, a, x[i+12], 20, -1926607734);
        a = hh(a, b, c, d, x[i+ 5], 4 , -378558);
        d = hh(d, a, b, c, x[i+ 8], 11, -2022574463);
        c = hh(c, d, a, b, x[i+11], 16,  1839030562);
        b = hh(b, c, d, a, x[i+14], 23, -35309556);
        a = hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
        d = hh(d, a, b, c, x[i+ 4], 11,  1272893353);
        c = hh(c, d, a, b, x[i+ 7], 16, -155497632);
        b = hh(b, c, d, a, x[i+10], 23, -1094730640);
        a = hh(a, b, c, d, x[i+13], 4 ,  681279174);
        d = hh(d, a, b, c, x[i+ 0], 11, -358537222);
        c = hh(c, d, a, b, x[i+ 3], 16, -722521979);
        b = hh(b, c, d, a, x[i+ 6], 23,  76029189);
        a = hh(a, b, c, d, x[i+ 9], 4 , -640364487);
        d = hh(d, a, b, c, x[i+12], 11, -421815835);
        c = hh(c, d, a, b, x[i+15], 16,  530742520);
        b = hh(b, c, d, a, x[i+ 2], 23, -995338651);
        a = ii(a, b, c, d, x[i+ 0], 6 , -198630844);
        d = ii(d, a, b, c, x[i+ 7], 10,  1126891415);
        c = ii(c, d, a, b, x[i+14], 15, -1416354905);
        b = ii(b, c, d, a, x[i+ 5], 21, -57434055);
        a = ii(a, b, c, d, x[i+12], 6 ,  1700485571);
        d = ii(d, a, b, c, x[i+ 3], 10, -1894986606);
        c = ii(c, d, a, b, x[i+10], 15, -1051523);
        b = ii(b, c, d, a, x[i+ 1], 21, -2054922799);
        a = ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
        d = ii(d, a, b, c, x[i+15], 10, -30611744);
        c = ii(c, d, a, b, x[i+ 6], 15, -1560198380);
        b = ii(b, c, d, a, x[i+13], 21,  1309151649);
        a = ii(a, b, c, d, x[i+ 4], 6 , -145523070);
        d = ii(d, a, b, c, x[i+11], 10, -1120210379);
        c = ii(c, d, a, b, x[i+ 2], 15,  718787259);
        b = ii(b, c, d, a, x[i+ 9], 21, -343485551);

        a = addme(a, olda);
        b = addme(b, oldb);
        c = addme(c, oldc);
        d = addme(d, oldd);
    }

    return rhex(a) + rhex(b) + rhex(c) + rhex(d);
};

var hex_chr = "0123456789abcdef";

function bitOR(a, b)
{
    var lsb = (a & 0x1) | (b & 0x1);
    var msb31 = (a >>> 1) | (b >>> 1);

    return (msb31 << 1) | lsb;
}

function bitXOR(a, b)
{
    var lsb = (a & 0x1) ^ (b & 0x1);
    var msb31 = (a >>> 1) ^ (b >>> 1);

    return (msb31 << 1) | lsb;
}

function bitAND(a, b)
{
    var lsb = (a & 0x1) & (b & 0x1);
    var msb31 = (a >>> 1) & (b >>> 1);

    return (msb31 << 1) | lsb;
}

function addme(x, y)
{
    var lsw = (x & 0xFFFF)+(y & 0xFFFF);
    var msw = (x >> 16)+(y >> 16)+(lsw >> 16);

    return (msw << 16) | (lsw & 0xFFFF);
}

function rhex(num)
{
    var str = "";
    var j;

    for(j=0; j<=3; j++)
        str += hex_chr.charAt((num >> (j * 8 + 4)) & 0x0F) + hex_chr.charAt((num >> (j * 8)) & 0x0F);

    return str;
}

function str2blks_MD5(str)
{
    var nblk = ((str.length + 8) >> 6) + 1;
    var blks = new Array(nblk * 16);
    var i;

    for(i=0; i<nblk * 16; i++)
        blks[i] = 0;

    for(i=0; i<str.length; i++)
        blks[i >> 2] |= str.charCodeAt(i) << (((str.length * 8 + i) % 4) * 8);

    blks[i >> 2] |= 0x80 << (((str.length * 8 + i) % 4) * 8);

    var l = str.length * 8;
    blks[nblk * 16 - 2] = (l & 0xFF);
    blks[nblk * 16 - 2] |= ((l >>> 8) & 0xFF) << 8;
    blks[nblk * 16 - 2] |= ((l >>> 16) & 0xFF) << 16;
    blks[nblk * 16 - 2] |= ((l >>> 24) & 0xFF) << 24;

    return blks;
}

function rol(num, cnt)
{
    return (num << cnt) | (num >>> (32 - cnt));
}

function cmn(q, a, b, x, s, t)
{
    return addme(rol((addme(addme(a, q), addme(x, t))), s), b);
}

function ff(a, b, c, d, x, s, t)
{
    return cmn(bitOR(bitAND(b, c), bitAND((~b), d)), a, b, x, s, t);
}

function gg(a, b, c, d, x, s, t)
{
    return cmn(bitOR(bitAND(b, d), bitAND(c, (~d))), a, b, x, s, t);
}

function hh(a, b, c, d, x, s, t)
{
    return cmn(bitXOR(bitXOR(b, c), d), a, b, x, s, t);
}

function ii(a, b, c, d, x, s, t)
{
    return cmn(bitXOR(c, bitOR(b, (~d))), a, b, x, s, t);
}
},{}],136:[function(require,module,exports){
var md5omatic = require('md5-o-matic');

module.exports = function (func, prefix) {
  prefix = prefix || '';
  func = func || function () { return '_default'; };
  return function () {
    var args = Array.prototype.slice.call(arguments);
    var k = func.apply(undefined, args);
    if (k === null) {
      return null;
    }
    if (typeof k === 'undefined' ||
      (typeof k === 'number' && isNaN(k)) ||
      k === '' ||
      (typeof k === 'object' && Object.keys(k).length === 0)) {
      throw new Error('Not a valid key');
    }
    if (typeof k !== 'string') {
      k = md5omatic(JSON.stringify(k));
    }
    return prefix + k;
  };
};

},{"md5-o-matic":135}],137:[function(require,module,exports){
function isObj(v) {
  return typeof v === 'object';
}

function isStr(v) {
  return typeof v === 'string';
}

function isBool(v) {
  return typeof v === 'boolean';
}

function isUndef(v) {
  if (typeof v === 'string') {
    return v.length === 0;
  }
  return typeof v === 'undefined';
}

function flatten(arr) {
  return [].concat.apply([], arr);
}

var emailRE = /.+\@.+\..+/;

var _validatorFactories = {
  object: function () { return function (value) { return (isUndef(value) || isObj(value) ? [] : ['object.base']); }; },
  string: function () { return function (value) { return (isUndef(value) || isStr(value) ? [] : ['string.base']); }; },
  boolean: function () { return function (value) { return (isUndef(value) || isBool(value) ? [] : ['boolean.base']); }; },
  min: function (minValue) { return function (value) { return (isUndef(value) || value.length >= minValue ? [] : ['string.min']); }; },
  max: function (maxValue) { return function (value) { return (isUndef(value) || value.length <= maxValue ? [] : ['string.max']); }; },
  email: function () { return function (value) { return (isUndef(value) || emailRE.test(value) ? [] : ['string.email']); }; },
  required: function () { return function (value) { return (!isUndef(value) ? [] : ['any.empty']); }; },
  regex: function (re) { return function (value) { return (isUndef(value) || re.test(value) ? [] : ['string.regex.base']); }; },
  keys: function (obj) { return function (value) { return (isUndef(value) ? [] : flatten(Object.keys(obj).map(function (attr) { return obj[attr]._validate(value[attr], attr); }))); }; },
};

function _joi() {
  this._validators = [];
}

var joi = {};

Object.keys(_validatorFactories).forEach(function (k) {
  _joi.prototype[k] = function unnamed(arg) {
    this._validators.push(_validatorFactories[k](arg));
    return this;
  };

  joi[k] = function (arg) {
    var j = new _joi();
    return j[k](arg);
  };
});

_joi.prototype._validate = function _validate(value, path) {
  return flatten(this._validators.map(function (func) { return func(value); }))
  .map(function (e) {
    var out = {
      type: typeof e === 'string' ? e : e.type,
    };
    var paths = [];
    if (path) {
      paths.push(path);
    }
    if (typeof e !== 'string' && 'path' in e) {
      paths.push(e.path);
    }

    if (paths.length) {
      out.path = paths.join('.');
    }
    return out;
  });
};

joi.validate = function validate(data, schema, options, callback) {
  // const abortEarly = options.abortEarly;
  var errors = schema._validate(data);
  var out = errors.length ? {
    error: {
      details: errors,
    },
    value: data,
  } : { error: null, value: data };

  if (callback) {
    callback(out.error, out.value);
  }
  return out;
};

module.exports = joi;

},{}],138:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],139:[function(require,module,exports){
module.exports = require('./lib/effects')
},{"./lib/effects":140}],140:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _io = require('./internal/io');

Object.defineProperty(exports, 'take', {
  enumerable: true,
  get: function get() {
    return _io.take;
  }
});
Object.defineProperty(exports, 'takem', {
  enumerable: true,
  get: function get() {
    return _io.takem;
  }
});
Object.defineProperty(exports, 'put', {
  enumerable: true,
  get: function get() {
    return _io.put;
  }
});
Object.defineProperty(exports, 'race', {
  enumerable: true,
  get: function get() {
    return _io.race;
  }
});
Object.defineProperty(exports, 'call', {
  enumerable: true,
  get: function get() {
    return _io.call;
  }
});
Object.defineProperty(exports, 'apply', {
  enumerable: true,
  get: function get() {
    return _io.apply;
  }
});
Object.defineProperty(exports, 'cps', {
  enumerable: true,
  get: function get() {
    return _io.cps;
  }
});
Object.defineProperty(exports, 'fork', {
  enumerable: true,
  get: function get() {
    return _io.fork;
  }
});
Object.defineProperty(exports, 'spawn', {
  enumerable: true,
  get: function get() {
    return _io.spawn;
  }
});
Object.defineProperty(exports, 'join', {
  enumerable: true,
  get: function get() {
    return _io.join;
  }
});
Object.defineProperty(exports, 'cancel', {
  enumerable: true,
  get: function get() {
    return _io.cancel;
  }
});
Object.defineProperty(exports, 'select', {
  enumerable: true,
  get: function get() {
    return _io.select;
  }
});
Object.defineProperty(exports, 'actionChannel', {
  enumerable: true,
  get: function get() {
    return _io.actionChannel;
  }
});
Object.defineProperty(exports, 'cancelled', {
  enumerable: true,
  get: function get() {
    return _io.cancelled;
  }
});
Object.defineProperty(exports, 'flush', {
  enumerable: true,
  get: function get() {
    return _io.flush;
  }
});
},{"./internal/io":145}],141:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.utils = exports.effects = exports.CANCEL = exports.delay = exports.throttle = exports.takeLatest = exports.takeEvery = exports.buffers = exports.channel = exports.eventChannel = exports.END = exports.runSaga = undefined;

var _runSaga = require('./internal/runSaga');

Object.defineProperty(exports, 'runSaga', {
  enumerable: true,
  get: function get() {
    return _runSaga.runSaga;
  }
});

var _channel = require('./internal/channel');

Object.defineProperty(exports, 'END', {
  enumerable: true,
  get: function get() {
    return _channel.END;
  }
});
Object.defineProperty(exports, 'eventChannel', {
  enumerable: true,
  get: function get() {
    return _channel.eventChannel;
  }
});
Object.defineProperty(exports, 'channel', {
  enumerable: true,
  get: function get() {
    return _channel.channel;
  }
});

var _buffers = require('./internal/buffers');

Object.defineProperty(exports, 'buffers', {
  enumerable: true,
  get: function get() {
    return _buffers.buffers;
  }
});

var _sagaHelpers = require('./internal/sagaHelpers');

Object.defineProperty(exports, 'takeEvery', {
  enumerable: true,
  get: function get() {
    return _sagaHelpers.takeEvery;
  }
});
Object.defineProperty(exports, 'takeLatest', {
  enumerable: true,
  get: function get() {
    return _sagaHelpers.takeLatest;
  }
});
Object.defineProperty(exports, 'throttle', {
  enumerable: true,
  get: function get() {
    return _sagaHelpers.throttle;
  }
});

var _utils = require('./internal/utils');

Object.defineProperty(exports, 'delay', {
  enumerable: true,
  get: function get() {
    return _utils.delay;
  }
});
Object.defineProperty(exports, 'CANCEL', {
  enumerable: true,
  get: function get() {
    return _utils.CANCEL;
  }
});

var _middleware = require('./internal/middleware');

var _middleware2 = _interopRequireDefault(_middleware);

var _effects = require('./effects');

var effects = _interopRequireWildcard(_effects);

var _utils2 = require('./utils');

var utils = _interopRequireWildcard(_utils2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _middleware2.default;
exports.effects = effects;
exports.utils = utils;
},{"./effects":140,"./internal/buffers":143,"./internal/channel":144,"./internal/middleware":146,"./internal/runSaga":148,"./internal/sagaHelpers":149,"./internal/utils":150,"./utils":151}],142:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = asap;
var queue = [];
var isSuspended = false;

function asap(task) {
  if (!isSuspended) {
    isSuspended = true;
    queue.push(task);
    asap.flush();
  } else {
    queue.push(task);
  }
}

asap.suspend = function () {
  return isSuspended = true;
};
asap.flush = function () {
  var nextTask = void 0;
  while (nextTask = queue.shift()) {
    nextTask();
  }
  isSuspended = false;
};
},{}],143:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buffers = exports.BUFFER_OVERFLOW = undefined;

var _utils = require('./utils');

var BUFFER_OVERFLOW = exports.BUFFER_OVERFLOW = 'Channel\'s Buffer overflow!';

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: _utils.kTrue, put: _utils.noop, take: _utils.noop };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take, flush: flush
  };
}

var buffers = exports.buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_EXPAND);
  }
};
},{"./utils":150}],144:[function(require,module,exports){
(function (process){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNDEFINED_INPUT_ERROR = exports.INVALID_BUFFER = exports.isEnd = exports.END = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.emitter = emitter;
exports.channel = channel;
exports.eventChannel = eventChannel;
exports.stdChannel = stdChannel;

var _utils = require('./utils');

var _buffers = require('./buffers');

var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = exports.END = { type: CHANNEL_END_TYPE };
var isEnd = exports.isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return (0, _utils.remove)(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = exports.INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = exports.UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (process.env.NODE_ENV !== 'production') {
  exports.UNDEFINED_INPUT_ERROR = UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _buffers.buffers.fixed();

  var closed = false;
  var takers = [];

  (0, _utils.check)(buffer, _utils.is.buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw (0, _utils.internalErr)('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw (0, _utils.internalErr)('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    (0, _utils.check)(input, _utils.is.notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[_utils.MATCH] || cb[_utils.MATCH](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    (0, _utils.check)(cb, _utils.is.func, 'channel.take\'s callback must be a function');

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return (0, _utils.remove)(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    (0, _utils.check)(cb, _utils.is.func, 'channel.flush\' callback must be a function');
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return { take: take, put: put, flush: flush, close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _buffers.buffers.none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    (0, _utils.check)(matcher, _utils.is.func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      chan.close();
    } else if (!matcher || matcher(input)) {
      chan.put(input);
    }
  });

  if (!_utils.is.func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: function close() {
      if (!chan.__closed__) {
        chan.close();
        unsubscribe();
      }
    }
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(subscribe);

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        (0, _utils.check)(matcher, _utils.is.func, 'channel.take\'s matcher argument must be a function');
        cb[_utils.MATCH] = matcher;
      }
      chan.take(cb);
    }
  });
}
}).call(this,require('_process'))

},{"./buffers":143,"./utils":150,"_process":138}],145:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asEffect = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.take = take;
exports.takem = takem;
exports.put = put;
exports.race = race;
exports.call = call;
exports.apply = apply;
exports.cps = cps;
exports.fork = fork;
exports.spawn = spawn;
exports.join = join;
exports.cancel = cancel;
exports.select = select;
exports.actionChannel = actionChannel;
exports.cancelled = cancelled;
exports.flush = flush;

var _utils = require('./utils');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IO = (0, _utils.sym)('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, IO, true), _defineProperty(_ref, type, payload), _ref;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    (0, _utils.check)(arguments[0], _utils.is.notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (_utils.is.pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (_utils.is.channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

function takem() {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
}

function put(channel, action) {
  if (arguments.length > 1) {
    (0, _utils.check)(channel, _utils.is.notUndef, 'put(channel, action): argument channel is undefined');
    (0, _utils.check)(channel, _utils.is.channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    (0, _utils.check)(action, _utils.is.notUndef, 'put(channel, action): argument action is undefined');
  } else {
    (0, _utils.check)(channel, _utils.is.notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.sync = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].sync = true;
  return eff;
};

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  (0, _utils.check)(fn, _utils.is.notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (_utils.is.array(fn)) {
    var _fn = fn;

    var _fn2 = _slicedToArray(_fn, 2);

    context = _fn2[0];
    fn = _fn2[1];
  } else if (fn.fn) {
    var _fn3 = fn;
    context = _fn3.context;
    fn = _fn3.fn;
  }
  (0, _utils.check)(fn, _utils.is.func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  var eff = fork.apply(undefined, [fn].concat(args));
  eff[FORK].detached = true;
  return eff;
}

var isForkedTask = function isForkedTask(task) {
  return task[_utils.TASK];
};

function join(task) {
  (0, _utils.check)(task, _utils.is.notUndef, 'join(task): argument task is undefined');
  if (!isForkedTask(task)) {
    throw new Error('join(task): argument ' + task + ' is not a valid Task object \n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)');
  }

  return effect(JOIN, task);
}

function cancel(task) {
  (0, _utils.check)(task, _utils.is.notUndef, 'cancel(task): argument task is undefined');
  if (!isForkedTask(task)) {
    throw new Error('cancel(task): argument ' + task + ' is not a valid Task object \n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)');
  }

  return effect(CANCEL, task);
}

function select(selector) {
  for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }

  if (arguments.length === 0) {
    selector = _utils.ident;
  } else {
    (0, _utils.check)(selector, _utils.is.notUndef, 'select(selector,[...]): argument selector is undefined');
    (0, _utils.check)(selector, _utils.is.func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  (0, _utils.check)(pattern, _utils.is.notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  (0, _utils.check)(channel, _utils.is.channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

var asEffect = exports.asEffect = {
  take: function take(effect) {
    return effect && effect[IO] && effect[TAKE];
  },
  put: function put(effect) {
    return effect && effect[IO] && effect[PUT];
  },
  race: function race(effect) {
    return effect && effect[IO] && effect[RACE];
  },
  call: function call(effect) {
    return effect && effect[IO] && effect[CALL];
  },
  cps: function cps(effect) {
    return effect && effect[IO] && effect[CPS];
  },
  fork: function fork(effect) {
    return effect && effect[IO] && effect[FORK];
  },
  join: function join(effect) {
    return effect && effect[IO] && effect[JOIN];
  },
  cancel: function cancel(effect) {
    return effect && effect[IO] && effect[CANCEL];
  },
  select: function select(effect) {
    return effect && effect[IO] && effect[SELECT];
  },
  actionChannel: function actionChannel(effect) {
    return effect && effect[IO] && effect[ACTION_CHANNEL];
  },
  cancelled: function cancelled(effect) {
    return effect && effect[IO] && effect[CANCELLED];
  },
  flush: function flush(effect) {
    return effect && effect[IO] && effect[FLUSH];
  }
};
},{"./utils":150}],146:[function(require,module,exports){
(function (process){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sagaMiddlewareFactory;

var _utils = require('./utils');

var _proc = require('./proc');

var _proc2 = _interopRequireDefault(_proc);

var _channel = require('./channel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sagaMiddlewareFactory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var runSagaDynamically = void 0;

  if (_utils.is.func(options)) {
    if (process.env.NODE_ENV === 'production') {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (options.logger && !_utils.is.func(options.logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (options.onerror && !_utils.is.func(options.onerror)) {
    throw new Error('`options.onerror` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref) {
    var getState = _ref.getState;
    var dispatch = _ref.dispatch;

    runSagaDynamically = runSaga;
    var sagaEmitter = (0, _channel.emitter)();

    function runSaga(saga) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (0, _proc2.default)(saga.apply(undefined, args), sagaEmitter.subscribe, dispatch, getState, options, 0, saga.name);
    }

    return function (next) {
      return function (action) {
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function (saga) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    (0, _utils.check)(runSagaDynamically, _utils.is.notUndef, 'Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
    (0, _utils.check)(saga, _utils.is.func, 'sagaMiddleware.run(saga, ...args): saga argument must be a Generator function!');
    return runSagaDynamically.apply(undefined, [saga].concat(args));
  };

  return sagaMiddleware;
}
}).call(this,require('_process'))

},{"./channel":144,"./proc":147,"./utils":150,"_process":138}],147:[function(require,module,exports){
(function (process){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TASK_CANCEL = exports.CHANNEL_END = exports.NOT_ITERATOR_ERROR = undefined;
exports.default = proc;

var _utils = require('./utils');

var _asap = require('./asap');

var _asap2 = _interopRequireDefault(_asap);

var _io = require('./io');

var _channel = require('./channel');

var _buffers = require('./buffers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isDev = process.env.NODE_ENV === 'development';

var NOT_ITERATOR_ERROR = exports.NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var nextEffectId = (0, _utils.autoInc)();
var CHANNEL_END = exports.CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = exports.TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return _utils.kTrue;
  },
  default: function _default(pattern) {
    return function (input) {
      return input.type === pattern;
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return p === input.type;
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  return (pattern === '*' ? matchers.wildcard : _utils.is.array(pattern) ? matchers.array : _utils.is.func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes iff all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      (0, _utils.remove)(tasks, task);
      task.cont = _utils.noop;
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = _utils.noop;
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context;
  var fn = _ref.fn;
  var args = _ref.args;

  if (_utils.is.iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (_utils.is.iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? (0, _utils.makeIterator)(function () {
    throw error;
  }) : (0, _utils.makeIterator)(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

function wrapHelper(helper) {
  return {
    fn: helper
  };
}

function proc(iterator) {
  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return _utils.noop;
  };
  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _utils.noop;
  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _utils.noop;
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var parentEffectId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var name = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'anonymous';
  var cont = arguments[7];

  (0, _utils.check)(iterator, _utils.is.iterator, NOT_ITERATOR_ERROR);

  var sagaMonitor = options.sagaMonitor;
  var logger = options.logger;
  var onError = options.onError;

  var log = logger || _utils.log;
  var stdChannel = (0, _channel.stdChannel)(subscribe);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = _utils.noop;

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
      Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
      Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL autoamtically cancels the main task
          We can get this value here
            - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          Thill will jump to the finally block
        **/
        result = _utils.is.func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = _utils.is.func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        log('error', 'uncaught at ' + name, error.message);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      if (result === TASK_CANCEL && isDev) {
        log('info', name + ' has been cancelled', '');
      }
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        result.sagaStack = 'at ' + name + ' \n ' + (result.sagaStack || result.stack);
      }
      if (!task.cont) {
        log('error', 'uncaught', result.sagaStack || result.stack);
        if (result instanceof Error && onError) {
          onError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = nextEffectId();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = _utils.noop; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }

      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = _utils.noop;

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        log('error', 'uncaught at ' + name, err.message);
      }
      currCb.cancel = _utils.noop; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
        ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
        This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
        Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    return (
      // Non declarative effect
      _utils.is.promise(effect) ? resolvePromise(effect, currCb) : _utils.is.helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : _utils.is.iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : _utils.is.array(effect) ? runParallelEffect(effect, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.take(effect)) ? runTakeEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.put(effect)) ? runPutEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.race(effect)) ? runRaceEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.call(effect)) ? runCallEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.cps(effect)) ? runCPSEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.fork(effect)) ? runForkEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.join(effect)) ? runJoinEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancel(effect)) ? runCancelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.select(effect)) ? runSelectEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.actionChannel(effect)) ? runChannelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.flush(effect)) ? runFlushEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancelled(effect)) ? runCancelledEffect(data, currCb) : /* anything else returned as is        */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[_utils.CANCEL];
    if (typeof cancelPromise === 'function') {
      cb.cancel = cancelPromise;
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel;
    var pattern = _ref2.pattern;
    var maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : (0, _channel.isEnd)(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel;
    var action = _ref3.action;
    var sync = _ref3.sync;

    /*
      Use a reentrant lock `asap` to flatten all nested dispatches
      If this put cause another Saga to take this action an then immediately
      put an action that will be taken by this Saga. Then the outer Saga will miss
      the action from the inner Saga b/c this put has not yet returned.
    */
    (0, _asap2.default)(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        return cb(error, true);
      }

      if (sync && _utils.is.promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context;
    var fn = _ref4.fn;
    var args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return _utils.is.promise(result) ? resolvePromise(result, cb) : _utils.is.iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context;
    var fn = _ref5.fn;
    var args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      fn.apply(context, args.concat(function (err, res) {
        return _utils.is.undef(err) ? cb(res) : cb(err, true);
      }));
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context;
    var fn = _ref6.fn;
    var args = _ref6.args;
    var detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    _asap2.default.suspend();
    var task = proc(taskIterator, subscribe, dispatch, getState, options, effectId, fn.name, detached ? null : _utils.noop);

    if (detached) {
      cb(task);
    } else {
      if (taskIterator._isRunning) {
        taskQueue.addTask(task);
        cb(task);
      } else if (taskIterator._error) {
        taskQueue.abort(taskIterator._error);
      } else {
        cb(task);
      }
    }
    _asap2.default.flush();
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      (function () {
        var joiner = { task: task, cb: cb };
        cb.cancel = function () {
          return (0, _utils.remove)(t.joiners, joiner);
        };
        t.joiners.push(joiner);
      })();
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(task, cb) {
    if (task.isRunning()) {
      task.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runParallelEffect(effects, effectId, cb) {
    if (!effects.length) {
      return cb([]);
    }

    var completedCount = 0;
    var completed = void 0;
    var results = Array(effects.length);

    function checkEffectEnd() {
      if (completedCount === results.length) {
        completed = true;
        cb(results);
      }
    }

    var childCbs = effects.map(function (eff, idx) {
      var chCbAtIdx = function chCbAtIdx(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || (0, _channel.isEnd)(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[idx] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtIdx.cancel = _utils.noop;
      return chCbAtIdx;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        childCbs.forEach(function (chCb) {
          return chCb.cancel();
        });
      }
    };

    effects.forEach(function (eff, idx) {
      return runEffect(eff, effectId, idx, childCbs[idx]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!(0, _channel.isEnd)(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          cb.cancel();
          completed = true;
          cb(_defineProperty({}, key, res));
        }
      };
      chCbAtKey.cancel = _utils.noop;
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector;
    var args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(_toConsumableArray(args)));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern;
    var buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb((0, _channel.eventChannel)(subscribe, buffer || _buffers.buffers.fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _defineProperty(_ref9, _utils.TASK, true), _defineProperty(_ref9, 'id', id), _defineProperty(_ref9, 'name', name), _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = (0, _utils.deferred)();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _defineProperty(_ref9, 'cont', cont), _defineProperty(_ref9, 'joiners', []), _defineProperty(_ref9, 'cancel', cancel), _defineProperty(_ref9, 'isRunning', function isRunning() {
      return iterator._isRunning;
    }), _defineProperty(_ref9, 'isCancelled', function isCancelled() {
      return iterator._isCancelled;
    }), _defineProperty(_ref9, 'isAborted', function isAborted() {
      return iterator._isAborted;
    }), _defineProperty(_ref9, 'result', function result() {
      return iterator._result;
    }), _defineProperty(_ref9, 'error', function error() {
      return iterator._error;
    }), _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}
}).call(this,require('_process'))

},{"./asap":142,"./buffers":143,"./channel":144,"./io":145,"./utils":150,"_process":138}],148:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.runSaga = runSaga;

var _utils = require('./utils');

var _proc = require('./proc');

var _proc2 = _interopRequireDefault(_proc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function runSaga(iterator, _ref) {
  var subscribe = _ref.subscribe;
  var dispatch = _ref.dispatch;
  var getState = _ref.getState;
  var sagaMonitor = _ref.sagaMonitor;
  var logger = _ref.logger;


  (0, _utils.check)(iterator, _utils.is.iterator, "runSaga must be called on an iterator");

  return (0, _proc2.default)(iterator, subscribe, dispatch, getState, { sagaMonitor: sagaMonitor, logger: logger });
}
},{"./proc":147,"./utils":150}],149:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.takeEvery = takeEvery;
exports.takeLatest = takeLatest;
exports.throttle = throttle;

var _channel = require('./channel');

var _utils = require('./utils');

var _io = require('./io');

var _buffers = require('./buffers');

var done = { done: true, value: undefined };
var qEnd = {};

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext]();

      var _fsm$qNext2 = _slicedToArray(_fsm$qNext, 3);

      var q = _fsm$qNext2[0];
      var output = _fsm$qNext2[1];
      var _updateState = _fsm$qNext2[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return (0, _utils.makeIterator)(next, function (error) {
    return next(null, error);
  }, name, true);
}

function safeName(pattern) {
  if (Array.isArray(pattern)) {
    return String(pattern.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(pattern);
  }
}

function takeEvery(pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: (0, _io.take)(pattern) };
  var yFork = function yFork(ac) {
    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === _channel.END ? [qEnd] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + safeName(pattern) + ', ' + worker.name + ')');
}

function takeLatest(pattern, worker) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  var yTake = { done: false, value: (0, _io.take)(pattern) };
  var yFork = function yFork(ac) {
    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: (0, _io.cancel)(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === _channel.END ? [qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + safeName(pattern) + ', ' + worker.name + ')');
}

function throttle(delayLength, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: (0, _io.actionChannel)(pattern, _buffers.buffers.sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: (0, _io.take)(channel, pattern) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: (0, _io.call)(_utils.delay, delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === _channel.END ? [qEnd] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + safeName(pattern) + ', ' + worker.name + ')');
}
},{"./buffers":143,"./channel":144,"./io":145,"./utils":150}],150:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.check = check;
exports.remove = remove;
exports.deferred = deferred;
exports.arrayOfDeffered = arrayOfDeffered;
exports.delay = delay;
exports.createMockTask = createMockTask;
exports.autoInc = autoInc;
exports.makeIterator = makeIterator;
exports.log = log;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sym = exports.sym = function sym(id) {
  return '@@redux-saga/' + id;
};
var TASK = exports.TASK = sym('TASK');
var HELPER = exports.HELPER = sym('HELPER');
var MATCH = exports.MATCH = sym('MATCH');
var CANCEL = exports.CANCEL = sym('cancelPromise');
var konst = exports.konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = exports.kTrue = konst(true);
var kFalse = exports.kFalse = konst(false);
var noop = exports.noop = function noop() {};
var ident = exports.ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var is = exports.is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  array: Array.isArray,
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (typeof pat === 'string' || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _defineProperty(_ref, TASK, true), _defineProperty(_ref, 'isRunning', function isRunning() {
    return running;
  }), _defineProperty(_ref, 'result', function result() {
    return _result;
  }), _defineProperty(_ref, 'error', function error() {
    return _error;
  }), _defineProperty(_ref, 'setRunning', function setRunning(b) {
    return running = b;
  }), _defineProperty(_ref, 'setResult', function setResult(r) {
    return _result = r;
  }), _defineProperty(_ref, 'setError', function setError(e) {
    return _error = e;
  }), _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message, error) {
  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

var internalErr = exports.internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};
},{}],151:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./internal/utils');

Object.defineProperty(exports, 'TASK', {
  enumerable: true,
  get: function get() {
    return _utils.TASK;
  }
});
Object.defineProperty(exports, 'noop', {
  enumerable: true,
  get: function get() {
    return _utils.noop;
  }
});
Object.defineProperty(exports, 'is', {
  enumerable: true,
  get: function get() {
    return _utils.is;
  }
});
Object.defineProperty(exports, 'deferred', {
  enumerable: true,
  get: function get() {
    return _utils.deferred;
  }
});
Object.defineProperty(exports, 'arrayOfDeffered', {
  enumerable: true,
  get: function get() {
    return _utils.arrayOfDeffered;
  }
});
Object.defineProperty(exports, 'createMockTask', {
  enumerable: true,
  get: function get() {
    return _utils.createMockTask;
  }
});

var _io = require('./internal/io');

Object.defineProperty(exports, 'asEffect', {
  enumerable: true,
  get: function get() {
    return _io.asEffect;
  }
});
},{"./internal/io":145,"./internal/utils":150}],152:[function(require,module,exports){
(function (global){
// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = require("./runtime");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./runtime":153}],153:[function(require,module,exports){
(function (process,global){
/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var hasOwn = Object.prototype.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided, then outerFn.prototype instanceof Generator.
    var generator = Object.create((outerFn || Generator).prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `value instanceof AwaitArgument` to determine if the yielded value is
  // meant to be awaited. Some may consider the name of this method too
  // cutesy, but they are curmudgeons.
  runtime.awrap = function(arg) {
    return new AwaitArgument(arg);
  };

  function AwaitArgument(arg) {
    this.arg = arg;
  }

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value instanceof AwaitArgument) {
          return Promise.resolve(value.arg).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof process === "object" && process.domain) {
      invoke = process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          if (method === "return" ||
              (method === "throw" && delegate.iterator[method] === undefined)) {
            // A return or throw (when the delegate iterator has no throw
            // method) always terminates the yield* loop.
            context.delegate = null;

            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            var returnMethod = delegate.iterator["return"];
            if (returnMethod) {
              var record = tryCatch(returnMethod, delegate.iterator, arg);
              if (record.type === "throw") {
                // If the return method threw an exception, let that
                // exception prevail over the original return or throw.
                method = "throw";
                arg = record.arg;
                continue;
              }
            }

            if (method === "return") {
              // Continue with the outer return, now that the delegate
              // iterator has been terminated.
              continue;
            }
          }

          var record = tryCatch(
            delegate.iterator[method],
            delegate.iterator,
            arg
          );

          if (record.type === "throw") {
            context.delegate = null;

            // Like returning generator.throw(uncaught), but without the
            // overhead of an extra function call.
            method = "throw";
            arg = record.arg;
            continue;
          }

          // Delegate generator ran and handled its own exceptions so
          // regardless of what the method was, we continue as if it is
          // "next" with an undefined arg.
          method = "next";
          arg = undefined;

          var info = record.arg;
          if (info.done) {
            context[delegate.resultName] = info.value;
            context.next = delegate.nextLoc;
          } else {
            state = GenStateSuspendedYield;
            return info;
          }

          context.delegate = null;
        }

        if (method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = arg;

        } else if (method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw arg;
          }

          if (context.dispatchException(arg)) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            method = "next";
            arg = undefined;
          }

        } else if (method === "return") {
          context.abrupt("return", arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          var info = {
            value: record.arg,
            done: context.done
          };

          if (record.arg === ContinueSentinel) {
            if (context.delegate && method === "next") {
              // Deliberately forget the last sent value so that we don't
              // accidentally pass it on to the delegate.
              arg = undefined;
            }
          } else {
            return info;
          }

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(arg) call above.
          method = "throw";
          arg = record.arg;
        }
      }
    };
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp[toStringTagSymbol] = "Generator";

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;
        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.next = finallyEntry.finallyLoc;
      } else {
        this.complete(record);
      }

      return ContinueSentinel;
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = record.arg;
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"_process":138}],154:[function(require,module,exports){
/*!
  * Reqwest! A general purpose XHR connection manager
  * license MIT (c) Dustin Diaz 2015
  * https://github.com/ded/reqwest
  */

!function (name, context, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (typeof define == 'function' && define.amd) define(definition)
  else context[name] = definition()
}('reqwest', this, function () {

  var context = this

  if ('window' in context) {
    var doc = document
      , byTag = 'getElementsByTagName'
      , head = doc[byTag]('head')[0]
  } else {
    var XHR2
    try {
      XHR2 = require('xhr2')
    } catch (ex) {
      throw new Error('Peer dependency `xhr2` required! Please npm install xhr2')
    }
  }


  var httpsRe = /^http/
    , protocolRe = /(^\w+):\/\//
    , twoHundo = /^(20\d|1223)$/ //http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
    , readyState = 'readyState'
    , contentType = 'Content-Type'
    , requestedWith = 'X-Requested-With'
    , uniqid = 0
    , callbackPrefix = 'reqwest_' + (+new Date())
    , lastValue // data stored by the most recent JSONP callback
    , xmlHttpRequest = 'XMLHttpRequest'
    , xDomainRequest = 'XDomainRequest'
    , noop = function () {}

    , isArray = typeof Array.isArray == 'function'
        ? Array.isArray
        : function (a) {
            return a instanceof Array
          }

    , defaultHeaders = {
          'contentType': 'application/x-www-form-urlencoded'
        , 'requestedWith': xmlHttpRequest
        , 'accept': {
              '*':  'text/javascript, text/html, application/xml, text/xml, */*'
            , 'xml':  'application/xml, text/xml'
            , 'html': 'text/html'
            , 'text': 'text/plain'
            , 'json': 'application/json, text/javascript'
            , 'js':   'application/javascript, text/javascript'
          }
      }

    , xhr = function(o) {
        // is it x-domain
        if (o['crossOrigin'] === true) {
          var xhr = context[xmlHttpRequest] ? new XMLHttpRequest() : null
          if (xhr && 'withCredentials' in xhr) {
            return xhr
          } else if (context[xDomainRequest]) {
            return new XDomainRequest()
          } else {
            throw new Error('Browser does not support cross-origin requests')
          }
        } else if (context[xmlHttpRequest]) {
          return new XMLHttpRequest()
        } else if (XHR2) {
          return new XHR2()
        } else {
          return new ActiveXObject('Microsoft.XMLHTTP')
        }
      }
    , globalSetupOptions = {
        dataFilter: function (data) {
          return data
        }
      }

  function succeed(r) {
    var protocol = protocolRe.exec(r.url)
    protocol = (protocol && protocol[1]) || context.location.protocol
    return httpsRe.test(protocol) ? twoHundo.test(r.request.status) : !!r.request.response
  }

  function handleReadyState(r, success, error) {
    return function () {
      // use _aborted to mitigate against IE err c00c023f
      // (can't read props on aborted request objects)
      if (r._aborted) return error(r.request)
      if (r._timedOut) return error(r.request, 'Request is aborted: timeout')
      if (r.request && r.request[readyState] == 4) {
        r.request.onreadystatechange = noop
        if (succeed(r)) success(r.request)
        else
          error(r.request)
      }
    }
  }

  function setHeaders(http, o) {
    var headers = o['headers'] || {}
      , h

    headers['Accept'] = headers['Accept']
      || defaultHeaders['accept'][o['type']]
      || defaultHeaders['accept']['*']

    var isAFormData = typeof FormData !== 'undefined' && (o['data'] instanceof FormData);
    // breaks cross-origin requests with legacy browsers
    if (!o['crossOrigin'] && !headers[requestedWith]) headers[requestedWith] = defaultHeaders['requestedWith']
    if (!headers[contentType] && !isAFormData) headers[contentType] = o['contentType'] || defaultHeaders['contentType']
    for (h in headers)
      headers.hasOwnProperty(h) && 'setRequestHeader' in http && http.setRequestHeader(h, headers[h])
  }

  function setCredentials(http, o) {
    if (typeof o['withCredentials'] !== 'undefined' && typeof http.withCredentials !== 'undefined') {
      http.withCredentials = !!o['withCredentials']
    }
  }

  function generalCallback(data) {
    lastValue = data
  }

  function urlappend (url, s) {
    return url + (/\?/.test(url) ? '&' : '?') + s
  }

  function handleJsonp(o, fn, err, url) {
    var reqId = uniqid++
      , cbkey = o['jsonpCallback'] || 'callback' // the 'callback' key
      , cbval = o['jsonpCallbackName'] || reqwest.getcallbackPrefix(reqId)
      , cbreg = new RegExp('((^|\\?|&)' + cbkey + ')=([^&]+)')
      , match = url.match(cbreg)
      , script = doc.createElement('script')
      , loaded = 0
      , isIE10 = navigator.userAgent.indexOf('MSIE 10.0') !== -1

    if (match) {
      if (match[3] === '?') {
        url = url.replace(cbreg, '$1=' + cbval) // wildcard callback func name
      } else {
        cbval = match[3] // provided callback func name
      }
    } else {
      url = urlappend(url, cbkey + '=' + cbval) // no callback details, add 'em
    }

    context[cbval] = generalCallback

    script.type = 'text/javascript'
    script.src = url
    script.async = true
    if (typeof script.onreadystatechange !== 'undefined' && !isIE10) {
      // need this for IE due to out-of-order onreadystatechange(), binding script
      // execution to an event listener gives us control over when the script
      // is executed. See http://jaubourg.net/2010/07/loading-script-as-onclick-handler-of.html
      script.htmlFor = script.id = '_reqwest_' + reqId
    }

    script.onload = script.onreadystatechange = function () {
      if ((script[readyState] && script[readyState] !== 'complete' && script[readyState] !== 'loaded') || loaded) {
        return false
      }
      script.onload = script.onreadystatechange = null
      script.onclick && script.onclick()
      // Call the user callback with the last value stored and clean up values and scripts.
      fn(lastValue)
      lastValue = undefined
      head.removeChild(script)
      loaded = 1
    }

    // Add the script to the DOM head
    head.appendChild(script)

    // Enable JSONP timeout
    return {
      abort: function () {
        script.onload = script.onreadystatechange = null
        err({}, 'Request is aborted: timeout', {})
        lastValue = undefined
        head.removeChild(script)
        loaded = 1
      }
    }
  }

  function getRequest(fn, err) {
    var o = this.o
      , method = (o['method'] || 'GET').toUpperCase()
      , url = typeof o === 'string' ? o : o['url']
      // convert non-string objects to query-string form unless o['processData'] is false
      , data = (o['processData'] !== false && o['data'] && typeof o['data'] !== 'string')
        ? reqwest.toQueryString(o['data'])
        : (o['data'] || null)
      , http
      , sendWait = false

    // if we're working on a GET request and we have data then we should append
    // query string to end of URL and not post data
    if ((o['type'] == 'jsonp' || method == 'GET') && data) {
      url = urlappend(url, data)
      data = null
    }

    if (o['type'] == 'jsonp') return handleJsonp(o, fn, err, url)

    // get the xhr from the factory if passed
    // if the factory returns null, fall-back to ours
    http = (o.xhr && o.xhr(o)) || xhr(o)

    http.open(method, url, o['async'] === false ? false : true)
    setHeaders(http, o)
    setCredentials(http, o)
    if (context[xDomainRequest] && http instanceof context[xDomainRequest]) {
        http.onload = fn
        http.onerror = err
        // NOTE: see
        // http://social.msdn.microsoft.com/Forums/en-US/iewebdevelopment/thread/30ef3add-767c-4436-b8a9-f1ca19b4812e
        http.onprogress = function() {}
        sendWait = true
    } else {
      http.onreadystatechange = handleReadyState(this, fn, err)
    }
    o['before'] && o['before'](http)
    if (sendWait) {
      setTimeout(function () {
        http.send(data)
      }, 200)
    } else {
      http.send(data)
    }
    return http
  }

  function Reqwest(o, fn) {
    this.o = o
    this.fn = fn

    init.apply(this, arguments)
  }

  function setType(header) {
    // json, javascript, text/plain, text/html, xml
    if (header === null) return undefined; //In case of no content-type.
    if (header.match('json')) return 'json'
    if (header.match('javascript')) return 'js'
    if (header.match('text')) return 'html'
    if (header.match('xml')) return 'xml'
  }

  function init(o, fn) {

    this.url = typeof o == 'string' ? o : o['url']
    this.timeout = null

    // whether request has been fulfilled for purpose
    // of tracking the Promises
    this._fulfilled = false
    // success handlers
    this._successHandler = function(){}
    this._fulfillmentHandlers = []
    // error handlers
    this._errorHandlers = []
    // complete (both success and fail) handlers
    this._completeHandlers = []
    this._erred = false
    this._responseArgs = {}

    var self = this

    fn = fn || function () {}

    if (o['timeout']) {
      this.timeout = setTimeout(function () {
        timedOut()
      }, o['timeout'])
    }

    if (o['success']) {
      this._successHandler = function () {
        o['success'].apply(o, arguments)
      }
    }

    if (o['error']) {
      this._errorHandlers.push(function () {
        o['error'].apply(o, arguments)
      })
    }

    if (o['complete']) {
      this._completeHandlers.push(function () {
        o['complete'].apply(o, arguments)
      })
    }

    function complete (resp) {
      o['timeout'] && clearTimeout(self.timeout)
      self.timeout = null
      while (self._completeHandlers.length > 0) {
        self._completeHandlers.shift()(resp)
      }
    }

    function success (resp) {
      var type = o['type'] || resp && setType(resp.getResponseHeader('Content-Type')) // resp can be undefined in IE
      resp = (type !== 'jsonp') ? self.request : resp
      // use global data filter on response text
      var filteredResponse = globalSetupOptions.dataFilter(resp.responseText, type)
        , r = filteredResponse
      try {
        resp.responseText = r
      } catch (e) {
        // can't assign this in IE<=8, just ignore
      }
      if (r) {
        switch (type) {
        case 'json':
          try {
            resp = context.JSON ? context.JSON.parse(r) : eval('(' + r + ')')
          } catch (err) {
            return error(resp, 'Could not parse JSON in response', err)
          }
          break
        case 'js':
          resp = eval(r)
          break
        case 'html':
          resp = r
          break
        case 'xml':
          resp = resp.responseXML
              && resp.responseXML.parseError // IE trololo
              && resp.responseXML.parseError.errorCode
              && resp.responseXML.parseError.reason
            ? null
            : resp.responseXML
          break
        }
      }

      self._responseArgs.resp = resp
      self._fulfilled = true
      fn(resp)
      self._successHandler(resp)
      while (self._fulfillmentHandlers.length > 0) {
        resp = self._fulfillmentHandlers.shift()(resp)
      }

      complete(resp)
    }

    function timedOut() {
      self._timedOut = true
      self.request.abort()
    }

    function error(resp, msg, t) {
      resp = self.request
      self._responseArgs.resp = resp
      self._responseArgs.msg = msg
      self._responseArgs.t = t
      self._erred = true
      while (self._errorHandlers.length > 0) {
        self._errorHandlers.shift()(resp, msg, t)
      }
      complete(resp)
    }

    this.request = getRequest.call(this, success, error)
  }

  Reqwest.prototype = {
    abort: function () {
      this._aborted = true
      this.request.abort()
    }

  , retry: function () {
      init.call(this, this.o, this.fn)
    }

    /**
     * Small deviation from the Promises A CommonJs specification
     * http://wiki.commonjs.org/wiki/Promises/A
     */

    /**
     * `then` will execute upon successful requests
     */
  , then: function (success, fail) {
      success = success || function () {}
      fail = fail || function () {}
      if (this._fulfilled) {
        this._responseArgs.resp = success(this._responseArgs.resp)
      } else if (this._erred) {
        fail(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t)
      } else {
        this._fulfillmentHandlers.push(success)
        this._errorHandlers.push(fail)
      }
      return this
    }

    /**
     * `always` will execute whether the request succeeds or fails
     */
  , always: function (fn) {
      if (this._fulfilled || this._erred) {
        fn(this._responseArgs.resp)
      } else {
        this._completeHandlers.push(fn)
      }
      return this
    }

    /**
     * `fail` will execute when the request fails
     */
  , fail: function (fn) {
      if (this._erred) {
        fn(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t)
      } else {
        this._errorHandlers.push(fn)
      }
      return this
    }
  , 'catch': function (fn) {
      return this.fail(fn)
    }
  }

  function reqwest(o, fn) {
    return new Reqwest(o, fn)
  }

  // normalize newline variants according to spec -> CRLF
  function normalize(s) {
    return s ? s.replace(/\r?\n/g, '\r\n') : ''
  }

  function serial(el, cb) {
    var n = el.name
      , t = el.tagName.toLowerCase()
      , optCb = function (o) {
          // IE gives value="" even where there is no value attribute
          // 'specified' ref: http://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-862529273
          if (o && !o['disabled'])
            cb(n, normalize(o['attributes']['value'] && o['attributes']['value']['specified'] ? o['value'] : o['text']))
        }
      , ch, ra, val, i

    // don't serialize elements that are disabled or without a name
    if (el.disabled || !n) return

    switch (t) {
    case 'input':
      if (!/reset|button|image|file/i.test(el.type)) {
        ch = /checkbox/i.test(el.type)
        ra = /radio/i.test(el.type)
        val = el.value
        // WebKit gives us "" instead of "on" if a checkbox has no value, so correct it here
        ;(!(ch || ra) || el.checked) && cb(n, normalize(ch && val === '' ? 'on' : val))
      }
      break
    case 'textarea':
      cb(n, normalize(el.value))
      break
    case 'select':
      if (el.type.toLowerCase() === 'select-one') {
        optCb(el.selectedIndex >= 0 ? el.options[el.selectedIndex] : null)
      } else {
        for (i = 0; el.length && i < el.length; i++) {
          el.options[i].selected && optCb(el.options[i])
        }
      }
      break
    }
  }

  // collect up all form elements found from the passed argument elements all
  // the way down to child elements; pass a '<form>' or form fields.
  // called with 'this'=callback to use for serial() on each element
  function eachFormElement() {
    var cb = this
      , e, i
      , serializeSubtags = function (e, tags) {
          var i, j, fa
          for (i = 0; i < tags.length; i++) {
            fa = e[byTag](tags[i])
            for (j = 0; j < fa.length; j++) serial(fa[j], cb)
          }
        }

    for (i = 0; i < arguments.length; i++) {
      e = arguments[i]
      if (/input|select|textarea/i.test(e.tagName)) serial(e, cb)
      serializeSubtags(e, [ 'input', 'select', 'textarea' ])
    }
  }

  // standard query string style serialization
  function serializeQueryString() {
    return reqwest.toQueryString(reqwest.serializeArray.apply(null, arguments))
  }

  // { 'name': 'value', ... } style serialization
  function serializeHash() {
    var hash = {}
    eachFormElement.apply(function (name, value) {
      if (name in hash) {
        hash[name] && !isArray(hash[name]) && (hash[name] = [hash[name]])
        hash[name].push(value)
      } else hash[name] = value
    }, arguments)
    return hash
  }

  // [ { name: 'name', value: 'value' }, ... ] style serialization
  reqwest.serializeArray = function () {
    var arr = []
    eachFormElement.apply(function (name, value) {
      arr.push({name: name, value: value})
    }, arguments)
    return arr
  }

  reqwest.serialize = function () {
    if (arguments.length === 0) return ''
    var opt, fn
      , args = Array.prototype.slice.call(arguments, 0)

    opt = args.pop()
    opt && opt.nodeType && args.push(opt) && (opt = null)
    opt && (opt = opt.type)

    if (opt == 'map') fn = serializeHash
    else if (opt == 'array') fn = reqwest.serializeArray
    else fn = serializeQueryString

    return fn.apply(null, args)
  }

  reqwest.toQueryString = function (o, trad) {
    var prefix, i
      , traditional = trad || false
      , s = []
      , enc = encodeURIComponent
      , add = function (key, value) {
          // If value is a function, invoke it and return its value
          value = ('function' === typeof value) ? value() : (value == null ? '' : value)
          s[s.length] = enc(key) + '=' + enc(value)
        }
    // If an array was passed in, assume that it is an array of form elements.
    if (isArray(o)) {
      for (i = 0; o && i < o.length; i++) add(o[i]['name'], o[i]['value'])
    } else {
      // If traditional, encode the "old" way (the way 1.3.2 or older
      // did it), otherwise encode params recursively.
      for (prefix in o) {
        if (o.hasOwnProperty(prefix)) buildParams(prefix, o[prefix], traditional, add)
      }
    }

    // spaces should be + according to spec
    return s.join('&').replace(/%20/g, '+')
  }

  function buildParams(prefix, obj, traditional, add) {
    var name, i, v
      , rbracket = /\[\]$/

    if (isArray(obj)) {
      // Serialize array item.
      for (i = 0; obj && i < obj.length; i++) {
        v = obj[i]
        if (traditional || rbracket.test(prefix)) {
          // Treat each array item as a scalar.
          add(prefix, v)
        } else {
          buildParams(prefix + '[' + (typeof v === 'object' ? i : '') + ']', v, traditional, add)
        }
      }
    } else if (obj && obj.toString() === '[object Object]') {
      // Serialize object item.
      for (name in obj) {
        buildParams(prefix + '[' + name + ']', obj[name], traditional, add)
      }

    } else {
      // Serialize scalar item.
      add(prefix, obj)
    }
  }

  reqwest.getcallbackPrefix = function () {
    return callbackPrefix
  }

  // jQuery and Zepto compatibility, differences can be remapped here so you can call
  // .ajax.compat(options, callback)
  reqwest.compat = function (o, fn) {
    if (o) {
      o['type'] && (o['method'] = o['type']) && delete o['type']
      o['dataType'] && (o['type'] = o['dataType'])
      o['jsonpCallback'] && (o['jsonpCallbackName'] = o['jsonpCallback']) && delete o['jsonpCallback']
      o['jsonp'] && (o['jsonpCallback'] = o['jsonp'])
    }
    return new Reqwest(o, fn)
  }

  reqwest.ajaxSetup = function (options) {
    options = options || {}
    for (var k in options) {
      globalSetupOptions[k] = options[k]
    }
  }

  return reqwest
});

},{"xhr2":28}],155:[function(require,module,exports){
/*! http://mths.be/startswith v0.2.0 by @mathias */
if (!String.prototype.startsWith) {
	(function() {
		'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
		var defineProperty = (function() {
			// IE 8 only supports `Object.defineProperty` on DOM elements
			try {
				var object = {};
				var $defineProperty = Object.defineProperty;
				var result = $defineProperty(object, object, object) && $defineProperty;
			} catch(error) {}
			return result;
		}());
		var toString = {}.toString;
		var startsWith = function(search) {
			if (this == null) {
				throw TypeError();
			}
			var string = String(this);
			if (search && toString.call(search) == '[object RegExp]') {
				throw TypeError();
			}
			var stringLength = string.length;
			var searchString = String(search);
			var searchLength = searchString.length;
			var position = arguments.length > 1 ? arguments[1] : undefined;
			// `ToInteger`
			var pos = position ? Number(position) : 0;
			if (pos != pos) { // better `isNaN`
				pos = 0;
			}
			var start = Math.min(Math.max(pos, 0), stringLength);
			// Avoid the `indexOf` call if no match is possible
			if (searchLength + start > stringLength) {
				return false;
			}
			var index = -1;
			while (++index < searchLength) {
				if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) {
					return false;
				}
			}
			return true;
		};
		if (defineProperty) {
			defineProperty(String.prototype, 'startsWith', {
				'value': startsWith,
				'configurable': true,
				'writable': true
			});
		} else {
			String.prototype.startsWith = startsWith;
		}
	}());
}

},{}],156:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errors = {
  /* signin */
  'signin.generic.error': {
    'signin.password': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.denied.error': {
    'signin.password': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.unauthorized': {
    'signin.password': {
      msg: 'Sorry, we don\'t recognise your username or password.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.generic.banned': {
    'signin.password': {
      msg: 'This user has been banned for an unspecified reason.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.banned': {
    'signin.password': {
      msg: 'This user has been banned.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.disapproved': {
    'signin.password': {
      msg: 'This user has been disapproved.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.possible spam activity': {
    'signin.password': {
      msg: 'This user has been identified as possible spammer.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.locked out': {
    'signin.password': {
      msg: 'This user has been locked out.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.identification.any.empty': {
    'signin.userName': {
      msg: 'Please enter your username.',
      state: 'error'
    }
  },
  'signin.password.any.empty': {
    'signin.password': {
      msg: 'Please enter your password.',
      state: 'error'
    }
  },
  /* registration */
  'registration.generic.error': {
    'registration.password': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    }
  },
  'registration.denied.error': {
    'registration.password': {
      msg: 'This user is not allowed to register. Please contact customer support.',
      state: 'error'
    }
  },
  'registration..spam': {
    'registration.password': {
      msg: 'Contact customer support',
      state: 'error'
    }
  },
  'registration.username.any.empty': {
    'registration.username': {
      msg: 'Please choose a username.',
      state: 'error'
    }
  },
  'registration.username.string.min': {
    'registration.username': {
      msg: 'Usernames must be at least three characters long.',
      state: 'error'
    }
  },
  'registration.username.string.max': {
    'registration.username': {
      msg: 'Usernames must be no more than 30 characters long.',
      state: 'error'
    }
  },
  'registration.email.duplicate': {
    'registration.email': {
      msg: 'This email address has already been registered.',
      state: 'error'
    }
  },
  'registration.email.string.email': {
    'registration.email': {
      msg: 'Please enter a valid email address.',
      state: 'error'
    }
  },
  'registration.email.any.empty': {
    'registration.email': {
      msg: 'Please enter an email address.',
      state: 'error'
    }
  },
  'registration.username.string.regex.base': {
    'registration.username': {
      msg: 'Usernames can only contain letters, numbers and the characters _ or -.',
      state: 'error'
    }
  },
  'registration.username.duplicate': {
    'registration.username': {
      msg: 'This username has already been taken.',
      state: 'error'
    }
  },
  'registration.password.any.empty': {
    'registration.password': {
      msg: 'Please choose a password.',
      state: 'error'
    }
  },
  'registration.password.string.min': {
    'registration.password': {
      msg: 'Your password must be at least six characters long.',
      state: 'error'
    }
  },
  'registration.firstName.any.empty': {
    'registration.firstName': {
      msg: 'Please tell us your first name.',
      state: 'error'
    }
  },
  'registration.lastName.any.empty': {
    'registration.lastName': {
      msg: 'Please tell us your last name.',
      state: 'error'
    }
  },
  /* google */
  'google.generic.error': {
    'generic.googlebutton': {
      msg: 'Google error.',
      state: 'error'
    }
  },
  'google.unauthorized': {
    'generic.googlebutton': {
      msg: 'Sorry, Google couldn\'t authorise this user.',
      state: 'error'
    }
  },
  'google.popup.closed': {
    'generic.googlebutton': {
      msg: 'The Google popup has been closed.',
      state: 'error'
    }
  },
  'google.popup.blocked': {
    'generic.googlebutton': {
      msg: 'The Google popup may have been blocked by your browser. Please check your settings.',
      state: 'error'
    }
  },
  'google.usererror': {
    'generic.googlebutton': {
      msg: 'Sorry, Google couldn\'t register or log in this user.',
      state: 'error'
    }
  },
  /* forgot-password */
  'forgot-password.generic.error': {
    'forgot-password.identification': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    }
  },
  'forgot-password.denied.error': {
    'forgot-password.identification': {
      msg: 'This user is not allowed to reset the password. Please contact customer support.',
      state: 'error'
    }
  },
  'forgot-password.email.string.email': {
    'forgot-password.identification': {
      msg: 'Please enter your email address.',
      state: 'error'
    }
  },
  'forgot-password.email.any.empty': {
    'forgot-password.identification': {
      msg: 'Please enter your email address.',
      state: 'error'
    }
  },
  'forgot-password.user.not-found': {
    'forgot-password.identification': {
      msg: 'Sorry, we don\'t recognise that email address.',
      state: 'error'
    }
  },
  'forgot-password.generic.banned': {
    'forgot-password.identification': {
      msg: 'This user has been banned for an unspecified reason.',
      state: 'error'
    }
  },
  'forgot-password.banned': {
    'forgot-password.identification': {
      msg: 'This user has been banned.',
      state: 'error'
    }
  },
  'forgot-password.disapproved': {
    'forgot-password.identification': {
      msg: 'This user has been disapproved.',
      state: 'error'
    }
  },
  'forgot-password.possible spam activity': {
    'forgot-password.identification': {
      msg: 'This user has been identified as possible spammer.',
      state: 'error'
    }
  },
  'forgot-password.locked out': {
    'forgot-password.identification': {
      msg: 'This user has been locked out.',
      state: 'error'
    }
  },
  /* resend-confirmation-email */
  'resend-confirmation-email.generic.error': {
    submitted: true,
    'resend-confirmation-email': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    }
  },
  'resend-confirmation-email.email.any.empty': {
    submitted: true,
    'resend-confirmation-email': {
      msg: 'Please enter an email address.',
      state: 'error'
    }
  },
  'resend-confirmation-email.email.string.email': {
    submitted: true,
    'resend-confirmation-email': {
      msg: 'Please enter a valid email address.',
      state: 'error'
    }
  },
  'resend-confirmation-email.generic-success': {
    submitted: true,
    success: true
  },
  'reset-password.invalid-token': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, that reset link didn\'t work. Please try a new one.',
      state: 'error'
    }
  },
  /* reset-password */
  'reset-password.generic.error': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, we weren\'t able to change your password. Please try again later.',
      state: 'error'
    }
  },
  'reset-password.server-error': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, we weren\'t able to change your password. Please try again later.',
      state: 'error'
    }
  },
  'reset-password.token-error': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, this link is not valid any more. Can you ask for a new one?',
      state: 'error'
    }
  },
  'reset-password.unable': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, We are unable to change the password, have you already changed it?',
      state: 'error'
    }
  },
  'reset-password.blocked': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, This user is blocked/banned. Contact customer support.',
      state: 'error'
    }
  },
  'reset-password.generic-success': {
    submitted: true,
    success: true
  },
  'edit-account.generic.error': {
    'edit-account.userType': {
      msg: 'Sorry, we weren\'t able to update your account. Please try again later.',
      state: 'error'
    },
    'edit-account.message': {
      msg: 'Sorry, we weren\'t able to update your account. Please try again later.',
      state: 'error'
    }
  },
  'edit-account.userType.any.allowOnly': {
    'edit-account.userType': {
      msg: 'The user type is not correct, please pick one',
      state: 'error'
    }
  },
  'edit-account.firstName.any.empty': {
    'edit-account.firstName': {
      msg: 'Please tell us your first name.',
      state: 'error'
    }
  },
  'edit-account.lastName.any.empty': {
    'edit-account.lastName': {
      msg: 'Please tell us your last name.',
      state: 'error'
    }
  },
  'edit-account.email.duplicate': {
    'edit-account.email': {
      msg: 'This email address has already been registered.',
      state: 'error'
    }
  },
  'edit-account.email.string.email': {
    'edit-account.email': {
      msg: 'Please enter a valid email address.',
      state: 'error'
    }
  },
  'edit-account.email.any.empty': {
    'edit-account.email': {
      msg: 'Please enter your email address.',
      state: 'error'
    }
  },
  'change-password.generic.error': {
    'change-password.password': {
      msg: 'Sorry, we weren\'t able to update your account. Please try again later.',
      state: 'error'
    }
  },
  'change-password.password.string.min': {
    'change-password.password': {
      msg: 'Your password must be at least six characters long.',
      state: 'error'
    }
  },
  'change-password.oldpassword.wrong': {
    'change-password.oldPassword': {
      msg: 'Your password is not correct, please try entering it again.',
      state: 'error'
    }
  },
  'change-password.samepassword': {
    'change-password.password': {
      msg: 'The new password is the same as the previous password.',
      state: 'error'
    }
  },
  'change-password.ok': {
    'change-password.message': {
      msg: 'You have succesfully changed your password.',
      state: 'success'
    }
  }
};

exports.default = function (codes) {
  if (!codes) return {};
  var errorCodes = codes.split(',');
  var validErrorCodes = errorCodes.filter(function (code) {
    return code in errors;
  });

  if (validErrorCodes.length === 0) {
    var prefix = errorCodes[0].split('.', 1);
    validErrorCodes.push(prefix + '.generic.error');
  }

  return validErrorCodes.map(function (code) {
    return errors[code];
  }).reduce(function (previous, current) {
    return (0, _assign2.default)({}, previous, current);
  }, {});
};

});
},{"async-define":8,"babel-runtime/core-js/object/assign":12}],157:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _Signin = require('./Signin');

var _Signin2 = _interopRequireDefault(_Signin);

var _ForgotPassword = require('./ForgotPassword');

var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

var _LoggedInSelect = require('./LoggedInSelect');

var _LoggedInSelect2 = _interopRequireDefault(_LoggedInSelect);

var _LoggedInUpdate = require('./LoggedInUpdate');

var _LoggedInUpdate2 = _interopRequireDefault(_LoggedInUpdate);

var _Register = require('./Register');

var _Register2 = _interopRequireDefault(_Register);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require('../reducers/actions');

var actionCreators = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = exports.App = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    (0, _classCallCheck3.default)(this, App);
    return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
  }

  (0, _createClass3.default)(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.trackDisplay(this.props.common.formType);
      if (!this.props.common.isModal && !this.props.common.isInline) {
        this.props.actions.failRegister(this.props.errors);
        this.props.actions.failSignIn(this.props.errors);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var components = {
        'sign-in': _react2.default.createElement(_Signin2.default, null),
        register: _react2.default.createElement(_Register2.default, null),
        'forgot-password': _react2.default.createElement(_ForgotPassword2.default, null),
        select: _react2.default.createElement(_Select2.default, null),
        'logged-in-select': _react2.default.createElement(_LoggedInSelect2.default, null),
        'logged-in-update': _react2.default.createElement(_LoggedInUpdate2.default, null)
      };
      var component = components[this.props.common.formType];
      return component;
    }
  }]);
  return App;
}(_react.Component);

App.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  signIn: _react.PropTypes.object.isRequired,
  register: _react.PropTypes.object.isRequired,
  forgotPassword: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    signIn: state.signIn,
    register: state.register,
    forgotPassword: state.forgotPassword
  };
}, mapDispatchToProps)(App);

});
},{"../reducers/actions":173,"./ForgotPassword":158,"./LoggedInSelect":159,"./LoggedInUpdate":160,"./Register":161,"./Select":162,"./Signin":164,"async-define":8,"babel-runtime/core-js/object/get-prototype-of":15,"babel-runtime/helpers/classCallCheck":21,"babel-runtime/helpers/createClass":22,"babel-runtime/helpers/inherits":23,"babel-runtime/helpers/possibleConstructorReturn":24}],158:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ForgotPassword = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require('../lib/getErrorFromPrefix');

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require('../reducers/actions');

var actionCreators = _interopRequireWildcard(_actions);

var _WidgetLink = require('./lib/WidgetLink');

var _WidgetLink2 = _interopRequireDefault(_WidgetLink);

var _HiddenInputs = require('./lib/HiddenInputs');

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('forgot-password');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('forgot-password');

var ForgotPassword = exports.ForgotPassword = function (_Component) {
  (0, _inherits3.default)(ForgotPassword, _Component);

  function ForgotPassword() {
    (0, _classCallCheck3.default)(this, ForgotPassword);
    return (0, _possibleConstructorReturn3.default)(this, (ForgotPassword.__proto__ || (0, _getPrototypeOf2.default)(ForgotPassword)).apply(this, arguments));
  }

  (0, _createClass3.default)(ForgotPassword, [{
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      this.props.actions.initForgotPassword();
    }
  }, {
    key: 'handleContinue',
    value: function handleContinue(e) {
      e.preventDefault();
      this.props.actions.successForgotPassword();
    }
  }, {
    key: 'hasError',
    value: function hasError() {
      return this.props.errors ? (0, _keys2.default)(this.props.errors).filter(function (n) {
        return n.startsWith('forgot-password.');
      }).length > 0 : false;
    }
  }, {
    key: 'changeField',
    value: function changeField(namepar, depspar) {
      var _this2 = this;

      var name = 'forgot-password.' + namepar;
      var deps = depspar.map(function (n) {
        return 'forgotpassword.' + n;
      }) || [];
      return function (e) {
        var target = e.target;
        _this2.props.actions.setField('forgotPassword', target.name, target.value);
        _this2.props.actions.changeField(name, deps);
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var err = this.props.errors;

      var content = void 0;
      if (this.props.forgotPassword.state === 'sent') {
        content = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'Email sent! Please now check your inbox'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'These emails can get caught in spam - please also check your spam folder.'
          ),
          _react2.default.createElement(
            'button',
            { onClick: function onClick(e) {
                return _this3.handleContinue(e);
              }, className: 'tes-btn tes-btn--lg tes-btn--icon tes-btn--block tes-btn--primary' },
            'Continue',
            _react2.default.createElement('span', { 'aria-hidden': 'true' })
          )
        );
      } else {
        content = _react2.default.createElement(
          'form',
          { onSubmit: function onSubmit(e) {
              return _this3.handleSubmit(e);
            }, role: 'form', method: 'post', className: 't-forgot-password-form' },
          _react2.default.createElement(_HiddenInputs2.default, null),
          _react2.default.createElement(
            'div',
            { className: getErrorCls('identification')(err) },
            _react2.default.createElement(
              'div',
              { className: 'tes-input-group' },
              _react2.default.createElement(
                'span',
                { className: 'tes-input-group__addon' },
                _react2.default.createElement('i', { className: 'icon icon-user' })
              ),
              _react2.default.createElement('input', { type: 'text', onChange: this.changeField('identification', []),
                name: 'identification',
                autoFocus: 'true',
                placeholder: 'email',
                value: this.props.forgotPassword.identification,
                className: 'tes-control tes-control--group identification-field t-identification'
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'tes-help-block' },
              getErrorMsg('identification')(err)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'margin-top-md margin-bottom-sm' },
            _react2.default.createElement(
              'button',
              { disabled: this.props.forgotPassword.state === 'wait' ? 'disabled' : null, type: 'submit', className: 'tes-btn tes-btn--lg tes-btn--icon tes-btn--block tes-btn--primary forgot-password-submit' },
              this.props.forgotPassword.state === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner icon-white' }) : 'Send'
            )
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { id: 'sign-in', className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
        _react2.default.createElement(
          'div',
          { className: 'heading-main margin-bottom-md text-center' },
          _react2.default.createElement(
            'h3',
            { className: 'tes-modal__heading' },
            'Recover your password'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Send us your email and we will send you instructions to reset your password.'
          )
        ),
        content,
        _react2.default.createElement(
          'div',
          { className: 'clearfix' },
          _react2.default.createElement(
            'div',
            { className: 'more-info text-center text-sm padding-top-sm border-top' },
            _react2.default.createElement(
              'span',
              null,
              'Remember your password?'
            ),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              _WidgetLink2.default,
              { formType: 'signIn' },
              'Log in now!'
            )
          )
        )
      );
    }
  }]);
  return ForgotPassword;
}(_react.Component);

ForgotPassword.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  signIn: _react.PropTypes.object.isRequired,
  register: _react.PropTypes.object.isRequired,
  forgotPassword: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    signIn: state.signIn,
    register: state.register,
    forgotPassword: state.forgotPassword
  };
}, mapDispatchToProps)(ForgotPassword);

});
},{"../lib/getErrorFromPrefix":170,"../reducers/actions":173,"./lib/HiddenInputs":165,"./lib/WidgetLink":167,"async-define":8,"babel-runtime/core-js/object/get-prototype-of":15,"babel-runtime/core-js/object/keys":16,"babel-runtime/helpers/classCallCheck":21,"babel-runtime/helpers/createClass":22,"babel-runtime/helpers/inherits":23,"babel-runtime/helpers/possibleConstructorReturn":24}],159:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoggedInSelect = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _SelectForm = require('./SelectForm');

var _SelectForm2 = _interopRequireDefault(_SelectForm);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require('../reducers/actions');

var actionCreators = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoggedInSelect = exports.LoggedInSelect = function (_Component) {
  (0, _inherits3.default)(LoggedInSelect, _Component);

  function LoggedInSelect() {
    (0, _classCallCheck3.default)(this, LoggedInSelect);
    return (0, _possibleConstructorReturn3.default)(this, (LoggedInSelect.__proto__ || (0, _getPrototypeOf2.default)(LoggedInSelect)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoggedInSelect, [{
    key: 'setTo',
    value: function setTo(e, userType) {
      if (!this.props.common.isModal && !this.props.common.isInline) return;
      e.preventDefault();
      this.props.actions.updateUserData({ userType: userType });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(_SelectForm2.default, {
        onStudentClick: function onStudentClick(e) {
          return _this2.setTo(e, 'student');
        },
        onTeacherClick: function onTeacherClick(e) {
          return _this2.setTo(e, 'teacher');
        },
        onOtherClick: function onOtherClick(e) {
          return _this2.setTo(e, 'other');
        },
        action: '/api/authn/edit-account',
        method: 'post'
      });
    }
  }]);
  return LoggedInSelect;
}(_react.Component);

LoggedInSelect.propTypes = {
  common: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common
  };
}, mapDispatchToProps)(LoggedInSelect);

});
},{"../reducers/actions":173,"./SelectForm":163,"async-define":8,"babel-runtime/core-js/object/get-prototype-of":15,"babel-runtime/helpers/classCallCheck":21,"babel-runtime/helpers/createClass":22,"babel-runtime/helpers/inherits":23,"babel-runtime/helpers/possibleConstructorReturn":24}],160:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoggedInUpdate = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require('../lib/getErrorFromPrefix');

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require('../reducers/actions');

var actionCreators = _interopRequireWildcard(_actions);

var _InputField = require('./lib/InputField');

var _InputField2 = _interopRequireDefault(_InputField);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('edit-account');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('edit-account');

var LoggedInUpdate = exports.LoggedInUpdate = function (_Component) {
  (0, _inherits3.default)(LoggedInUpdate, _Component);

  function LoggedInUpdate(props) {
    (0, _classCallCheck3.default)(this, LoggedInUpdate);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LoggedInUpdate.__proto__ || (0, _getPrototypeOf2.default)(LoggedInUpdate)).call(this, props));

    _this.state = {
      firstName: '',
      lastName: '',
      email: '',
      userType: _this.props.common.userType
    };
    return _this;
  }

  (0, _createClass3.default)(LoggedInUpdate, [{
    key: 'onChange',
    value: function onChange(e, name) {
      var data = {};
      data[name] = e.target.value;
      this.setState(data);
    }
  }, {
    key: 'getActiveFields',
    value: function getActiveFields() {
      var variants = {
        fullname: {
          title: 'Please add your full name',
          helpLink: 'Why are you being asked for your name?',
          helpText: 'This section of our site requires your name as you will be interacting with schools, institutions or other members of TES in a professional context. Using your actual name here improves the service and will allow you to interact with others with greater transparency and trust.',
          validFields: ['firstName', 'lastName']
        },
        email: {
          title: 'Please add your email',
          validFields: ['email', 'userType']
        }
      };

      if (!variants[this.props.common.variant]) {
        return variants.fullname;
      }
      return variants[this.props.common.variant];
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      if (!this.props.common.isModal && !this.props.common.isInline) return;
      e.preventDefault();

      var activeFields = this.getActiveFields();
      var hasField = function hasField(name) {
        return activeFields.validFields.indexOf(name) !== -1;
      };

      var data = {};
      if (hasField('firstName')) {
        data.firstName = this.state.firstName;
      }
      if (hasField('lastName')) {
        data.lastName = this.state.lastName;
      }
      if (hasField('email')) {
        data.email = this.state.email;
      }
      if (hasField('userType')) {
        data.userType = this.state.userType;
      }
      this.props.actions.resetErrors();
      this.props.actions.updateUserData(data);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var err = this.props.errors;
      var activeFields = this.getActiveFields();
      var hasField = function hasField(name) {
        return activeFields.validFields.indexOf(name) !== -1;
      };

      return _react2.default.createElement(
        'div',
        { id: 'logged-in-update', className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
        _react2.default.createElement(
          'div',
          { className: 'heading-main margin-bottom-md text-center' },
          _react2.default.createElement(
            'h3',
            { className: 'tes-modal__heading' },
            activeFields.title
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'form',
            { autoComplete: 'off', role: 'form', onSubmit: function onSubmit(e) {
                return _this2.handleSubmit(e);
              }, className: 't-logged-in-update margin-bottom-md', method: 'post', action: '/api/authn/edit-account' },
            this.props.common.rtn ? _react2.default.createElement('input', { type: 'hidden', name: 'rtn', value: encodeURIComponent(this.props.common.rtn) }) : null,
            hasField('userType') && this.props.common.userType ? _react2.default.createElement('input', { className: 't-user-type', type: 'hidden', name: 'userType', ref: 'userType', value: this.props.common.userType }) : null,
            _react2.default.createElement('input', { type: 'hidden', name: 'appId', value: this.props.common.appId }),
            _react2.default.createElement('input', { type: 'hidden', name: '_CSRF_TOKEN', value: this.props.common.csrfToken }),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6' },
                hasField('firstName') ? _react2.default.createElement(_InputField2.default, {
                  name: 'firstName', label: 'First name', value: this.state.firstName,
                  errorClass: getErrorCls('firstName')(err),
                  errorMessage: getErrorMsg('firstName')(err),
                  onChange: function onChange(e) {
                    return _this2.onChange(e, 'firstName');
                  },
                  autoFocus: 'true'
                }) : null
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6' },
                hasField('lastName') ? _react2.default.createElement(_InputField2.default, {
                  name: 'firstName', label: 'Last name', value: this.state.lastName,
                  errorClass: getErrorCls('lastName')(err),
                  errorMessage: getErrorMsg('lastName')(err),
                  onChange: function onChange(e) {
                    return _this2.onChange(e, 'lastName');
                  }
                }) : null
              )
            ),
            hasField('email') ? _react2.default.createElement(_InputField2.default, {
              name: 'email',
              label: this.props.common.userType === 'student' ? 'Email (optional)' : 'Email',
              value: this.state.email,
              errorClass: getErrorCls('email')(err),
              errorMessage: getErrorMsg('email')(err),
              onChange: function onChange(e) {
                return _this2.onChange(e, 'email');
              }
            }) : null,
            activeFields.helpLink ? _react2.default.createElement(
              'div',
              { className: 'margin-bottom-xs' },
              _react2.default.createElement(
                'span',
                { className: 'link link--colored text-xs', title: activeFields.helpText },
                activeFields.helpLink
              )
            ) : null,
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                { type: 'submit', className: 'tes-btn tes-btn--icon tes-btn--lg tes-btn--block tes-btn--primary' },
                'Confirm'
              )
            )
          )
        )
      );
    }
  }]);
  return LoggedInUpdate;
}(_react.Component);

LoggedInUpdate.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors
  };
}, mapDispatchToProps)(LoggedInUpdate);

});
},{"../lib/getErrorFromPrefix":170,"../reducers/actions":173,"./lib/InputField":166,"async-define":8,"babel-runtime/core-js/object/get-prototype-of":15,"babel-runtime/helpers/classCallCheck":21,"babel-runtime/helpers/createClass":22,"babel-runtime/helpers/inherits":23,"babel-runtime/helpers/possibleConstructorReturn":24}],161:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Register = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require('../lib/getErrorFromPrefix');

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require('../reducers/actions');

var actionCreators = _interopRequireWildcard(_actions);

var _WidgetLink = require('./lib/WidgetLink');

var _WidgetLink2 = _interopRequireDefault(_WidgetLink);

var _HiddenInputs = require('./lib/HiddenInputs');

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

var _InputField = require('./lib/InputField');

var _InputField2 = _interopRequireDefault(_InputField);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('registration');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('registration');
var getGenericErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('generic');
var getGenericErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('generic');

var Register = exports.Register = function (_Component) {
  (0, _inherits3.default)(Register, _Component);

  function Register() {
    (0, _classCallCheck3.default)(this, Register);
    return (0, _possibleConstructorReturn3.default)(this, (Register.__proto__ || (0, _getPrototypeOf2.default)(Register)).apply(this, arguments));
  }

  (0, _createClass3.default)(Register, [{
    key: 'getGoogleLogoURL',
    value: function getGoogleLogoURL() {
      return this.props.common.cdnUrl + 'img/google-logo-g.png';
    }
  }, {
    key: 'changeField',
    value: function changeField(namepar, depspar) {
      var _this2 = this;

      var name = 'registration.' + namepar;
      var deps = depspar.map(function (n) {
        return 'registration.' + n;
      }) || [];
      return function (e) {
        var target = e.target;
        _this2.props.actions.setField('register', target.name, target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value);
        _this2.props.actions.changeField(name, deps);
        _this2.props.actions.validateField(name);
      };
    }
  }, {
    key: 'hasError',
    value: function hasError() {
      return this.props.errors ? (0, _keys2.default)(this.props.errors).filter(function (n) {
        return n.startsWith('registration.');
      }).length > 0 : false;
    }
  }, {
    key: 'handleGoogle',
    value: function handleGoogle() {
      this.props.actions.initGoogleSignIn();
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      var target = e.target;
      this.props.actions.initRegister(function () {
        target.submit(); // only called for pages
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var err = this.props.errors;
      var hasName = !this.props.common.omitName;

      return _react2.default.createElement(
        'div',
        { id: 'sign-in', className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
        _react2.default.createElement(
          'div',
          { className: 'heading-main margin-bottom-md text-center' },
          _react2.default.createElement(
            'h3',
            { className: 'tes-modal__heading' },
            'Join TES for free'
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'button',
                {
                  disabled: this.props.register.state === 'wait' || this.props.common.googleState === 'wait' ? 'disabled' : null,
                  onClick: function onClick(e) {
                    return _this3.handleGoogle(e);
                  },
                  className: 'tes-btn tes-btn--secondary tes-btn--icon tes-btn--block'
                },
                this.props.common.googleState === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner tes-btn__icon' }) : _react2.default.createElement(
                  'span',
                  { className: 'text-sm' },
                  _react2.default.createElement('img', { style: { padding: '0 6px 2px 0' }, src: this.getGoogleLogoURL() }),
                  ' Register with Google'
                )
              )
            )
          ),
          _react2.default.createElement(
            'form',
            { autoComplete: 'off', role: 'form', onSubmit: function onSubmit(e) {
                return _this3.handleSubmit(e);
              }, className: 't-register-form margin-bottom-md', method: 'post', action: '/api/authn/register-redirect' },
            _react2.default.createElement(_HiddenInputs2.default, null),
            _react2.default.createElement(
              'div',
              { className: 'separator' },
              _react2.default.createElement(
                'span',
                { className: 'separator--text bg-light' },
                'or'
              )
            ),
            hasName ? _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6' },
                _react2.default.createElement(_InputField2.default, {
                  name: 'firstName', label: 'First name', value: this.props.register.firstName,
                  errorClass: getErrorCls('firstName')(err),
                  errorMessage: getErrorMsg('firstName')(err),
                  onChange: this.changeField('firstName', [])
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6' },
                _react2.default.createElement(_InputField2.default, {
                  name: 'lastName', label: 'Last name', value: this.props.register.lastName,
                  errorClass: getErrorCls('lastName')(err),
                  errorMessage: getErrorMsg('lastName')(err),
                  onChange: this.changeField('lastName', [])
                })
              )
            ) : null,
            _react2.default.createElement(_InputField2.default, {
              name: 'email',
              label: this.props.common.userType === 'student' ? 'Email (optional)' : 'Email',
              value: this.props.register.email,
              errorClass: getErrorCls('email')(err),
              errorMessage: getErrorMsg('email')(err),
              onChange: this.changeField('email', []),
              type: 'email'
            }),
            _react2.default.createElement(_InputField2.default, {
              name: 'username',
              label: 'Username',
              value: this.props.register.username,
              errorClass: getErrorCls('username')(err),
              errorMessage: getErrorMsg('username')(err),
              onChange: this.changeField('username', [])
            }),
            _react2.default.createElement(_InputField2.default, {
              name: 'password',
              label: 'password',
              value: this.props.register.password,
              errorClass: getErrorCls('password')(err),
              errorMessage: getErrorMsg('password')(err),
              onChange: this.changeField('password', []),
              type: 'password'
            }),
            this.props.common.userType !== 'student' ? _react2.default.createElement(
              'div',
              { className: 'tes-checkbox tes-checkbox--inline text-sm margin-bottom-sm' },
              _react2.default.createElement(
                'label',
                { className: 'tes-control-label text-xs' },
                _react2.default.createElement('input', { onChange: this.changeField('newsletter', []),
                  type: 'checkbox', name: 'newsletter',
                  className: 't-newsletter',
                  value: 'true',
                  checked: this.props.register.newsletter
                }),
                ' Uncheck this box if you do not want to receive news and updates from TES'
              )
            ) : null,
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                { disabled: this.props.register.state === 'wait' || this.props.common.googleState === 'wait' ? 'disabled' : null,
                  type: 'submit', className: 'tes-btn tes-btn--icon tes-btn--lg sign-up-submit tes-btn--block tes-btn--primary'
                },
                this.props.register.state === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner icon-white tes-btn__icon' }) : 'Register'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'text-secondary col-xs-12', style: { paddingRight: 0 } },
              _react2.default.createElement(
                'div',
                { className: 'margin-bottom-md' },
                'By registering, you are agreeing to our ',
                _react2.default.createElement(
                  'a',
                  { target: '_blank', href: 'https://www.tes.com/content/terms-and-conditions' },
                  'terms and conditions'
                ),
                ' and ',
                _react2.default.createElement(
                  'a',
                  { target: '_blank', href: 'https://www.tes.com/us/privacy-policy' },
                  'privacy policy'
                )
              )
            )
          ),
          getGenericErrorCls('googlebutton')(err) ? _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'tes-has-error col-xs-12' },
              _react2.default.createElement(
                'div',
                { className: 'tes-help-block' },
                getGenericErrorMsg('googlebutton')(err)
              )
            )
          ) : null
        ),
        _react2.default.createElement(
          'div',
          { className: 'clearfix' },
          _react2.default.createElement(
            'div',
            { className: 'more-info text-center text-sm padding-top-md border-top' },
            _react2.default.createElement(
              'span',
              null,
              'Already have a TES account?'
            ),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              _WidgetLink2.default,
              { formType: 'signIn' },
              'Log in now!'
            )
          )
        )
      );
    }
  }]);
  return Register;
}(_react.Component);

Register.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  register: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    register: state.register
  };
}, mapDispatchToProps)(Register);

});
},{"../lib/getErrorFromPrefix":170,"../reducers/actions":173,"./lib/HiddenInputs":165,"./lib/InputField":166,"./lib/WidgetLink":167,"async-define":8,"babel-runtime/core-js/object/get-prototype-of":15,"babel-runtime/core-js/object/keys":16,"babel-runtime/helpers/classCallCheck":21,"babel-runtime/helpers/createClass":22,"babel-runtime/helpers/inherits":23,"babel-runtime/helpers/possibleConstructorReturn":24}],162:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _SelectForm = require('./SelectForm');

var _SelectForm2 = _interopRequireDefault(_SelectForm);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require('../reducers/actions');

var actionCreators = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Select = exports.Select = function (_Component) {
  (0, _inherits3.default)(Select, _Component);

  function Select() {
    (0, _classCallCheck3.default)(this, Select);
    return (0, _possibleConstructorReturn3.default)(this, (Select.__proto__ || (0, _getPrototypeOf2.default)(Select)).apply(this, arguments));
  }

  (0, _createClass3.default)(Select, [{
    key: 'switchTo',
    value: function switchTo(e, userType) {
      if (!this.props.common.isModal && !this.props.common.isInline) return;
      e.preventDefault();
      this.props.actions.setUserType(userType);
      this.props.actions.setFormType('register');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(_SelectForm2.default, {
        onStudentClick: function onStudentClick(e) {
          return _this2.switchTo(e, 'student');
        },
        onTeacherClick: function onTeacherClick(e) {
          return _this2.switchTo(e, 'teacher');
        },
        onOtherClick: function onOtherClick(e) {
          return _this2.switchTo(e, 'other');
        },
        action: '/authn/register',
        method: 'get'
      });
    }
  }]);
  return Select;
}(_react.Component);

Select.propTypes = {
  common: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common
  };
}, mapDispatchToProps)(Select);

});
},{"../reducers/actions":173,"./SelectForm":163,"async-define":8,"babel-runtime/core-js/object/get-prototype-of":15,"babel-runtime/helpers/classCallCheck":21,"babel-runtime/helpers/createClass":22,"babel-runtime/helpers/inherits":23,"babel-runtime/helpers/possibleConstructorReturn":24}],163:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectForm = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require('../lib/getErrorFromPrefix');

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require('../reducers/actions');

var actionCreators = _interopRequireWildcard(_actions);

var _HiddenInputs = require('./lib/HiddenInputs');

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('edit-account');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('edit-account');

var SelectForm = exports.SelectForm = function (_Component) {
  (0, _inherits3.default)(SelectForm, _Component);

  function SelectForm() {
    (0, _classCallCheck3.default)(this, SelectForm);
    return (0, _possibleConstructorReturn3.default)(this, (SelectForm.__proto__ || (0, _getPrototypeOf2.default)(SelectForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(SelectForm, [{
    key: 'onMouseOver',
    value: function onMouseOver(evt) {
      evt.target.style.opacity = '0.9';
    }
  }, {
    key: 'onMouseOut',
    value: function onMouseOut(evt) {
      evt.target.style.opacity = '1';
    }
  }, {
    key: 'render',
    value: function render() {
      var err = this.props.errors;
      var buttonStyle = { position: 'relative', marginTop: -25 };
      var imgStyle = { width: '100%' }; // for FF on MAC

      return _react2.default.createElement(
        'div',
        { className: 'padding-left-md padding-right-md t-select-form' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-6' },
            _react2.default.createElement(
              'form',
              { className: 't-student-form app-authentication-select-form',
                action: this.props.action, method: this.props.method,
                onSubmit: this.props.onStudentClick
              },
              _react2.default.createElement('input', { className: 't-userType', type: 'hidden', name: 'userType', value: 'student' }),
              _react2.default.createElement(_HiddenInputs2.default, { isGetRequest: this.props.method.toLowerCase() === 'get', noUserType: true }),
              _react2.default.createElement(
                'button',
                { className: 'tes-btn' },
                _react2.default.createElement('img', {
                  onMouseOver: this.onMouseOver,
                  onMouseOut: this.onMouseOut,
                  height: '442',
                  width: '370',
                  className: 'img-responsive',
                  title: 'Student',
                  alt: 'Student',
                  style: imgStyle,
                  src: this.props.common.cdnUrl + 'img/student2x.png'
                })
              ),
              _react2.default.createElement(
                'button',
                {
                  className: 'tes-btn tes-btn--primary tes-btn--block tes-btn--xl hidden-xs t-switch-student',
                  style: buttonStyle
                },
                _react2.default.createElement(
                  'strong',
                  null,
                  'I\'m a student'
                )
              ),
              _react2.default.createElement(
                'button',
                {
                  className: 'tes-btn tes-btn--primary tes-btn--block tes-btn--sm visible-xs',
                  style: buttonStyle
                },
                _react2.default.createElement(
                  'strong',
                  null,
                  'I\'m a student'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-6' },
            _react2.default.createElement(
              'form',
              { className: 't-teacher-form app-authentication-select-form',
                action: this.props.action, method: this.props.method,
                onSubmit: this.props.onTeacherClick
              },
              _react2.default.createElement('input', { className: 't-userType', type: 'hidden', name: 'userType', value: 'teacher' }),
              _react2.default.createElement(_HiddenInputs2.default, { isGetRequest: this.props.method.toLowerCase() === 'get', noUserType: true }),
              _react2.default.createElement(
                'button',
                { className: 'tes-btn' },
                _react2.default.createElement('img', {
                  onMouseOver: this.onMouseOver,
                  onMouseOut: this.onMouseOut,
                  height: '442',
                  width: '370',
                  className: 'img-responsive',
                  title: 'Teacher',
                  alt: 'Teacher',
                  style: imgStyle,
                  src: this.props.common.cdnUrl + 'img/teacher2x.png'
                })
              ),
              _react2.default.createElement(
                'button',
                {
                  className: 'tes-btn tes-btn--primary tes-btn--block tes-btn--xl hidden-xs t-switch-teacher',
                  style: buttonStyle
                },
                _react2.default.createElement(
                  'strong',
                  null,
                  'I\'m a teacher'
                )
              ),
              _react2.default.createElement(
                'button',
                {
                  className: 'tes-btn tes-btn--primary tes-btn--block tes-btn--sm visible-xs',
                  style: buttonStyle
                },
                _react2.default.createElement(
                  'strong',
                  null,
                  'I\'m a teacher'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 text-center text-sm' },
            _react2.default.createElement(
              'div',
              { className: 'border-top padding-top-sm margin-top-md' },
              _react2.default.createElement(
                'form',
                { className: 'app-authentication-select-form t-other-form',
                  action: this.props.action, method: this.props.method,
                  onSubmit: this.props.onOtherClick
                },
                _react2.default.createElement('input', { className: 't-userType', type: 'hidden', name: 'userType', value: 'other' }),
                _react2.default.createElement(_HiddenInputs2.default, { isGetRequest: this.props.method.toLowerCase() === 'get', noUserType: true }),
                _react2.default.createElement(
                  'button',
                  { className: 'tes-btn link link--coloured t-switch-other' },
                  'I\'m a parent, school leader, student teacher, or someone else'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: getErrorCls('message')(err) },
          _react2.default.createElement(
            'div',
            { className: 'tes-help-block text-center' },
            getErrorMsg('message')(err)
          )
        )
      );
    }
  }]);
  return SelectForm;
}(_react.Component);

SelectForm.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  onStudentClick: _react.PropTypes.func.isRequired,
  onTeacherClick: _react.PropTypes.func.isRequired,
  onOtherClick: _react.PropTypes.func.isRequired,
  action: _react.PropTypes.string.isRequired,
  method: _react.PropTypes.string.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors
  };
}, mapDispatchToProps)(SelectForm);

});
},{"../lib/getErrorFromPrefix":170,"../reducers/actions":173,"./lib/HiddenInputs":165,"async-define":8,"babel-runtime/core-js/object/get-prototype-of":15,"babel-runtime/helpers/classCallCheck":21,"babel-runtime/helpers/createClass":22,"babel-runtime/helpers/inherits":23,"babel-runtime/helpers/possibleConstructorReturn":24}],164:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Signin = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require('../lib/getErrorFromPrefix');

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require('../reducers/actions');

var actionCreators = _interopRequireWildcard(_actions);

var _WidgetLink = require('./lib/WidgetLink');

var _WidgetLink2 = _interopRequireDefault(_WidgetLink);

var _HiddenInputs = require('./lib/HiddenInputs');

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

var _InputField = require('./lib/InputField');

var _InputField2 = _interopRequireDefault(_InputField);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('signin');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('signin');
var getGenericErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('generic');
var getGenericErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('generic');

var Signin = exports.Signin = function (_Component) {
  (0, _inherits3.default)(Signin, _Component);

  function Signin() {
    (0, _classCallCheck3.default)(this, Signin);
    return (0, _possibleConstructorReturn3.default)(this, (Signin.__proto__ || (0, _getPrototypeOf2.default)(Signin)).apply(this, arguments));
  }

  (0, _createClass3.default)(Signin, [{
    key: 'getGoogleLogoURL',
    value: function getGoogleLogoURL() {
      return this.props.common.cdnUrl + 'img/google-logo-g.png';
    }
  }, {
    key: 'handleGoogle',
    value: function handleGoogle() {
      this.props.actions.initGoogleSignIn();
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      var target = e.target;

      this.props.actions.initSignIn(function () {
        target.submit();
      });
    }
  }, {
    key: 'hasError',
    value: function hasError() {
      return this.props.errors ? (0, _keys2.default)(this.props.errors).filter(function (n) {
        return n.startsWith('signin.');
      }).length > 0 : false;
    }
  }, {
    key: 'changeField',
    value: function changeField(namepar, depspar) {
      var _this2 = this;

      var name = 'signin.' + namepar;
      var deps = depspar.map(function (n) {
        return 'signin.' + n;
      }) || [];
      return function (e) {
        var target = e.target;
        _this2.props.actions.setField('signIn', target.name, target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value);
        _this2.props.actions.changeField(name, deps);
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var err = this.props.errors;

      return _react2.default.createElement(
        'div',
        { id: 'sign-in', className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
        _react2.default.createElement(
          'div',
          { className: 'heading-main margin-bottom-md text-center' },
          _react2.default.createElement(
            'h3',
            { className: 'tes-modal__heading' },
            'Please log in'
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'button',
                {
                  disabled: this.props.signIn.state === 'wait' || this.props.common.googleState === 'wait' ? 'disabled' : null,
                  onClick: function onClick(e) {
                    return _this3.handleGoogle(e);
                  },
                  className: 'tes-btn tes-btn--secondary tes-btn--icon tes-btn--block'
                },
                this.props.common.googleState === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner tes-btn__icon' }) : _react2.default.createElement(
                  'span',
                  { className: 'text-sm' },
                  _react2.default.createElement('img', { style: { padding: '0 6px 2px 0' }, src: this.getGoogleLogoURL() }),
                  ' Log in with Google'
                )
              )
            )
          ),
          _react2.default.createElement(
            'form',
            { autoComplete: 'off', onSubmit: function onSubmit(e) {
                return _this3.handleSubmit(e);
              }, role: 'form', className: 't-sign-in-form margin-bottom-sm', method: 'post', action: '/api/authn/sign-in-redirect' },
            _react2.default.createElement(_HiddenInputs2.default, null),
            _react2.default.createElement(
              'div',
              { className: 'separator' },
              _react2.default.createElement(
                'span',
                { className: 'separator--text bg-light' },
                'or'
              )
            ),
            _react2.default.createElement(_InputField2.default, {
              name: 'identification',
              label: 'Username or email',
              icon: 'user',
              value: this.props.signIn.identification,
              errorClass: getErrorCls('userName')(err),
              errorMessage: getErrorMsg('userName')(err),
              onChange: this.changeField('userName', ['password']),
              autoFocus: 'true',
              autoComplete: 'off'
            }),
            _react2.default.createElement(_InputField2.default, {
              name: 'password',
              label: 'Password',
              icon: 'lock',
              value: this.props.signIn.password,
              errorClass: getErrorCls('password')(err),
              errorMessage: getErrorMsg('password')(err),
              onChange: this.changeField('password', ['userName']),
              type: 'password',
              autoComplete: 'off'
            }),
            _react2.default.createElement(
              'div',
              { className: 'text-sm margin-bottom-md margin-top-md' },
              _react2.default.createElement(
                'div',
                { className: 'tes-checkbox tes-checkbox--inline' },
                _react2.default.createElement(
                  'label',
                  { className: 'tes-control-label', title: 'This shouldn\'t be used on a shared computer' },
                  _react2.default.createElement('input', { type: 'checkbox',
                    name: 'trustedComputer',
                    value: 'true',
                    checked: this.props.signIn.trustedComputer,
                    onChange: this.changeField('trustedComputer', [])
                  }),
                  ' Stay logged in'
                )
              ),
              _react2.default.createElement(
                _WidgetLink2.default,
                { formType: 'forgotPassword' },
                'Forgot password?'
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                {
                  disabled: this.props.signIn.state === 'wait' || this.props.common.googleState === 'wait' ? 'disabled' : null,
                  type: 'submit', className: 'tes-btn tes-btn--lg sign-in-submit tes-btn--icon tes-btn--block tes-btn--primary'
                },
                this.props.signInstate === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner icon-white tes-btn__icon' }) : 'Log in'
              )
            )
          ),
          getGenericErrorCls('googlebutton')(err) ? _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 tes-has-error' },
              _react2.default.createElement(
                'div',
                { className: 'tes-help-block' },
                getGenericErrorMsg('googlebutton')(err)
              )
            )
          ) : null
        ),
        _react2.default.createElement(
          'div',
          { className: 'clearfix' },
          _react2.default.createElement(
            'div',
            { className: 'more-info text-center text-sm padding-top-sm' },
            _react2.default.createElement(
              'span',
              null,
              'Not a member yet?'
            ),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              _WidgetLink2.default,
              { formType: 'register' },
              'Join us for free'
            )
          )
        )
      );
    }
  }]);
  return Signin;
}(_react.Component);

Signin.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  signIn: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    signIn: state.signIn
  };
}, mapDispatchToProps)(Signin);

});
},{"../lib/getErrorFromPrefix":170,"../reducers/actions":173,"./lib/HiddenInputs":165,"./lib/InputField":166,"./lib/WidgetLink":167,"async-define":8,"babel-runtime/core-js/object/get-prototype-of":15,"babel-runtime/core-js/object/keys":16,"babel-runtime/helpers/classCallCheck":21,"babel-runtime/helpers/createClass":22,"babel-runtime/helpers/inherits":23,"babel-runtime/helpers/possibleConstructorReturn":24}],165:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HiddenInputs = HiddenInputs;

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __react_redux;

var _tracking = require('../../lib/tracking');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HiddenInputs(_ref) {
  var common = _ref.common;
  var isGetRequest = _ref.isGetRequest;
  var noUserType = _ref.noUserType;

  var pageContext = (0, _tracking.getPageContext)(common.pageMz, common.overrideMz);

  var pageContextInputs = ['pageId', 'pageType', 'pageSection', 'pageSubSection'].filter(function (name) {
    return pageContext && pageContext[name];
  }).map(function (name) {
    return _react2.default.createElement('input', { type: 'hidden', key: name, name: name, value: pageContext[name] });
  });

  return _react2.default.createElement(
    'span',
    null,
    pageContextInputs,
    common.rtn ? _react2.default.createElement('input', { type: 'hidden', name: 'rtn', value: common.rtn }) : null,
    !noUserType && common.userType ? _react2.default.createElement('input', { className: 't-user-type', type: 'hidden', name: 'userType', value: common.userType }) : null,
    common.regUrl ? _react2.default.createElement('input', { className: 't-reg-url', type: 'hidden', name: 'regUrl', value: common.regUrl }) : null,
    _react2.default.createElement('input', { type: 'hidden', name: 'appId', value: common.appId }),
    !isGetRequest ? _react2.default.createElement('input', { type: 'hidden', name: '_CSRF_TOKEN', value: common.csrfToken }) : null,
    common.doSelectUserType ? _react2.default.createElement('input', { className: 't-select', type: 'hidden', name: 'select', value: 'true' }) : null,
    common.omitName ? _react2.default.createElement('input', { type: 'hidden', name: 'omitName', value: common.omitName }) : null
  );
}

HiddenInputs.propTypes = {
  common: _react.PropTypes.object.isRequired,
  isGetRequest: _react.PropTypes.bool,
  noUserType: _react.PropTypes.bool
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common
  };
})(HiddenInputs);

});
},{"../../lib/tracking":171,"async-define":8}],166:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __react;

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function InputGroup(_ref) {
  var icon = _ref.icon;
  var children = _ref.children;

  if (!icon) return _react2.default.createElement(
    "div",
    null,
    children
  );
  return _react2.default.createElement(
    "div",
    { className: "tes-input-group" },
    _react2.default.createElement(
      "span",
      { className: "tes-input-group__addon" },
      _react2.default.createElement("i", { className: "icon icon-" + icon })
    ),
    children
  );
}

InputGroup.propTypes = {
  icon: _react.PropTypes.string
};

function InputField(_ref2) {
  var errorClass = _ref2.errorClass;
  var errorMessage = _ref2.errorMessage;
  var label = _ref2.label;
  var value = _ref2.value;
  var name = _ref2.name;
  var onChange = _ref2.onChange;
  var type = _ref2.type;
  var icon = _ref2.icon;
  var autoFocus = _ref2.autoFocus;
  var autoComplete = _ref2.autoComplete;

  var id = "auth-" + name;
  var widgetType = type || 'text';
  return _react2.default.createElement(
    "div",
    { className: errorClass },
    _react2.default.createElement(
      InputGroup,
      { icon: icon },
      _react2.default.createElement(
        "label",
        { className: "tes-control-label tes-control-label--hidden", htmlFor: id },
        label
      ),
      _react2.default.createElement("input", { onChange: onChange, id: id, type: widgetType,
        name: name,
        placeholder: label,
        className: "tes-control",
        value: value,
        autoFocus: autoFocus,
        autoComplete: autoComplete
      })
    ),
    _react2.default.createElement(
      "div",
      { className: "tes-help-block" },
      errorMessage
    )
  );
}

InputField.propTypes = {
  errorClass: _react.PropTypes.string.isRequired,
  errorMessage: _react.PropTypes.string.isRequired,
  label: _react.PropTypes.string.isRequired,
  icon: _react.PropTypes.string,
  value: _react.PropTypes.string.isRequired,
  name: _react.PropTypes.string.isRequired,
  type: _react.PropTypes.string,
  onChange: _react.PropTypes.func.isRequired,
  autoFocus: _react.PropTypes.string,
  autoComplete: _react.PropTypes.string
};

exports.default = InputField;

});
},{"async-define":8}],167:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetLink = WidgetLink;

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require('../../reducers/actions');

var actionCreators = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WidgetLink(_ref) {
  var common = _ref.common;
  var formType = _ref.formType;
  var children = _ref.children;
  var actions = _ref.actions;

  var registerPages = {
    signIn: 'sign-in',
    forgotPassword: 'forgot-password',
    register: common.doSelectUserType ? 'select' : 'register'
  };

  var registerPage = registerPages[formType];

  var switchTo = function switchTo(e) {
    if (!common.isModal && !common.isInline) return;
    e.preventDefault();
    actions.initSetFormType(registerPage);
  };

  var encodedRtn = encodeURIComponent(common.rtn);
  var encodedRegUrl = encodeURIComponent(common.regUrl);

  var qs = [];
  if (common.rtn) {
    qs.push('rtn=' + encodedRtn);
  }
  if (common.doSelectUserType) {
    qs.push('select=true');
  }
  if ('id' in common.overrideMz) {
    qs.push('pageId=' + common.overrideMz.id);
  }
  if ('type' in common.overrideMz) {
    qs.push('pageType=' + common.overrideMz.type);
  }
  if ('section' in common.overrideMz) {
    qs.push('pageSection=' + common.overrideMz.section);
  }
  if ('subsection' in common.overrideMz) {
    qs.push('pageSubSection=' + common.overrideMz.subsection);
  }
  if (common.regUrl) {
    qs.push('regUrl=' + encodedRegUrl);
  }
  if (common.omitName) {
    qs.push('omitName=' + common.omitName);
  }

  var baseURLs = {
    signIn: '/authn/sign-in',
    forgotPassword: '/authn/forgot-password',
    register: '/authn/' + registerPage
  };

  var baseURL = baseURLs[formType];
  var url = qs.length ? baseURL + '?' + qs.join('&') : baseURL;
  var extraClass = formType === 'forgotPassword' ? ' pull-right' : '';
  return _react2.default.createElement(
    'a',
    { onClick: switchTo, href: url, className: 't-switch-form' + extraClass },
    children
  );
}

WidgetLink.propTypes = {
  common: _react.PropTypes.object.isRequired,
  actions: _react.PropTypes.object.isRequired,
  formType: _react.PropTypes.string.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common
  };
}, mapDispatchToProps)(WidgetLink);

});
},{"../../reducers/actions":173,"async-define":8}],168:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _reqwest = require('reqwest');

var _reqwest2 = _interopRequireDefault(_reqwest);

var _retry = require('async-deco/promise/retry');

var _retry2 = _interopRequireDefault(_retry);

var _memoize = require('async-deco/promise/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

var _es6PromisePolyfill = require('es6-promise-polyfill');

var _es6PromisePolyfill2 = _interopRequireDefault(_es6PromisePolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-console */
try {
  window.Promise = _es6PromisePolyfill2.default.Promise;
} catch (e) {
  // nothing
}

var getOrigin = function getOrigin() {
  if (window.location.origin) {
    return window.location.origin;
  }
  var port = window.location.port ? ':' + window.location.port : '';
  var protocol = window.location.protocol;
  var hostname = window.location.hostname;
  return protocol + '//' + hostname + port;
};

var XHRTIMEOUT_WITH_RETRY = 9000;
var XHRTIMEOUT_WITHOUT_RETRY = 20000;

var defaultParams = {
  type: 'json',
  contentType: 'application/json',
  headers: {
    accept: 'application/json',
    'x-auth-api-version': '2'
  }
};

function postRequest(endpoint, data, times) {
  var requestFunction = void 0;
  var timeout = void 0;
  if (times) {
    (function () {
      var t0 = new Date();
      var retry = (0, _retry2.default)(times, 100, function (err) {
        return err && err.status === 0;
      }, function () {
        return function (t, o) {
          var t1 = new Date();
          console.log('app-authentication: api trying ' + o.times + ' after ' + (t1 - t0) + ' ms');
        };
      });
      requestFunction = retry(_reqwest2.default);
      timeout = XHRTIMEOUT_WITH_RETRY;
    })();
  } else {
    requestFunction = _reqwest2.default;
    timeout = XHRTIMEOUT_WITHOUT_RETRY;
  }

  var _ref = document.cookie.match(/csrf=([^;]*)/) || [];

  var _ref2 = (0, _slicedToArray3.default)(_ref, 2);

  var match = _ref2[0];
  var csrfToken = _ref2[1];


  return requestFunction((0, _assign2.default)({}, defaultParams, {
    url: endpoint,
    method: 'POST',
    timeout: timeout,
    data: (0, _stringify2.default)(data),
    headers: (0, _assign2.default)({}, defaultParams.headers, match && csrfToken ? {
      'x-csrf-token': match && csrfToken
    } : {})
  }));
}

var memoize = (0, _memoize2.default)(function (d) {
  try {
    return d.data.email ? d.data.email : null;
  } catch (e) {
    return null;
  }
});
var cachedReqwest = memoize(_reqwest2.default);

function getRequest(endpoint, data) {
  var timeout = XHRTIMEOUT_WITHOUT_RETRY;

  return cachedReqwest((0, _assign2.default)({}, defaultParams, {
    url: endpoint,
    method: 'GET',
    timeout: timeout,
    data: data
  }));
}

var events = function getEvents() {
  try {
    return window.TES.events;
  } catch (e) {
    return {
      on: function on() {},
      trigger: function trigger() {}
    };
  }
}();

var api = {
  verifyUsername: function verifyUsername(username) {
    return getRequest('/api/authn/find-user', { username: username });
  },
  verifyEmail: function verifyEmail(email) {
    return getRequest('/api/authn/find-user', { email: email });
  },
  signIn: function signIn(data) {
    return postRequest('/api/authn/sign-in-redirect', data, 4);
  },
  register: function register(data) {
    return postRequest('/api/authn/register-redirect', data);
  },
  googleSignIn: function googleSignIn(data) {
    return new _promise2.default(function (resolve, reject) {
      var params = (0, _keys2.default)(data).filter(function (k) {
        return !!data[k];
      }).map(function (k) {
        return [k, encodeURIComponent(data[k])];
      }).map(function (t) {
        return t[0] + '=' + t[1];
      }).join('&');

      var path = '/oauth/google?' + params;

      if (!data.isModal) {
        return window.location.assign(path);
      }

      var done = false;

      var googlePopup = window.open(path, '', 'location=0,status=0,width=600,height=500');

      function onMessage(evt) {
        var msg = void 0;
        if (evt.origin !== getOrigin()) return;
        try {
          msg = (0, _typeof3.default)(evt.data) === 'object' ? evt.data : JSON.parse(evt.data);
        } catch (e) {
          // ie9 returns evt.data === undefined, but I won't care!!!!
          // this is also the case of non JSON messages
          return;
        }
        if (msg.sender !== 'googlepopup') {
          return;
        }
        if (msg.status === 'ok' || msg.status === 'error') {
          done = true;
          window.removeEventListener('message', onMessage);
          googlePopup.close();
        }
        if (msg.status === 'ok') {
          resolve();
        }
        if (msg.status === 'error') {
          reject(new Error(msg.errorCode));
        }
      }

      window.addEventListener('message', onMessage);

      var _oauthInterval = window.setInterval(function () {
        var fireError = function fireError(errorCode) {
          if (!done) {
            reject(new Error(errorCode));
          }
          window.removeEventListener('message', onMessage);
          window.clearInterval(_oauthInterval);
        };
        try {
          if (!googlePopup) {
            fireError('google.popup.blocked');
          } else if (googlePopup.closed) {
            fireError('google.popup.closed');
          }
        } catch (e) {
          // ie fires error here
        }
      }, 1000);
    });
  },
  forgotPassword: function forgotPassword(data) {
    return postRequest('/api/authn/forgot-password', data);
  },
  updateUserData: function updateUserData(data) {
    return postRequest('/api/authn/edit-account', data);
  },
  reload: function reload() {
    window.location.reload(true);
  },
  loggedInEvent: function loggedInEvent() {
    events.trigger('logged-in');
  },
  closeModalEvent: function closeModalEvent() {
    events.trigger('modal-close', 'authapp');
  }
};

exports.default = api;

});
},{"async-deco/promise/memoize":1,"async-deco/promise/retry":2,"async-define":8,"babel-runtime/core-js/json/stringify":11,"babel-runtime/core-js/object/assign":12,"babel-runtime/core-js/object/keys":16,"babel-runtime/core-js/promise":18,"babel-runtime/helpers/slicedToArray":25,"babel-runtime/helpers/typeof":26,"es6-promise-polyfill":130,"reqwest":154}],169:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authDenied = authDenied;
exports.forgotPasswordDenied = forgotPasswordDenied;
var bannedStates = {
  2: 'banned',
  3: 'disapproved',
  4: 'possible spam activity',
  5: 'locked out'
};

function getResponse(err) {
  if ('response' in err || 'responseText' in err) {
    try {
      return JSON.parse(err.response || err.responseText);
    } catch (e) {
      return undefined;
    }
  } else {
    return err;
  }
}

function authDenied(err) {
  if (err.status === 401) {
    return 'signin.unauthorized';
  }
  if (err.status === 403) {
    var response = getResponse(err);
    if (response && 'data' in response && response.data.code && response.data.code in bannedStates) {
      return 'signin.' + bannedStates[response.data.code];
    }
    return 'signin.generic.banned';
  }
}

function forgotPasswordDenied(err) {
  if (err.status === 404) {
    return 'forgot-password.user.not-found';
  }
  if (err.status === 403) {
    var response = getResponse(err);
    if (response && 'data' in response && response.data.code && response.data.code in bannedStates) {
      return 'forgot-password.' + bannedStates[response.data.code];
    }
    return 'forgot-password.generic.banned';
  }
}

});
},{"async-define":8}],170:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrorMsgFromPrefix = getErrorMsgFromPrefix;
exports.getErrorClsFromPrefix = getErrorClsFromPrefix;
function getErrorMsgFromPrefix(prefix) {
  return function (_field) {
    var field = prefix + '.' + _field;
    return function (err) {
      return err && field in err ? err[field].msg : '';
    };
  };
}

function getErrorClsFromPrefix(prefix) {
  return function (_field) {
    var field = prefix + '.' + _field;
    return function (err) {
      return err && field in err && err[field].state === 'error' ? ' tes-has-error' : '';
    };
  };
}

});
},{"async-define":8}],171:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackClick = trackClick;
exports.trackDisplay = trackDisplay;
exports.trackError = trackError;
exports.trackForgotPassword = trackForgotPassword;
exports.trackLogin = trackLogin;
exports.trackRegister = trackRegister;
exports.getTrackingType = getTrackingType;
exports.getPageContext = getPageContext;
/* global _mz:false, _mze:false */

function hasMz() {
  try {
    return !!_mz;
  } catch (e) {
    return false;
  }
}

function trackClick(formType) {
  if (!hasMz()) return;
  var eventTitle = void 0;
  if (formType === 'sign-in') {
    eventTitle = 'login';
  } else if (formType === 'register' || formType === 'select') {
    eventTitle = 'register';
  }
  if (eventTitle) {
    _mz.emit(_mze.CLICK, {
      module: {
        type: 'auth-links'
      },
      eventTitle: eventTitle
    });
  }
}

function trackDisplay(formType, type, userType) {
  if (!hasMz()) return;
  var eventTitle = {
    'sign-in': 'tes-login',
    register: 'register',
    'forgot-password': 'forgot-password',
    select: 'tes-account-type'
  };
  var event = {
    id: eventTitle[formType] || 'tes-login',
    module: {
      type: type
    }
  };

  if (userType) {
    event.variant = userType;
  }

  _mz.emit(_mze.DISPLAY, event);
}

function trackError(id, msg, type) {
  if (!hasMz()) return;
  var evt = id === 'register-fail' ? _mze.REGISTER_FAIL : _mze.LOGIN_FAIL;
  _mz.emit(evt, {
    id: id,
    payload: {
      message: msg
    },
    module: {
      type: type
    }
  });
}

function trackForgotPassword(type, cb) {
  if (!hasMz()) return cb && cb();
  _mz.emit(_mze.SUBMIT, {
    id: 'forgot-password',
    module: {
      type: type
    }
  }, cb);
}

function trackLogin(id, type, cb) {
  if (!hasMz()) return cb && cb();
  _mz.emit(_mze.LOGIN, {
    id: id,
    module: {
      type: type
    }
  }, cb);
}

function trackRegister(type, cb) {
  if (!hasMz()) return cb && cb();
  _mz.emit(_mze.REGISTER, {
    id: 'register',
    module: {
      type: type
    },
    tags: ['funnel']
  }, cb);
}

function getTrackingType(isModal, isInline) {
  if (isModal) {
    return 'modal';
  } else if (isInline) {
    return 'embed';
  }
  return 'standalone';
}

function getPageContext(pageMetadata, overridePageMetadata) {
  var meta = {};

  if ('id' in overridePageMetadata || 'id' in pageMetadata) {
    meta.pageId = overridePageMetadata.id || pageMetadata.id;
  }

  if ('type' in overridePageMetadata || 'type' in pageMetadata) {
    meta.pageType = overridePageMetadata.type || pageMetadata.type;
  }

  if ('section' in overridePageMetadata || 'section' in pageMetadata) {
    meta.pageSection = overridePageMetadata.section || pageMetadata.section;
  }

  if ('subsection' in overridePageMetadata || 'subsection' in pageMetadata) {
    meta.pageSubSection = overridePageMetadata.subsection || pageMetadata.subsection;
  }

  return meta;
}

});
},{"async-define":8}],172:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = traverseObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function traverseObject(obj, key) {
  if ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) !== 'object') {
    return undefined;
  }
  for (var k in obj) {
    if (key === k) {
      return obj[key];
    }
    var value = traverseObject(obj[k], key);
    if (value) {
      return value;
    }
  }
  return undefined;
}

});
},{"async-define":8,"babel-runtime/helpers/typeof":26}],173:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reset = reset;
exports.initSetFormType = initSetFormType;
exports.setFormType = setFormType;
exports.updateUserData = updateUserData;
exports.validationErrors = validationErrors;
exports.setUserType = setUserType;
exports.successGoogleSignIn = successGoogleSignIn;
exports.successSignIn = successSignIn;
exports.successRegister = successRegister;
exports.failSignIn = failSignIn;
exports.failRegister = failRegister;
exports.failForgotPassword = failForgotPassword;
exports.failGoogleSignIn = failGoogleSignIn;
exports.initSignIn = initSignIn;
exports.initRegister = initRegister;
exports.initGoogleSignIn = initGoogleSignIn;
exports.initForgotPassword = initForgotPassword;
exports.sentForgotPassword = sentForgotPassword;
exports.successForgotPassword = successForgotPassword;
exports.validateField = validateField;
exports.changeField = changeField;
exports.setField = setField;
exports.resetErrors = resetErrors;
exports.suggestUserName = suggestUserName;
exports.trackClick = trackClick;
exports.trackDisplay = trackDisplay;

var _constants = require('./constants');

var constant = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Action Creators
function reset() {
  return { type: constant.RESET };
}

function initSetFormType(formType) {
  return { type: constant.INIT_SET_FORM_TYPE, formType: formType };
}

function setFormType(formType) {
  return { type: constant.SET_FORM_TYPE, formType: formType };
}

function updateUserData(data) {
  return { type: constant.UPDATE_USER_DATA, data: data };
}

function validationErrors(errors) {
  return { type: constant.VALIDATION_ERRORS, errors: errors };
}

function setUserType(userType) {
  return { type: constant.SET_USER_TYPE, userType: userType };
}

function successGoogleSignIn() {
  return { type: constant.SUCCESS_GOOGLE_SIGN_IN };
}

function successSignIn() {
  return { type: constant.SUCCESS_SIGN_IN };
}

function successRegister() {
  return { type: constant.SUCCESS_REGISTER };
}

function failSignIn(errors) {
  return { type: constant.FAIL_SIGN_IN, errors: errors };
}

function failRegister(errors) {
  return { type: constant.FAIL_REGISTER, errors: errors };
}

function failForgotPassword(errors) {
  return { type: constant.FAIL_FORGOT_PASSWORD, errors: errors };
}

function failGoogleSignIn(errors) {
  return { type: constant.FAIL_GOOGLE_SIGN_IN, errors: errors };
}

function initSignIn(callback) {
  return { type: constant.INIT_SIGN_IN, callback: callback };
}

function initRegister(callback) {
  return { type: constant.INIT_REGISTER, callback: callback };
}

function initGoogleSignIn() {
  return { type: constant.INIT_GOOGLE_SIGN_IN };
}

function initForgotPassword() {
  return { type: constant.INIT_FORGOT_PASSWORD };
}

function sentForgotPassword() {
  return { type: constant.SENT_FORGOT_PASSWORD };
}

function successForgotPassword() {
  return { type: constant.SUCCESS_FORGOT_PASSWORD };
}

function validateField(name) {
  return { type: constant.VALIDATE_FIELD, name: name };
}

function changeField(name, deps) {
  return { type: constant.CHANGE_FIELD, name: name, deps: deps };
}

function setField(form, name, value) {
  return { type: constant.SET_FIELD, form: form, name: name, value: value };
}

function resetErrors() {
  return { type: constant.RESET_ERRORS };
}

function suggestUserName(username) {
  return { type: constant.SUGGEST_USER_NAME, username: username };
}

function trackClick(formType) {
  return { type: constant.TRACK_CLICK, formType: formType };
}

function trackDisplay(formType) {
  return { type: constant.TRACK_DISPLAY, formType: formType };
}

});
},{"./constants":174,"async-define":8}],174:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var RESET = exports.RESET = 'RESET';
var INIT_SET_FORM_TYPE = exports.INIT_SET_FORM_TYPE = 'INIT_SET_FORM_TYPE';
var SET_FORM_TYPE = exports.SET_FORM_TYPE = 'SET_FORM_TYPE';
var SET_USER_TYPE = exports.SET_USER_TYPE = 'SET_USER_TYPE';
var UPDATE_USER_DATA = exports.UPDATE_USER_DATA = 'UPDATE_USER_DATA';

var VALIDATION_ERRORS = exports.VALIDATION_ERRORS = 'VALIDATION_ERRORS';

var SUCCESS_GOOGLE_SIGN_IN = exports.SUCCESS_GOOGLE_SIGN_IN = 'SUCCESS_GOOGLE_SIGN_IN';
var SUCCESS_SIGN_IN = exports.SUCCESS_SIGN_IN = 'SUCCESS_SIGN_IN';
var SUCCESS_REGISTER = exports.SUCCESS_REGISTER = 'SUCCESS_REGISTER';
var SUCCESS_FORGOT_PASSWORD = exports.SUCCESS_FORGOT_PASSWORD = 'SUCCESS_FORGOT_PASSWORD';

var INIT_SIGN_IN = exports.INIT_SIGN_IN = 'INIT_SIGN_IN';
var INIT_REGISTER = exports.INIT_REGISTER = 'INIT_REGISTER';
var INIT_GOOGLE_SIGN_IN = exports.INIT_GOOGLE_SIGN_IN = 'INIT_GOOGLE_SIGN_IN';

var FAIL_SIGN_IN = exports.FAIL_SIGN_IN = 'FAIL_SIGN_IN';
var FAIL_REGISTER = exports.FAIL_REGISTER = 'FAIL_REGISTER';
var FAIL_FORGOT_PASSWORD = exports.FAIL_FORGOT_PASSWORD = 'FAIL_FORGOT_PASSWORD';
var FAIL_GOOGLE_SIGN_IN = exports.FAIL_GOOGLE_SIGN_IN = 'FAIL_GOOGLE_SIGN_IN';

var INIT_FORGOT_PASSWORD = exports.INIT_FORGOT_PASSWORD = 'INIT_FORGOT_PASSWORD';
var SENT_FORGOT_PASSWORD = exports.SENT_FORGOT_PASSWORD = 'SENT_FORGOT_PASSWORD';

var VALIDATE_FIELD = exports.VALIDATE_FIELD = 'VALIDATE_FIELD';
var CHANGE_FIELD = exports.CHANGE_FIELD = 'CHANGE_FIELD';
var SET_FIELD = exports.SET_FIELD = 'SET_FIELD';

var RESET_ERRORS = exports.RESET_ERRORS = 'RESET_ERRORS';
var SUGGEST_USER_NAME = exports.SUGGEST_USER_NAME = 'SUGGEST_USER_NAME';

var TRACK_DISPLAY = exports.TRACK_DISPLAY = 'TRACK_DISPLAY';
var TRACK_CLICK = exports.TRACK_CLICK = 'TRACK_CLICK';

});
},{"async-define":8}],175:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.default = reducer;

var _constants = require('./constants');

var constant = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  common: {},
  register: {
    firstName: '',
    lastName: '',
    email: '',
    username: '',
    password: '',
    newsletter: false,
    autoFillUsername: true,
    state: null
  },
  signIn: {
    identification: '',
    password: '',
    trustedComputer: false,
    state: null
  },
  forgotPassword: {
    identification: '',
    state: null
  },
  errors: {}
};

function extend(state, obj) {
  var s = {};
  (0, _keys2.default)(obj).forEach(function (attr) {
    s[attr] = (0, _assign2.default)({}, state[attr], obj[attr]);
  });
  return (0, _assign2.default)({}, state, s);
}

// Reducer
function reset(state) {
  var newState = {
    errors: {},
    common: (0, _assign2.default)({}, state.common, { googleState: null }),
    register: initialState.register,
    signIn: initialState.signIn,
    forgotPassword: initialState.forgotPassword
  };
  newState.signIn.trustedComputer = state.common.isMobile;
  return (0, _assign2.default)({}, state, newState);
}

function resetErrors(state) {
  return (0, _assign2.default)({}, state, { errors: {} });
}

function setFormType(state, action) {
  return extend(state, { common: { formType: action.formType } });
}

function setUserType(state, action) {
  return extend(state, { common: { userType: action.userType } });
}

function validationErrors(state, action) {
  return extend(state, { errors: action.errors });
}

function initSignIn(state) {
  return extend(resetErrors(state), { signIn: { state: 'wait' } });
}

function initRegister(state) {
  return extend(resetErrors(state), { register: { state: 'wait' } });
}

function initGoogleSignIn(state) {
  return extend(resetErrors(state), { common: { googleState: 'wait' } });
}

function initForgotPassword(state) {
  return extend(resetErrors(state), { forgotPassword: { state: 'wait' } });
}

function failSignIn(state) {
  return extend(state, { signIn: { state: null } });
}

function failRegister(state) {
  return extend(state, { register: { state: null } });
}

function failGoogleSignIn(state) {
  return extend(state, { common: { googleState: null } });
}

function failForgotPassword(state) {
  return extend(state, { forgotPassword: { state: null } });
}

function sentForgotPassword(state) {
  return extend(resetErrors(state), { forgotPassword: { state: 'sent' } });
}

function validateField(state, action) {
  if (action.name === 'registration.email' && state.register.username === '') {
    return extend(state, { register: { autoFillUsername: true } });
  }
  if (action.name === 'registration.username') {
    return extend(state, { register: { autoFillUsername: false } });
  }
  return state;
}

function changeField(state, action) {
  var newErrors = (0, _assign2.default)({}, state.errors);
  delete newErrors[action.name];
  action.deps.forEach(function (d) {
    return delete newErrors[d];
  });
  return (0, _assign2.default)({}, state, { errors: newErrors });
}

function setField(state, action) {
  var obj = {};
  obj[action.form] = {};
  obj[action.form][action.name] = action.value;
  if (action.form === 'signIn' && action.name === 'identification') {
    (0, _assign2.default)(obj, { forgotPassword: { identification: action.value } });
  }
  return extend(state, obj);
}

function suggestUserName(state, action) {
  if (!state.register.autoFillUsername) {
    return state;
  }
  var newErrors = (0, _assign2.default)({}, state.errors);
  delete newErrors['registration.username'];
  var newState = (0, _assign2.default)({}, state, { errors: newErrors });
  return extend(newState, { register: { username: action.username } });
}

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case constant.RESET:
      return reset(state, action);
    case constant.SET_FORM_TYPE:
      return setFormType(state, action);
    case constant.SET_USER_TYPE:
      return setUserType(state, action);
    case constant.VALIDATION_ERRORS:
      return validationErrors(state, action);
    case constant.INIT_SIGN_IN:
      return initSignIn(state, action);
    case constant.INIT_REGISTER:
      return initRegister(state, action);
    case constant.INIT_GOOGLE_SIGN_IN:
      return initGoogleSignIn(state, action);
    case constant.INIT_FORGOT_PASSWORD:
      return initForgotPassword(state, action);
    case constant.FAIL_SIGN_IN:
      return failSignIn(state, action);
    case constant.FAIL_REGISTER:
      return failRegister(state, action);
    case constant.FAIL_GOOGLE_SIGN_IN:
      return failGoogleSignIn(state, action);
    case constant.FAIL_FORGOT_PASSWORD:
      return failForgotPassword(state, action);
    case constant.SENT_FORGOT_PASSWORD:
      return sentForgotPassword(state, action);
    case constant.VALIDATE_FIELD:
      return validateField(state, action);
    case constant.CHANGE_FIELD:
      return changeField(state, action);
    case constant.SET_FIELD:
      return setField(state, action);
    case constant.RESET_ERRORS:
      return resetErrors(state, action);
    case constant.SUGGEST_USER_NAME:
      return suggestUserName(state, action);

    default:
      return state;
  }
}

});
},{"./constants":174,"async-define":8,"babel-runtime/core-js/object/assign":12,"babel-runtime/core-js/object/keys":16}],176:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.initSignIn = initSignIn;
exports.initRegister = initRegister;
exports.initGoogleSignIn = initGoogleSignIn;
exports.initForgotPassword = initForgotPassword;
exports.successSignIn = successSignIn;
exports.successForgotPassword = successForgotPassword;
exports.updateUserData = updateUserData;
exports.validateField = validateField;
exports.suggestUserName = suggestUserName;
exports.initSetFormType = initSetFormType;
exports.failSignIn = failSignIn;
exports.failRegister = failRegister;
exports.trackClickSaga = trackClickSaga;
exports.trackDisplaySaga = trackDisplaySaga;
exports.default = rootSaga;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _minijoi = require('module-tsl-error-middlewares/src/minijoi');

var _minijoi2 = _interopRequireDefault(_minijoi);

var _deniedErrorcode = require('../lib/denied-errorcode');

var _actions = require('../reducers/actions');

var actions = _interopRequireWildcard(_actions);

var _tracking = require('../lib/tracking');

var _traverseObject = require('../lib/traverse-object');

var _traverseObject2 = _interopRequireDefault(_traverseObject);

var _errorMessages = require('../../app/domain/errorMessages');

var _errorMessages2 = _interopRequireDefault(_errorMessages);

var _constants = require('../reducers/constants');

var constant = _interopRequireWildcard(_constants);

var _api = require('../lib/api');

var _api2 = _interopRequireDefault(_api);

var _utils = require('./utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [initSignIn, initRegister, initGoogleSignIn, initForgotPassword, successSignIn, successForgotPassword, updateUserData, validateField, suggestUserName, initSetFormType, failSignIn, failRegister, trackClickSaga, trackDisplaySaga, takeLatestWithName, rootSaga].map(_regenerator2.default.mark);

/*
  utilities
*/
function getWindow() {
  try {
    return window;
  } catch (e) {
    return {};
  }
}

function getErrorCode(xhr, prefix) {
  var genericErrorCode = xhr.status >= 400 && xhr.status < 500 ? 'denied' : 'generic';
  try {
    var response = JSON.parse(xhr.response || xhr.responseText);
    // assembling the error code
    var errorCodes = response.errors.map(function (e) {
      return prefix + '.' + e.field + '.' + e.types[0];
    });
    return errorCodes.length ? errorCodes.join(',') : prefix + '.' + genericErrorCode + '.error';
  } catch (e) {
    if (getWindow()._airbrake) {
      var errorObj = void 0;
      if (xhr.status === 0) {
        errorObj = { error: { message: 'app-authentication: api timing out (' + prefix + ') readystate ' + xhr.readyState, fileName: 'restapi.js', lineNumber: 0, columnNumber: 0 } };
      } else {
        errorObj = { error: { message: 'app-authentication: api returning unexpected ' + genericErrorCode + ' (' + prefix + '): ' + xhr.status + ' - ' + xhr.response, fileName: 'api.js', lineNumber: 0, columnNumber: 0 } };
      }
      getWindow()._airbrake.push(errorObj);
    }
    return prefix + '.' + genericErrorCode + '.error';
  }
}

var userNameValidation = _minijoi2.default.string().min(3).max(30).regex(/^[A-Za-z0-9_\-]*$/).required();
var emailValidation = _minijoi2.default.string().email();

var schemas = {
  registration: _minijoi2.default.object().keys({
    username: userNameValidation,
    email: emailValidation,
    password: _minijoi2.default.string().min(6).required(),
    firstName: _minijoi2.default.string(),
    lastName: _minijoi2.default.string(),
    newsletter: _minijoi2.default.boolean()
  })
};

/*
  sagas
*/
function initSignIn(action) {
  var isInline, isModal, credentials, errorCode, errors;
  return _regenerator2.default.wrap(function initSignIn$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(actions.resetErrors());

        case 2:
          _context.next = 4;
          return (0, _effects.select)(_utils.getIsInline);

        case 4:
          isInline = _context.sent;
          _context.next = 7;
          return (0, _effects.select)(_utils.getIsModal);

        case 7:
          isModal = _context.sent;

          if (!(!isInline && !isModal)) {
            _context.next = 20;
            break;
          }

          _context.prev = 9;
          _context.next = 12;
          return (0, _effects.cps)(_tracking.trackLogin, 'tes-login', (0, _tracking.getTrackingType)(isModal, isInline));

        case 12:
          _context.next = 17;
          break;

        case 14:
          _context.prev = 14;
          _context.t0 = _context['catch'](9);

          console.log('Tracking Login error', _context.t0.message); // eslint-disable-line no-console

        case 17:
          _context.next = 19;
          return (0, _effects.call)(action.callback);

        case 19:
          return _context.abrupt('return');

        case 20:
          _context.prev = 20;
          _context.next = 23;
          return (0, _effects.call)(_tracking.trackLogin, 'tes-login', (0, _tracking.getTrackingType)(isModal, isInline));

        case 23:
          _context.next = 25;
          return (0, _effects.select)(_utils.getSignInData);

        case 25:
          credentials = _context.sent;
          _context.next = 28;
          return (0, _effects.call)(_api2.default.signIn, credentials);

        case 28:
          _context.next = 30;
          return (0, _effects.put)(actions.successSignIn());

        case 30:
          _context.next = 40;
          break;

        case 32:
          _context.prev = 32;
          _context.t1 = _context['catch'](20);
          errorCode = (0, _deniedErrorcode.authDenied)(_context.t1) || getErrorCode(_context.t1, 'signin');
          errors = (0, _errorMessages2.default)(errorCode);
          _context.next = 38;
          return (0, _effects.put)(actions.validationErrors(errors));

        case 38:
          _context.next = 40;
          return (0, _effects.put)(actions.failSignIn(errors));

        case 40:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[9, 14], [20, 32]]);
}

function initRegister(action) {
  var isInline, isModal, info, errorCode, errors;
  return _regenerator2.default.wrap(function initRegister$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)(actions.resetErrors());

        case 2:
          _context2.next = 4;
          return (0, _effects.select)(_utils.getIsInline);

        case 4:
          isInline = _context2.sent;
          _context2.next = 7;
          return (0, _effects.select)(_utils.getIsModal);

        case 7:
          isModal = _context2.sent;

          if (!(!isInline && !isModal)) {
            _context2.next = 20;
            break;
          }

          _context2.prev = 9;
          _context2.next = 12;
          return (0, _effects.cps)(_tracking.trackRegister, (0, _tracking.getTrackingType)(isModal, isInline));

        case 12:
          _context2.next = 17;
          break;

        case 14:
          _context2.prev = 14;
          _context2.t0 = _context2['catch'](9);

          console.log('Tracking Registration error', _context2.t0.message); // eslint-disable-line no-console

        case 17:
          _context2.next = 19;
          return (0, _effects.call)(action.callback);

        case 19:
          return _context2.abrupt('return');

        case 20:
          _context2.prev = 20;
          _context2.next = 23;
          return (0, _effects.call)(_tracking.trackRegister, (0, _tracking.getTrackingType)(isModal, isInline));

        case 23:
          _context2.next = 25;
          return (0, _effects.select)(_utils.getRegistrationData);

        case 25:
          info = _context2.sent;
          _context2.next = 28;
          return (0, _effects.call)(_api2.default.register, info);

        case 28:
          _context2.next = 30;
          return (0, _effects.put)(actions.successRegister());

        case 30:
          _context2.next = 40;
          break;

        case 32:
          _context2.prev = 32;
          _context2.t1 = _context2['catch'](20);
          errorCode = getErrorCode(_context2.t1, 'registration');
          errors = (0, _errorMessages2.default)(errorCode);
          _context2.next = 38;
          return (0, _effects.put)(actions.validationErrors(errors));

        case 38:
          _context2.next = 40;
          return (0, _effects.put)(actions.failRegister(errors));

        case 40:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[9, 14], [20, 32]]);
}

function initGoogleSignIn() {
  var isInline, isModal, info, errorCode, errors;
  return _regenerator2.default.wrap(function initGoogleSignIn$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.put)(actions.resetErrors());

        case 3:
          _context3.next = 5;
          return (0, _effects.select)(_utils.getIsInline);

        case 5:
          isInline = _context3.sent;
          _context3.next = 8;
          return (0, _effects.select)(_utils.getIsModal);

        case 8:
          isModal = _context3.sent;
          _context3.next = 11;
          return (0, _effects.select)(_utils.getGoogleSignInData);

        case 11:
          info = _context3.sent;

          if (!(!isModal && !isInline)) {
            _context3.next = 24;
            break;
          }

          _context3.prev = 13;
          _context3.next = 16;
          return (0, _effects.cps)(_tracking.trackLogin, 'google-login', (0, _tracking.getTrackingType)(isModal, isInline));

        case 16:
          _context3.next = 21;
          break;

        case 18:
          _context3.prev = 18;
          _context3.t0 = _context3['catch'](13);

          console.log('Tracking Google Login error', _context3.t0.message); // eslint-disable-line no-console

        case 21:
          _context3.next = 23;
          return (0, _effects.call)(_api2.default.googleSignIn, info);

        case 23:
          return _context3.abrupt('return');

        case 24:
          _context3.next = 26;
          return (0, _effects.call)(_tracking.trackLogin, 'google-login', (0, _tracking.getTrackingType)(isModal, isInline));

        case 26:
          _context3.next = 28;
          return (0, _effects.call)(_api2.default.googleSignIn, info);

        case 28:
          _context3.next = 30;
          return (0, _effects.put)(actions.successGoogleSignIn());

        case 30:
          _context3.next = 40;
          break;

        case 32:
          _context3.prev = 32;
          _context3.t1 = _context3['catch'](0);
          errorCode = _context3.t1.message;
          errors = (0, _errorMessages2.default)(errorCode);
          _context3.next = 38;
          return (0, _effects.put)(actions.validationErrors(errors));

        case 38:
          _context3.next = 40;
          return (0, _effects.put)(actions.failGoogleSignIn(errors));

        case 40:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[0, 32], [13, 18]]);
}

function initForgotPassword() {
  var isInline, isModal, info, errorCode, errors;
  return _regenerator2.default.wrap(function initForgotPassword$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)(actions.resetErrors());

        case 2:
          _context4.next = 4;
          return (0, _effects.select)(_utils.getIsInline);

        case 4:
          isInline = _context4.sent;
          _context4.next = 7;
          return (0, _effects.select)(_utils.getIsModal);

        case 7:
          isModal = _context4.sent;
          _context4.prev = 8;
          _context4.next = 11;
          return (0, _effects.cps)(_tracking.trackForgotPassword, (0, _tracking.getTrackingType)(isModal, isInline));

        case 11:
          _context4.next = 16;
          break;

        case 13:
          _context4.prev = 13;
          _context4.t0 = _context4['catch'](8);

          console.log('Tracking forgot password error', _context4.t0.message); // eslint-disable-line no-console

        case 16:
          _context4.prev = 16;
          _context4.next = 19;
          return (0, _effects.select)(_utils.getForgotPasswordData);

        case 19:
          info = _context4.sent;
          _context4.next = 22;
          return (0, _effects.call)(_api2.default.forgotPassword, info);

        case 22:
          _context4.next = 24;
          return (0, _effects.put)(actions.sentForgotPassword());

        case 24:
          _context4.next = 26;
          return (0, _effects.put)(actions.setField('forgotPassword', 'identification', ''));

        case 26:
          _context4.next = 36;
          break;

        case 28:
          _context4.prev = 28;
          _context4.t1 = _context4['catch'](16);
          errorCode = (0, _deniedErrorcode.forgotPasswordDenied)(_context4.t1) || getErrorCode(_context4.t1, 'forgot-password');
          errors = (0, _errorMessages2.default)(errorCode);
          _context4.next = 34;
          return (0, _effects.put)(actions.validationErrors(errors));

        case 34:
          _context4.next = 36;
          return (0, _effects.put)(actions.failForgotPassword(errors));

        case 36:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[8, 13], [16, 28]]);
}

function successSignIn() {
  var onSuccess;
  return _regenerator2.default.wrap(function successSignIn$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.select)(_utils.getOnSuccess);

        case 2:
          onSuccess = _context5.sent;

          if (!(onSuccess === 'reload')) {
            _context5.next = 8;
            break;
          }

          _context5.next = 6;
          return (0, _effects.call)(_api2.default.reload);

        case 6:
          _context5.next = 16;
          break;

        case 8:
          _context5.next = 10;
          return (0, _effects.call)(_api2.default.closeModalEvent);

        case 10:
          _context5.next = 12;
          return (0, _effects.call)(_api2.default.loggedInEvent);

        case 12:
          _context5.next = 14;
          return (0, _effects.call)(_reduxSaga.delay, 200);

        case 14:
          _context5.next = 16;
          return (0, _effects.put)(actions.reset());

        case 16:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function successForgotPassword() {
  return _regenerator2.default.wrap(function successForgotPassword$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)(actions.setField('forgotPassword', 'identification', ''));

        case 2:
          _context6.next = 4;
          return (0, _effects.call)(_api2.default.closeModalEvent);

        case 4:
          _context6.next = 6;
          return (0, _effects.call)(_reduxSaga.delay, 200);

        case 6:
          _context6.next = 8;
          return (0, _effects.put)(actions.reset());

        case 8:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}

function updateUserData(action) {
  var errorCode;
  return _regenerator2.default.wrap(function updateUserData$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.call)(_api2.default.updateUserData, action.data);

        case 3:
          _context7.next = 5;
          return (0, _effects.put)(actions.successSignIn());

        case 5:
          _context7.next = 12;
          break;

        case 7:
          _context7.prev = 7;
          _context7.t0 = _context7['catch'](0);
          errorCode = getErrorCode(_context7.t0, 'edit-account');
          _context7.next = 12;
          return (0, _effects.put)(actions.validationErrors((0, _errorMessages2.default)(errorCode)));

        case 12:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[0, 7]]);
}

function validateField(action) {
  var _this = this;

  var userData, response, _response, _ret;

  return _regenerator2.default.wrap(function validateField$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.call)(_reduxSaga.delay, 1200);

        case 2:
          _context9.next = 4;
          return (0, _effects.select)(_utils.getRegistrationData);

        case 4:
          userData = _context9.sent;

          if (!(action.name === 'registration.username' && userData.username && !_minijoi2.default.validate(userData.username, userNameValidation).error)) {
            _context9.next = 14;
            break;
          }

          _context9.next = 8;
          return (0, _effects.call)(_api2.default.verifyUsername, userData.username);

        case 8:
          response = _context9.sent;

          if (!response.length) {
            _context9.next = 12;
            break;
          }

          _context9.next = 12;
          return (0, _effects.put)(actions.validationErrors((0, _errorMessages2.default)('registration.username.duplicate')));

        case 12:
          _context9.next = 30;
          break;

        case 14:
          if (!(action.name === 'registration.email' && userData.email && !_minijoi2.default.validate(userData.email, emailValidation).error)) {
            _context9.next = 26;
            break;
          }

          _context9.next = 17;
          return (0, _effects.call)(_api2.default.verifyEmail, userData.email);

        case 17:
          _response = _context9.sent;

          if (!_response.length) {
            _context9.next = 21;
            break;
          }

          _context9.next = 21;
          return (0, _effects.put)(actions.validationErrors((0, _errorMessages2.default)('registration.email.duplicate')));

        case 21:
          if (!_response.suggestedUsername) {
            _context9.next = 24;
            break;
          }

          _context9.next = 24;
          return (0, _effects.put)(actions.suggestUserName(_response.suggestedUsername));

        case 24:
          _context9.next = 30;
          break;

        case 26:
          return _context9.delegateYield(_regenerator2.default.mark(function _callee() {
            var _action$name$split, _action$name$split2, form, fieldName, schema, outcome, errorCode;

            return _regenerator2.default.wrap(function _callee$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    _action$name$split = action.name.split('.');
                    _action$name$split2 = (0, _slicedToArray3.default)(_action$name$split, 2);
                    form = _action$name$split2[0];
                    fieldName = _action$name$split2[1];

                    if (form in schemas) {
                      _context8.next = 6;
                      break;
                    }

                    return _context8.abrupt('return', {
                      v: void 0
                    });

                  case 6:
                    schema = schemas[form];
                    outcome = _minijoi2.default.validate(userData, schema, { abortEarly: false });

                    if (outcome.error) {
                      _context8.next = 10;
                      break;
                    }

                    return _context8.abrupt('return', {
                      v: void 0
                    });

                  case 10:
                    errorCode = outcome.error.details.filter(function (e) {
                      return e.path === fieldName;
                    }).map(function (e) {
                      return form + '.' + e.path + '.' + e.type;
                    }).join(',');

                    if (!errorCode.length) {
                      _context8.next = 14;
                      break;
                    }

                    _context8.next = 14;
                    return (0, _effects.put)(actions.validationErrors((0, _errorMessages2.default)(errorCode)));

                  case 14:
                  case 'end':
                    return _context8.stop();
                }
              }
            }, _callee, _this);
          })(), 't0', 27);

        case 27:
          _ret = _context9.t0;

          if (!((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object")) {
            _context9.next = 30;
            break;
          }

          return _context9.abrupt('return', _ret.v);

        case 30:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[7], this);
}

function suggestUserName() {
  var userData, response;
  return _regenerator2.default.wrap(function suggestUserName$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.select)(_utils.getRegistrationData);

        case 2:
          userData = _context10.sent;

          if (!(userData.email && !_minijoi2.default.validate(userData.email, emailValidation).error)) {
            _context10.next = 10;
            break;
          }

          _context10.next = 6;
          return (0, _effects.call)(_api2.default.verifyEmail, userData.email);

        case 6:
          response = _context10.sent;

          if (!response.suggestedUsername) {
            _context10.next = 10;
            break;
          }

          _context10.next = 10;
          return (0, _effects.put)(actions.suggestUserName(response.suggestedUsername));

        case 10:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[8], this);
}

function initSetFormType(action) {
  var isInline, isModal, oldFormType;
  return _regenerator2.default.wrap(function initSetFormType$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.select)(_utils.getIsInline);

        case 2:
          isInline = _context11.sent;
          _context11.next = 5;
          return (0, _effects.select)(_utils.getIsModal);

        case 5:
          isModal = _context11.sent;

          if (!(!isModal && !isInline)) {
            _context11.next = 8;
            break;
          }

          return _context11.abrupt('return');

        case 8:
          _context11.next = 10;
          return (0, _effects.select)(_utils.getFormType);

        case 10:
          oldFormType = _context11.sent;

          if (!(oldFormType === action.formType)) {
            _context11.next = 13;
            break;
          }

          return _context11.abrupt('return');

        case 13:
          _context11.next = 15;
          return (0, _effects.put)(actions.setFormType(action.formType));

        case 15:
          _context11.next = 17;
          return (0, _effects.put)(actions.trackClick(action.formType));

        case 17:
          _context11.next = 19;
          return (0, _effects.put)(actions.trackDisplay(action.formType));

        case 19:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[9], this);
}

function failSignIn(action) {
  var filteredErrors, msg, id, isInline, isModal;
  return _regenerator2.default.wrap(function failSignIn$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          if (action.errors) {
            _context12.next = 2;
            break;
          }

          return _context12.abrupt('return');

        case 2:
          filteredErrors = (0, _keys2.default)(action.errors).filter(function (e) {
            return e.startsWith('signin.') || e.startsWith('generic.googlebutton');
          });

          if (!filteredErrors.length) {
            _context12.next = 14;
            break;
          }

          msg = (0, _traverseObject2.default)(action.errors[filteredErrors[0]], 'msg') || 'unknown error';
          id = filteredErrors[0] === 'generic.googlebutton' ? 'google-login-fail' : 'login-fail';
          _context12.next = 8;
          return (0, _effects.select)(_utils.getIsInline);

        case 8:
          isInline = _context12.sent;
          _context12.next = 11;
          return (0, _effects.select)(_utils.getIsModal);

        case 11:
          isModal = _context12.sent;
          _context12.next = 14;
          return (0, _effects.call)(_tracking.trackError, id, msg, (0, _tracking.getTrackingType)(isModal, isInline));

        case 14:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[10], this);
}

function failRegister(action) {
  var filteredErrors, msg, isInline, isModal;
  return _regenerator2.default.wrap(function failRegister$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          if (action.errors) {
            _context13.next = 2;
            break;
          }

          return _context13.abrupt('return');

        case 2:
          filteredErrors = (0, _keys2.default)(action.errors).filter(function (e) {
            return e.startsWith('registration.');
          });

          if (!filteredErrors.length) {
            _context13.next = 13;
            break;
          }

          msg = (0, _traverseObject2.default)(action.errors[filteredErrors[0]], 'msg') || 'unknown error';
          _context13.next = 7;
          return (0, _effects.select)(_utils.getIsInline);

        case 7:
          isInline = _context13.sent;
          _context13.next = 10;
          return (0, _effects.select)(_utils.getIsModal);

        case 10:
          isModal = _context13.sent;
          _context13.next = 13;
          return (0, _effects.call)(_tracking.trackError, 'register-fail', msg, (0, _tracking.getTrackingType)(isModal, isInline));

        case 13:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[11], this);
}

function trackClickSaga(action) {
  return _regenerator2.default.wrap(function trackClickSaga$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.call)(_tracking.trackClick, action.formType);

        case 2:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[12], this);
}

function trackDisplaySaga(action) {
  var isInline, isModal, userType;
  return _regenerator2.default.wrap(function trackDisplaySaga$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.select)(_utils.getIsInline);

        case 2:
          isInline = _context15.sent;
          _context15.next = 5;
          return (0, _effects.select)(_utils.getIsModal);

        case 5:
          isModal = _context15.sent;
          _context15.next = 8;
          return (0, _effects.select)(_utils.getUserType);

        case 8:
          userType = _context15.sent;

          if (isInline) {
            _context15.next = 12;
            break;
          }

          _context15.next = 12;
          return (0, _effects.call)(_tracking.trackDisplay, action.formType, (0, _tracking.getTrackingType)(isModal, isInline), userType);

        case 12:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[13], this);
}

function takeLatestWithName(pattern, saga) {
  var task;
  return _regenerator2.default.wrap(function takeLatestWithName$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.fork)(_regenerator2.default.mark(function newSaga() {
            var lastTask, action;
            return _regenerator2.default.wrap(function newSaga$(_context16) {
              while (1) {
                switch (_context16.prev = _context16.next) {
                  case 0:
                    lastTask = {};

                  case 1:
                    if (!true) {
                      _context16.next = 13;
                      break;
                    }

                    _context16.next = 4;
                    return (0, _effects.take)(pattern);

                  case 4:
                    action = _context16.sent;

                    if (!(action.name in lastTask)) {
                      _context16.next = 8;
                      break;
                    }

                    _context16.next = 8;
                    return (0, _effects.cancel)(lastTask[action.name]);

                  case 8:
                    _context16.next = 10;
                    return (0, _effects.fork)(saga, action);

                  case 10:
                    lastTask[action.name] = _context16.sent;
                    _context16.next = 1;
                    break;

                  case 13:
                  case 'end':
                    return _context16.stop();
                }
              }
            }, newSaga, this);
          }));

        case 2:
          task = _context17.sent;
          return _context17.abrupt('return', task);

        case 4:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[14], this);
}

function isEmail(action) {
  return action.type === constant.VALIDATE_FIELD && action.name === 'registration.email';
}

function rootSaga() {
  return _regenerator2.default.wrap(function rootSaga$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return [(0, _reduxSaga.takeEvery)(constant.INIT_SIGN_IN, initSignIn), (0, _reduxSaga.takeEvery)(constant.INIT_REGISTER, initRegister), (0, _reduxSaga.takeEvery)(constant.INIT_GOOGLE_SIGN_IN, initGoogleSignIn), (0, _reduxSaga.takeEvery)(constant.INIT_FORGOT_PASSWORD, initForgotPassword), (0, _reduxSaga.takeEvery)(constant.SUCCESS_GOOGLE_SIGN_IN, successSignIn), (0, _reduxSaga.takeEvery)(constant.SUCCESS_SIGN_IN, successSignIn), (0, _reduxSaga.takeEvery)(constant.SUCCESS_REGISTER, successSignIn), (0, _reduxSaga.takeEvery)(constant.SUCCESS_FORGOT_PASSWORD, successForgotPassword), (0, _reduxSaga.takeEvery)(constant.UPDATE_USER_DATA, updateUserData), (0, _reduxSaga.takeEvery)(constant.INIT_SET_FORM_TYPE, initSetFormType), (0, _reduxSaga.takeEvery)(constant.FAIL_SIGN_IN, failSignIn), (0, _reduxSaga.takeEvery)(constant.FAIL_GOOGLE_SIGN_IN, failSignIn), (0, _reduxSaga.takeEvery)(constant.FAIL_REGISTER, failRegister), (0, _reduxSaga.takeEvery)(constant.TRACK_CLICK, trackClickSaga), (0, _reduxSaga.takeEvery)(constant.TRACK_DISPLAY, trackDisplaySaga), takeLatestWithName(constant.VALIDATE_FIELD, validateField), (0, _reduxSaga.throttle)(800, isEmail, suggestUserName)];

        case 2:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked[15], this);
}

});
},{"../../app/domain/errorMessages":156,"../lib/api":168,"../lib/denied-errorcode":169,"../lib/tracking":171,"../lib/traverse-object":172,"../reducers/actions":173,"../reducers/constants":174,"./utils":177,"async-define":8,"babel-runtime/core-js/object/keys":16,"babel-runtime/helpers/slicedToArray":25,"babel-runtime/helpers/typeof":26,"babel-runtime/regenerator":27,"module-tsl-error-middlewares/src/minijoi":137,"redux-saga":141,"redux-saga/effects":139}],177:[function(require,module,exports){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOnSuccess = getOnSuccess;
exports.getFormType = getFormType;
exports.getIsInline = getIsInline;
exports.getIsModal = getIsModal;
exports.getUserType = getUserType;
exports.getForgotPasswordData = getForgotPasswordData;
exports.getSignInData = getSignInData;
exports.getRegistrationData = getRegistrationData;
exports.getGoogleSignInData = getGoogleSignInData;

var _tracking = require('../lib/tracking');

function getOnSuccess(state) {
  return state.common.onSuccess;
}

function getFormType(state) {
  return state.common.formType;
}

function getIsInline(state) {
  return state.common.isInline;
}

function getIsModal(state) {
  return state.common.isModal;
}

function getUserType(state) {
  return state.common.userType;
}

function getForgotPasswordData(state) {
  return { email: state.forgotPassword.identification };
}

function getSignInData(state) {
  var common = state.common;
  var signIn = state.signIn;
  var pageContext = (0, _tracking.getPageContext)(common.pageMz, common.overrideMz);

  var identification = signIn.identification;
  var password = signIn.password;
  var trustedComputer = signIn.trustedComputer;
  var appId = common.appId;

  var pageId = pageContext.pageId;
  var pageType = pageContext.pageType;
  var pageSection = pageContext.pageSection;
  var pageSubSection = pageContext.pageSubSection;

  var data = {
    appId: appId,
    identification: identification,
    password: password,
    trustedComputer: trustedComputer,
    pageId: pageId,
    pageType: pageType,
    pageSection: pageSection,
    pageSubSection: pageSubSection
  };

  return data;
}

function getRegistrationData(state) {
  var common = state.common;
  var register = state.register;
  var pageContext = (0, _tracking.getPageContext)(common.pageMz, common.overrideMz);

  var isModal = common.isModal;
  var isInline = common.isInline;
  var isStudent = common.userType === 'student';

  var pageId = pageContext.pageId;
  var pageType = pageContext.pageType;
  var pageSection = pageContext.pageSection;
  var pageSubSection = pageContext.pageSubSection;

  var data = {
    username: register.username,
    email: register.email || '',
    password: register.password,
    userType: common.userType || null,
    newsletter: isStudent ? false : register.newsletter,
    regUrl: !isModal && !isInline ? common.rtn : window && window.location.href,
    pageId: pageId,
    pageType: pageType,
    pageSection: pageSection,
    pageSubSection: pageSubSection,
    appId: common.appId
  };

  if (!common.omitName) {
    data.firstName = register.firstName;
    data.lastName = register.lastName;
  }

  return data;
}

function getGoogleSignInData(state) {
  var common = state.common;
  var register = state.register;
  var pageContext = (0, _tracking.getPageContext)(common.pageMz, common.overrideMz);

  var isStudent = common.userType === 'student';
  var isModal = common.isModal;
  var isInline = common.isInline;

  var pageId = pageContext.pageId;
  var pageType = pageContext.pageType;
  var pageSection = pageContext.pageSection;
  var pageSubSection = pageContext.pageSubSection;
  var regUrl = void 0;
  if (common.regUrl) {
    regUrl = common.regUrl;
  } else if (!isModal && !isInline) {
    regUrl = common.rtn;
  } else {
    regUrl = window && window.location.href;
  }

  var data = {
    isModal: isModal || isInline,
    userType: common.userType,
    newsletter: isStudent ? false : register.newsletter,
    regUrl: regUrl,
    appId: common.appId,
    pageId: pageId,
    pageType: pageType,
    pageSection: pageSection,
    pageSubSection: pageSubSection,
    rtn: isModal || isInline ? '/oauth/close-modal' : common.rtn || window.location.href
  };
  return data;
}

});
},{"../lib/tracking":171,"async-define":8}],178:[function(require,module,exports){
(function (process){
var asyncDefine = require('async-define');
asyncDefine(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function (__react,__react_dom,__redux,__react_redux){
'use strict';

require('ima.js-babel6-polyfill');

var _es6ObjectAssign = require('es6-object-assign');

var _es6ObjectAssign2 = _interopRequireDefault(_es6ObjectAssign);

require('string.prototype.startswith');

var _reduxSaga = require('redux-saga');

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _reactDom = __react_dom;

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __react_redux;

var _redux = __redux;

var _reducers = require('../reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _App = require('../components/App');

var _App2 = _interopRequireDefault(_App);

var _sagas = require('../sagas');

var _sagas2 = _interopRequireDefault(_sagas);

var _actions = require('../reducers/actions');

var actions = _interopRequireWildcard(_actions);

var _utils = require('../sagas/utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var events = window.TES.events; // polyfills


_es6ObjectAssign2.default.polyfill();

process.env.BROWSER = true;

var mountPointCls = 'app-auth-mountpoint';
var mountPoint = '.' + mountPointCls;

var bootstrap = function bootstrap() {
  var sagaMiddleware = (0, _reduxSaga2.default)();

  var mountElement = document.querySelector(mountPoint);
  mountElement.className = mountPointCls + '-loaded';
  var initialState = JSON.parse(mountElement.getAttribute('data-init-state'));

  var enhancer = (0, _redux.compose)((0, _redux.applyMiddleware)(sagaMiddleware));

  var store = (0, _redux.createStore)(_reducers2.default, initialState, enhancer);
  // then run the saga
  sagaMiddleware.run(_sagas2.default);

  var app = _react2.default.createElement(_App2.default);
  var provider = _react2.default.createElement(_reactRedux.Provider, { store: store }, app);

  _reactDom2.default.render(provider, mountElement);

  events.on('modal-switch', function (eventType, data) {
    if (data.appId === 'authapp') {
      store.dispatch(actions.initSetFormType(data.msg));
    }
  });
  // // this sends an event only when I am NOT changing the form type
  events.on(/modal-(switch|init)/, function (eventType, data) {
    var form = data.msg;
    if (data.appId === 'authapp' && form === (0, _utils.getFormType)(store.getState())) {
      store.dispatch(actions.trackClick(form));
    }
  });
};

if (document.querySelector(mountPoint)) {
  bootstrap(); // page init
} else {
  events.one('modal-init', bootstrap); // modal init
}

});
}).call(this,require('_process'))

},{"../components/App":157,"../reducers":175,"../reducers/actions":173,"../sagas":176,"../sagas/utils":177,"_process":138,"async-define":8,"es6-object-assign":129,"ima.js-babel6-polyfill":134,"redux-saga":141,"string.prototype.startswith":155}]},{},[178])
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
